/*! huya-kiwi Version: v1.10.11 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var AllApi = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get HYGift () { return HYGift; },
    get HYLive () { return HYLive; },
    get HYLivingRoomActivity () { return HYLivingRoomActivity; },
    get HYRouter () { return HYRouter; },
    get HYReport () { return HYReport; },
    get HYUserInfo () { return HYUserInfo; },
    get HYLogin () { return HYLogin; },
    get loginSuccess () { return loginSuccess; },
    get loginFailed () { return loginFailed; },
    get kickOff () { return kickOff; },
    get HYDevice () { return HYDevice; },
    get HYPortraitActivity () { return HYPortraitActivity; },
    get HYLandscapeActivity () { return HYLandscapeActivity; },
    get HYNativeEventCenter () { return HYNativeEventCenter; },
    get HYEventCenter () { return OldEventCenter; },
    get HYCache () { return HYCache; },
    get HYDiskConfig () { return HYDiskConfig; },
    get HYTipOff () { return HYTipOff; },
    get HYSubscribe () { return HYSubscribe; },
    get HYFeedBack () { return HYFeedBack; },
    get HYDownload () { return HYDownload; },
    get HYShare () { return HYShare; },
    get HYToast () { return HYToast; },
    get HYLog () { return HYLog; },
    get HYDataCenter () { return hyDataCenter; },
    get NativeModules () { return nativeModules; },
    get Utils () { return Utils; },
    get Browser () { return Browser; },
    get generateCommonAPI () { return generateCommonAPI; },
    get kKWJSSdkEventIdApp () { return kKWJSSdkEventIdApp; },
    get installApkEventChanged () { return installApkEventChanged; },
    get activityWindowSizeChanged () { return activityWindowSizeChanged; },
    get willResignActive () { return willResignActive; },
    get didBecomeActive () { return didBecomeActive; },
    get networkChanged () { return networkChanged; },
    get screenRecordChanged () { return screenRecordChanged; },
    get PlatformCompat () { return PlatformCompat; },
    get CrossDomain () { return index; },
    get HUYASdk () { return HUYASdk; },
    get HYAAID () { return HYAAID; },
    get HYAd () { return HYAd; },
    get HYAdReport () { return HYAdReport; },
    get audioRecordEnd () { return audioRecordEnd; },
    get HYAudioRecord () { return HYAudioRecord; },
    get HYAuth () { return HYAuth; },
    get HYAuthorization () { return HYAuthorization; },
    get HYCommodity () { return HYCommodity; },
    get HYDynamicConfig () { return HYDynamicConfig; },
    get HYFreeFlow () { return HYFreeFlow; },
    get HYInteraction () { return HYInteraction; },
    get HYLiveFilmVip () { return HYLiveFilmVip; },
    get HYLiveTreasureBox () { return HYLiveTreasureBox; },
    get HYNestedScroll () { return HYNestedScroll; },
    get HYPanel () { return HYPanel; },
    get HYPay () { return HYPay; },
    get HYPlayer () { return HYPlayer; },
    get HYSaveInAlbum () { return HYSaveInAlbum; },
    get TAP_BACK () { return TAP_BACK; },
    get HYSettingBack () { return HYSettingBack; },
    get HYSettingsData () { return HYSettingsData; },
    get HYStatistic () { return HYStatistic; },
    get HYSuperFans () { return HYSuperFans; },
    get HYTeamMedal () { return HYTeamMedal; },
    get HYThirdCall () { return HYThirdCall; },
    get HYUdb () { return HYUdb; },
    get HYUI () { return HYUI; },
    get HYWebCalendar () { return HYWebCalendar; },
    get HYWebGameReserve () { return HYWebGameReserve; },
    get HYWebPersonal () { return HYWebPersonal; },
    get HYWebShortcut () { return HYWebShortcut; },
    get HYWebView () { return HYWebView; },
    get onAppear () { return onAppear; },
    get onDisappear () { return onDisappear; },
    get HYWebViewLifeCycle () { return HYWebViewLifeCycle; },
    get HYWup () { return HYWup; },
    get transmit () { return transmit; },
    get transmitWup () { return transmitWup; },
    get HYYouth () { return HYYouth; },
    get HYBusinessWidget () { return HYBusinessWidget; },
    get HYWebAccompanyMsgFloatBall () { return HYWebAccompanyMsgFloatBall; },
    get HYPCAnchor () { return HYPCAnchor; },
    get HYPCLive () { return HYPCLive; }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var isHarmonyOSMobile$1 = /Harmony/i.test(navigator.userAgent) && /Mobile|Tablet/i.test(navigator.userAgent);
var isMobile$1 = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) || isHarmonyOSMobile$1;
var hasHUYAKeyWord = navigator.userAgent.trim().split(" ").includes('huya');
var isHUYAApp = isMobile$1 && hasHUYAKeyWord;
var Browser = {
  versions: function () {
    var u = navigator.userAgent;
    return {
      trident: u.indexOf('Trident') > -1,
      webKit: u.indexOf('AppleWebKit') > -1,
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
      mobile: isMobile$1,
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
      iPhone: u.indexOf('iPhone') > -1,
      iPad: u.indexOf('iPad') > -1,
      webApp: u.indexOf('Safari') == -1,
      weixin: u.indexOf('MicroMessenger') > -1,
      qq: u.match(/\sQQ/i) == ' qq',
      pcAnchor: /pc_exe_template/i.test(u),
      pcLive: /huya-pc/i.test(u),
      zsApp: /huya-zs/i.test(u.toLowerCase()),
      harmonyOSMobile: isHarmonyOSMobile$1,
      huyaApp: isHUYAApp
    };
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};

function _base64ToBlob(base64) {
  var buffer = _base64ToArrayBuffer(base64);
  return new Blob([buffer]);
}
function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}
function _arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
function _getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function _shallowExtend(dest, source) {
  for (var property in source) {
    if (source.hasOwnProperty(property)) {
      dest[property] = source[property];
    }
  }
}
function _versionCompare(version1, version2) {
  version1 = version1 || '0.0.0';
  version2 = version2 || '0.0.0';
  if (version1 == version2) return 0;
  var verArr1 = version1.split('.');
  var verArr2 = version2.split('.');
  var len = Math.max(verArr1.length, verArr2.length);
  for (var i = 0; i < len; i++) {
    var ver1 = parseInt(verArr1[i]);
    var ver2 = parseInt(verArr2[i]);
    if (ver1 > ver2) {
      return 1;
    } else if (ver1 < ver2) {
      return -1;
    }
  }
  return 0;
}
function parseJSON(thing) {
  if (typeof thing !== 'string') return thing;
  try {
    return JSON.parse(thing);
  } catch (e) {
    return thing;
  }
}
function parseJSONForNewPC(thing) {
  if (typeof thing !== 'string') return thing;
  try {
    var jsonStr = thing == 'string' ? thing.replace(/\\\\u([\da-f]{4})/gi, function (_match, grp) {
      return String.fromCharCode(parseInt(grp, 16));
    }) : thing;
    return JSON.parse(jsonStr);
  } catch (err) {
    return thing;
  }
}
var Utils = {
  parseJSON: parseJSON,
  parseJSONForNewPC: parseJSONForNewPC,
  arrayBufferToBase64: _arrayBufferToBase64,
  base64ToArrayBuffer: _base64ToArrayBuffer,
  base64ToBlob: _base64ToBlob,
  getParameterByName: _getParameterByName,
  shallowExtend: _shallowExtend,
  versionCompare: _versionCompare,
  appendQueryString: function appendQueryString(url, obj) {
    url = url ? url : '';
    for (var key in obj) {
      if (obj[key]) {
        url += '&' + key + '=' + obj[key];
      }
    }
    return url;
  }
};

var _global =
      typeof window !== 'undefined' ?
        window :
        typeof global !== 'undefined' ?
          global :
          typeof self !== 'undefined' ?
            self :
            {};

    _global.SENTRY_RELEASE={id:"1.10.11"};

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var getBridge$1 = function getBridge() {
  try {
    if (window.top && window.self != window.top && window.top.KiwiJSBridge) {
      return window.top.KiwiJSBridge;
    } else {
      return window.KiwiJSBridge;
    }
  } catch (e) {
    return window.KiwiJSBridge;
  }
};

function formatResForPC(res) {
  if (window.__disableFormatResForPC__) return res;
  if (Browser.versions.pcAnchor) {
    res = Utils.parseJSON(res);
  } else if (Browser.versions.pcLive) {
    res = Utils.parseJSONForNewPC(res);
  }
  return res;
}
var MessageQueue = function () {
  function MessageQueue() {
    _classCallCheck(this, MessageQueue);
    this._messageQueue = [];
  }
  _createClass(MessageQueue, [{
    key: "messageQueue",
    value: function messageQueue() {
      return this._messageQueue;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._messageQueue = [];
    }
  }, {
    key: "pushCallMsg",
    value: function pushCallMsg(moduleName, func, options, params) {
      this._messageQueue.push({
        type: 'call',
        module: moduleName,
        func: func,
        options: options,
        params: params
      });
    }
  }, {
    key: "pushOnMsg",
    value: function pushOnMsg(moduleName, eventId, params, callback) {
      this._messageQueue.push({
        type: 'on',
        module: moduleName,
        eventId: eventId,
        params: params,
        callback: callback
      });
    }
  }, {
    key: "pushOffMsg",
    value: function pushOffMsg(moduleName, eventId, params, callback) {
      this._messageQueue.push({
        type: 'off',
        module: moduleName,
        eventId: eventId,
        params: params,
        callback: callback
      });
    }
  }]);
  return MessageQueue;
}();
var NativeBridge = function () {
  function NativeBridge() {
    _classCallCheck(this, NativeBridge);
    this._messageQueue = new MessageQueue();
  }
  _createClass(NativeBridge, [{
    key: "invoke",
    value: function invoke(func, options, params) {
      options.usePostMessageByDefault = true;
      options.useProcolByDefault = false;
      options.useContextByDefault = false;
      if (getBridge$1()) {
        getBridge$1().call(func, options, function (resp) {
          this.handleResponse(func, resp, params);
        }.bind(this));
      } else {
        this._messageQueue.pushCallMsg(undefined, func, options, params);
      }
    }
  }, {
    key: "on",
    value: function on(eventId, params, callback) {
      if (getBridge$1()) {
        getBridge$1().on(eventId, params, callback);
      } else {
        this._messageQueue.pushOnMsg(undefined, eventId, params, callback);
      }
    }
  }, {
    key: "off",
    value: function off(eventId, params, callback) {
      if (getBridge$1()) {
        getBridge$1().off(eventId, params, callback);
      } else {
        this._messageQueue.pushOffMsg(undefined, eventId, params, callback);
      }
    }
  }, {
    key: "invokeWithModule",
    value: function invokeWithModule(moduleName, methodName, params, callback) {
      if (getBridge$1()) {
        getBridge$1().callWithModule(moduleName, methodName, params, callback);
      } else {
        this._messageQueue.pushCallMsg(moduleName, methodName, params, {
          callback: callback
        });
      }
    }
  }, {
    key: "invokeWithModuleSync",
    value: function invokeWithModuleSync(moduleName, methodName, params) {
      if (getBridge$1()) {
        return getBridge$1().callWithModuleSync(moduleName, methodName, params);
      }
      return {
        errorCode: -1,
        data: 'bridge is not inject.'
      };
    }
  }, {
    key: "onWithModule",
    value: function onWithModule(moduleName, eventId, params, callback) {
      if (getBridge$1()) {
        getBridge$1().onWithModule(moduleName, eventId, params, callback);
      } else {
        this._messageQueue.pushOnMsg(moduleName, eventId, params, callback);
      }
    }
  }, {
    key: "offWithModule",
    value: function offWithModule(moduleName, eventId, params, callback) {
      if (getBridge$1()) {
        getBridge$1().offWithModule(moduleName, eventId, params, callback);
      } else {
        this._messageQueue.pushOffMsg(moduleName, eventId, params, callback);
      }
    }
  }, {
    key: "handleQueuedMessage",
    value: function handleQueuedMessage() {
      var _this = this;
      var messageQueue = this._messageQueue.messageQueue();
      messageQueue.forEach(function (msg) {
        if (msg.type === 'call') {
          if (msg.module) {
            getBridge$1().callWithModule(msg.module, msg.func, msg.options, msg.params.callback);
          } else {
            getBridge$1().call(msg.func, msg.options, function (resp) {
              this.handleResponse(msg.func, resp, msg.params);
            }.bind(_this));
          }
        } else if (msg.type === 'on') {
          if (msg.module) {
            getBridge$1().onWithModule(msg.module, msg.eventId, msg.params, msg.callback);
          } else {
            getBridge$1().on(msg.eventId, msg.params, msg.callback);
          }
        } else if (msg.type === 'off') {
          if (msg.module) {
            getBridge$1().offWithModule(msg.moduleName, msg.eventId, msg.params, msg.callback);
          } else {
            getBridge$1().off(msg.eventId, msg.params, msg.callback);
          }
        }
      });
      this._messageQueue.clear();
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(func, resp, params) {
      if (!params) return;
      resp = formatResForPC(resp);
      if (Browser.versions.android && (!getBridge$1() || !getBridge$1().isNewBridge)) {
        if (resp.udbToken && resp.udbToken.length) {
          resp.udbToken = encodeURIComponent(resp.udbToken);
        }
      }
      switch (resp.status) {
        case 'ok':
          if (params.success) {
            params.success(resp);
          }
          break;
        case 'cancel':
          if (params.cancel) {
            params.cancel(resp);
          }
          break;
        default:
          if (params.fail) {
            params.fail(resp);
          }
      }
      if (params.complete) {
        params.complete(resp);
      }
    }
  }]);
  return NativeBridge;
}();
var nativeBridge = new NativeBridge();

var _DOM_READY_IFRAME_ID = '__HUYAJSBridgeIframe_DomReady';
function _createDomReadyIFrame() {
  var domReady = document.createElement('iframe');
  domReady.id = _DOM_READY_IFRAME_ID;
  domReady.style.display = 'none';
  document.documentElement.appendChild(domReady);
  domReady.src = 'kiwi://DOMContentLoaded';
}
function _removeDomReadyIFrame() {
  var elem = document.getElementById(_DOM_READY_IFRAME_ID);
  if (elem) {
    document.documentElement.removeChild(elem);
  }
}
function _readyEventListenerHandle() {
  nativeBridge.handleQueuedMessage();
  getBridge$1().call('ready', {
    usePostMessageByDefault: true
  }, function () {});
  setTimeout(function () {
    _removeDomReadyIFrame();
  }, 1000);
}
function addReadyEventListener(handle) {
  if (getBridge$1()) {
    handle();
  } else {
    if (document.addEventListener) {
      document.addEventListener('KiwiWebViewJavascriptBridgeReady', handle, false);
    }
  }
}
function _setupOnError() {
  var originalOnEror = window.onerror;
  if (!originalOnEror) {
    window.onerror = function (sMsg, sUrl, sLine) {
      sMsg = sMsg ? sMsg : '';
      sUrl = sUrl ? sUrl : '';
      sLine = sLine ? sLine : '';
      var errorInfo = 'error:' + sMsg + '\n';
      errorInfo += 'URL:' + sUrl + '\n';
      errorInfo += 'Line:' + sLine + '\n';
      if (window.fnError) {
        window.fnError(sMsg, sUrl, sLine);
      }
      getBridge$1().call('onerror', {
        errorInfo: errorInfo,
        usePostMessageByDefault: true
      }, function () {});
      originalOnEror && originalOnEror.apply(this, arguments);
      return false;
    };
  }
}
function shouldCreateIframeForBridge() {
  if (Browser.versions.pcAnchor || Browser.versions.pcLive) return false;
  var forceSetKiwiIframeForBridge = window.__forceSetKiwiIframeForBridge;
  if (forceSetKiwiIframeForBridge !== undefined) return forceSetKiwiIframeForBridge;
  return Browser.versions.zsApp || Browser.versions.huyaApp;
}
function setup() {
  addReadyEventListener(_readyEventListenerHandle);
  if (!shouldCreateIframeForBridge()) {
    _setupOnError();
    return;
  }
  if (document.readyState == 'interactive' || document.readyState == 'complete') {
    try {
      _createDomReadyIFrame();
    } catch (e) {}
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      _createDomReadyIFrame();
    });
  }
  if (Browser.versions.android) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'KWBridge://huya.com/load_KwBridge.js';
    head.appendChild(script);
  }
  _setupOnError();
}

var HUYASdk$1 = {
  version: '1.0.0',
  usePostMessageByDefault: true,
  useProcolByDefault: false,
  useContextByDefault: false,
  EVENT_ID: {},
  CONST_TYPE: {},
  Browser: Browser,
  Utils: Utils,
  bridge: nativeBridge,
  JSBridge: nativeBridge,
  exportApi: function exportApi(api) {
    Utils.shallowExtend(HUYASdk$1, api);
  },
  exportEventID: function exportEventID(api) {
    Utils.shallowExtend(HUYASdk$1.EVENT_ID, api);
  },
  exportConstType: function exportConstType(api) {
    Utils.shallowExtend(HUYASdk$1.CONST_TYPE, api);
  },
  log: function log(msg) {
    nativeBridge.invoke('log', {
      'msg': msg
    });
  },
  ready: function ready(callback) {
    addReadyEventListener(callback);
  },
  handleResponse: nativeBridge.handleResponse.bind(nativeBridge),
  wupRequstMap: {},
  uniqueWupRequstId: 0
};

/**
 * 加载js
 * @param url
 * @param success
 */
var urlsMap = {};
function loadJs(url, success) {
    if (urlsMap[url])
        return success();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var matched = __spread(window.document.scripts).find(function (script) { return script.src === url; });
    if (matched)
        return success();
    var domScript = document.createElement('script');
    domScript.src = url;
    // success = success || function () {}
    domScript.onload = domScript.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
            success();
            urlsMap[url] = 1;
            this.onload = this.onreadystatechange = null;
        }
    };
    document.getElementsByTagName('head')[0].appendChild(domScript);
}
var createSDKError = function (e, name) {
    var sdkError = new Error(JSON.stringify(e.issues, null, 2));
    sdkError.name = 'better-kiwi ' + name + ' Validated Error';
    return sdkError;
};
var useSentry = function () { return __awaiter(void 0, void 0, void 0, function () {
    var sentryConfig_1;
    var _a, _b;
    return __generator(this, function (_c) {
        // 默认不使用sentry
        if (typeof window.disableKiwiSentry === 'undefined')
            return [2 /*return*/];
        // 设置禁用sentry
        if (typeof window.disableKiwiSentry !== 'undefined' && window.disableKiwiSentry)
            return [2 /*return*/];
        try {
            sentryConfig_1 = {
                dsn: 'https://1870bbaca4864b1489a34714511de6dc@fems.huya.com/775',
                release: "1.10.11",
                enabled: true
            };
            if (typeof window.Sentry !== 'undefined') {
                // console.log('exce', sentryConfig)
                if ((_a = window.Sentry) === null || _a === void 0 ? void 0 : _a.init) {
                    (_b = window.Sentry) === null || _b === void 0 ? void 0 : _b.init(sentryConfig_1);
                }
            }
            else {
                loadJs('https://static-jw.msstatic.com/hy-sentry/sdk/latest/bundle.tracing.min.js', function () {
                    var _a, _b;
                    // console.log('load sentry', sentryConfig)
                    if (typeof window.Sentry !== 'undefined') {
                        // console.log('exce', sentryConfig)
                        if ((_a = window.Sentry) === null || _a === void 0 ? void 0 : _a.init) {
                            (_b = window.Sentry) === null || _b === void 0 ? void 0 : _b.init(sentryConfig_1);
                        }
                    }
                    else {
                        console.warn('sentry is not ready');
                    }
                });
            }
        }
        catch (err) {
            console.warn(err);
        }
        return [2 /*return*/];
    });
}); };
// 处理PC端结果返回字符串
var parseRespJson = function (str) {
    if (typeof str == 'object')
        return str;
    if (typeof str !== 'string')
        return str;
    try {
        return JSON.parse(str);
    }
    catch (_e) {
        return str;
    }
};
/**
 * 处理新版PC观众端结果返回字符串
 */
var parseJsonForNewPC = function (thing) {
    if (typeof thing !== 'string')
        return thing;
    try {
        //清除 c# 序列化JSON字符串存在\uu22 问题
        var jsonStr = thing == 'string'
            ? thing.replace(/\\\\u([\da-f]{4})/gi, function (match, grp) {
                return String.fromCharCode(parseInt(grp, 16));
            })
            : thing;
        return JSON.parse(jsonStr);
    }
    catch (_err) {
        console.warn('转换json字符串失败', thing);
        return thing;
    }
};
// 上报函数错误
var reportApiMess = function (funcName, resp) {
    var _a, _b, _c;
    if (window.performanceInfo && window.performanceInfo._hmt) {
        var data = parseRespJson(resp);
        var status_1 = typeof data === 'object' ? (data === null || data === void 0 ? void 0 : data.status) || ((_a = ((data === null || data === void 0 ? void 0 : data.message) || {})) === null || _a === void 0 ? void 0 : _a.status) : '';
        var code = typeof data === 'object'
            ? (data === null || data === void 0 ? void 0 : data.errorCode) || (data === null || data === void 0 ? void 0 : data.err_code) || ((_b = ((data === null || data === void 0 ? void 0 : data.message) || {})) === null || _b === void 0 ? void 0 : _b.err_code) || ((_c = ((data === null || data === void 0 ? void 0 : data.message) || {})) === null || _c === void 0 ? void 0 : _c.code)
            : -1;
        // 兜底处理
        if (status_1 === 'fail' || code === -1) {
            console.log('reportApiMess', funcName, JSON.stringify(data));
            window.performanceInfo._hmt.push([
                'reportApiMess',
                'js-sdk-error-report',
                JSON.stringify(data),
                status_1 === 'fail' ? -1 : code,
                funcName,
                'kiwi-sdk',
                "1.10.11"
            ]);
        }
    }
};
function once(fn) {
    var result;
    var emited = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!emited) {
            emited = true;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            result = fn.apply(void 0, __spread(args));
        }
        return result;
    };
}
function runWhenIdle(callback, timeout) {
    if (timeout === void 0) { timeout = 150; }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window.requestIdleCallback !== 'function')
        return setTimeout(callback, timeout);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var handle = window.requestIdleCallback(callback);
    setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.cancelIdleCallback(handle);
        callback();
    }, timeout);
}
/**
 * @see https://git.huya.info/huyafed/project/huya-main-webpack/-/wikis/modules/room/roomPostMessageService
 * 主站通用方法调用
 * @example getMainRsp(null, 5000, 'RoomLoginReq', 'RoomLoginRes');
 * @param {*} param
 * @param {*} timeout
 * @param {*} req
 * @param {*} rsp
 * @returns
 */
var getMainRsp = function (param, timeout, req, rsp) {
    if (timeout === void 0) { timeout = 500; }
    try {
        return new Promise(function (resolve, reject) {
            var request = {
                code: req,
                data: param
            };
            var timer = setTimeout(function () {
                //   reject(console.log('主站方法返回超时'))
                reject('[kiwisdk] mainweb methor call timeout');
            }, timeout);
            window.addEventListener('message', handleMessage, false);
            window.parent.postMessage(JSON.stringify(request), '*');
            function handleMessage(_a) {
                var origin = _a.origin, data = _a.data;
                if (/\.huya\.com$/.test(origin)) {
                    var response = void 0;
                    if (data && typeof data === 'string') {
                        try {
                            response = JSON.parse(data);
                            // eslint-disable-next-line
                        }
                        catch (err) { }
                    }
                    if (response && response.code === rsp) {
                        clearTimeout(timer);
                        window.removeEventListener('message', handleMessage, false);
                        resolve(response.data);
                    }
                }
            }
        });
    }
    catch (error) {
        return Promise.reject(error);
    }
};
/**
 * @description 设置全局缓存, 避免同一个页面不同模块重复调用
 */
function getGlobalValue(fn, globalKey) {
    var key = "__kiwisdk_global_" + globalKey + "__";
    if (window[key])
        return window[key];
    var result = fn();
    window[key] = result;
    return result;
}
/**
 * @description 全局仅调用1次，如初始化某些监听事件。避免同一个页面不同模块重复调用
 */
function runOnceInGlobal(fn, globalKey) {
    var key = "__kiwisdk_globalfn_" + globalKey + "__";
    if (window[key])
        return;
    fn();
    window[key] = true;
}
var getUidAndToken = function (HYUserInfo) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                var timer = setTimeout(function () {
                    resolve({ uid: 0, udbToken: '' });
                }, 1000);
                HYUserInfo.getCurrentUserInfo({
                    complete: function (resp) {
                        clearTimeout(timer);
                        resp = parseRespJson(resp);
                        var result = {
                            uid: resp.uid,
                            udbToken: resp.udbToken
                        };
                        resolve(result);
                    }
                });
            })];
    });
}); };
var getCookie = function (name) {
    var arr;
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg)))
        return decodeURIComponent(arr[2]);
    else
        return null;
};
var OPENAPP_CDN = 'https://a.msstatic.com/huya/hd/cdn_libs/openApp.js?v=1.10.0';
var openAppByCDN = function (params) {
    if (typeof window.openApp === 'function')
        return window.openApp(params);
    loadJs(OPENAPP_CDN, function () {
        if (typeof window.openApp === 'function')
            return window.openApp(params);
    });
};
// 兼容旧方法
var isCompatibleOldSdk = function (params) {
    return params && (typeof (params === null || params === void 0 ? void 0 : params.success) === 'function' || typeof (params === null || params === void 0 ? void 0 : params.complete) === 'function');
};
var createRandomId = function () {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

/**
 * @description 高频率使用的 taf-api
 * @example
 ```javascript
  loadScript("https://hd2.huya.com/fedbasic/huyafed/taf-api/index.umd.0.3.0.min.js").then(() => {
    if (!(window as any).hyTafApi) return;
    const hyTafApi = (window as any).hyTafApi;
    const { configure, getUserProfile } = hyTafApi;
    configure({ Taf, tafSdk});
    getUserProfile({ lUid: getUserId().lUid }).then(console.log);
  });
 ```
 */
var TAF_API_CDN = 'https://hd2.huya.com/fedbasic/huyafed/taf-api/index.umd.0.4.0.min.js';
var fetchTafApi = once(function () { return __awaiter(void 0, void 0, void 0, function () {
    var fetchScript, promise;
    return __generator(this, function (_a) {
        fetchScript = function () {
            return new Promise(function (resolve, reject) {
                loadJs(TAF_API_CDN, function () {
                    if (!window.hyTafApi)
                        return reject(new Error('taf-api not loaded'));
                    resolve(window.hyTafApi);
                });
            });
        };
        promise = getGlobalValue(fetchScript, 'fetchTafApi');
        return [2 /*return*/, promise];
    });
}); });
/**
 * `hyTafNetWork` 由diy页面注入全局变量
 * 默认支持 diy 页面
 */
var getDefaultTafApiConfig = function () {
    if (window.hyTafNetWork && typeof window.hyTafNetWork.getTaf === 'function') {
        var config = {
            Taf: window.hyTafNetWork.getTaf(),
            tafSdk: window.hyTafNetWork
        };
        return config;
    }
    return null;
};

var __config = {
    /** 是否为测试环境 */
    isTestEnv: window.location.origin.indexOf('test') !== -1,
    redirectUrl: undefined,
    outerHandle: undefined,
    errorHandle: undefined,
    /** 重写当前平台值;当 sdk 判断错误时，业务可临时覆盖 */
    platformOverride: undefined,
    /**
     * tafApi 相关配置，外部传入 Taf 协议对象和 tafSdk，用来调用 taf 接口
     * @example
     * ```javascript
        // @huyafed/taf-network 引入并使用
        import TafNetwork from '@huyafed/taf-network';
        import { HUYASdk } from '@huyafed/huya-kiwi';
        const tafSdk = new TafNetwork({
          showLog: window.location.origin.indexOf('test') === -1,
          isDebug: window.location.origin.indexOf('test') !== -1,
        });
        HUYASdk.config({ tafApiConfig: { tafSdk } })
  
        // diy 组件默认支持
     * ```
     */
    tafApiConfig: getDefaultTafApiConfig(),
    /**
     * 跨域 Api 开关
     * - 若当前页面被父窗口用iframe嵌入且因跨域问题使app的JS Bridge失效，会导致h5无法调用客户端api
     * - 打开此开关，在跨域时会尝试使用postmessage来通信，调用客户端api
     */
    useCrossDomainApi: false
};
/**
 * @description 这里的数据会注入到 HUYASdk
 */
var exportConfig = {
    /** 设置 HUYASdk 配置。@example: HUYASdk.config({ isTestEnv: false }) */
    config: function (config) {
        __config = Object.assign(__config, config || {});
    },
    getInnerConfig: function () { return __config; },
    isInHuyaApp: function () { return Boolean(getBridge$1()); },
    ACTIVITY_EVENT_ID: {
        //活动页展开收起状态发生变化
        ACTIVITY_WINDOW_SIZE_CHANGED: 'ACTIVITY_WINDOW_SIZE_CHANGED'
    }
};
// 挂载兼容旧HUYASdk
if (HUYASdk$1 !== undefined) {
    HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.exportEventID({
        VIEW_DISAPPEAR: 'VIEW_DISAPPEAR',
        VIEW_APPEAR: 'VIEW_APPEAR',
        WILL_RESIGN_ACTIVE: 'WILL_RESIGN_ACTIVE',
        DID_BECOME_ACTIVE: 'DID_BECOME_ACTIVE',
        NETWORK_CHANGED: 'NETWORK_CHANGED',
        AUDIO_RECORD_END: 'AUDIO_RECORD_END',
        ACTIVITY_WINDOW_SIZE_CHANGED: 'ACTIVITY_WINDOW_SIZE_CHANGED',
        INSTALL_APK_EVENT_CHANGED: 'INSTALL_APK_EVENT_CHANGED',
        kKWJSSdkEventIdApp: 'kKWJSSdkEventIdApp',
        TRANSMIT: 'transmit',
        WUP_TRANSMIT: 'transmitWup',
        CHANNEL: 'channelEvent',
        SCREEN_RECORD_CHANGED: 'SCREEN_RECORD_CHANGED',
        NATIVE_INSTALLER: 'INSTALL_APK_EVENT_CHANGED',
        LOGIN_SUCCESS: 'loginSuccess',
        LOGIN_FAILED: 'loginFailed',
        KICK_OFF: 'kickOff',
        loginSuccess: 'loginSuccess',
        loginFailed: 'loginFailed',
        kickOff: 'kickOff'
    });
    HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.exportConstType({
        Privileges_Type: {
            Open: 1,
            Renew: 2
        }
    });
    // 添加旧方法
    Object.assign(HUYASdk$1, exportConfig);
}
// 兼容旧版sdk配置
var HUYAConfig = {
    APP_NAME: {
        GAME_IOS: 'hyassist4game-ios',
        GAME_ANDROID: 'game-adr',
        LIVE_IOS: 'live-ios',
        LIVE_ANDROID: 'live-adr',
        IOS: 'kiwi-ios',
        ANDROID: 'kiwi-android',
        HARMONY: 'kiwi-harmony',
        Pitaya: 'ios_pitaya',
        Pitaya_ANDROID: 'adr_pitaya' //小鹿陪玩Android
    },
    //虎牙app
    isHuyaApp: function (appName) {
        return (appName == this.APP_NAME.IOS ||
            appName == this.APP_NAME.ANDROID ||
            appName == this.APP_NAME.HARMONY);
    },
    //是小鹿陪玩
    isPitayaApp: function (appName) {
        return appName == this.APP_NAME.Pitaya || appName == this.APP_NAME.Pitaya_ANDROID;
    },
    //虎牙开播助手
    isHuyaLive: function (appName) {
        return appName == this.APP_NAME.LIVE_IOS || appName == this.APP_NAME.LIVE_ANDROID;
    },
    //虎牙手游开播
    isHuyaGame: function (appName) {
        return appName == this.APP_NAME.GAME_IOS || appName == this.APP_NAME.GAME_ANDROID;
    }
};

var util;
(function (util) {
  util.assertEqual = function (val) {
    return val;
  };
  function assertIs(_arg) {}
  util.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util.assertNever = assertNever;
  util.arrayToEnum = function (items) {
    var obj = {};
    var _iterator = _createForOfIteratorHelper(items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        obj[item] = item;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return obj;
  };
  util.getValidEnumValues = function (obj) {
    var validKeys = util.objectKeys(obj).filter(function (k) {
      return typeof obj[obj[k]] !== "number";
    });
    var filtered = {};
    var _iterator2 = _createForOfIteratorHelper(validKeys),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var k = _step2.value;
        filtered[k] = obj[k];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return util.objectValues(filtered);
  };
  util.objectValues = function (obj) {
    return util.objectKeys(obj).map(function (e) {
      return obj[e];
    });
  };
  util.objectKeys = typeof Object.keys === "function"
  ? function (obj) {
    return Object.keys(obj);
  }
  : function (object) {
    var keys = [];
    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util.find = function (arr, checker) {
    var _iterator3 = _createForOfIteratorHelper(arr),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var item = _step3.value;
        if (checker(item)) return item;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return undefined;
  };
  util.isInteger = typeof Number.isInteger === "function" ? function (val) {
    return Number.isInteger(val);
  }
  : function (val) {
    return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  };
  function joinValues(array) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " | ";
    return array.map(function (val) {
      return typeof val === "string" ? "'".concat(val, "'") : val;
    }).join(separator);
  }
  util.joinValues = joinValues;
  util.jsonStringifyReplacer = function (_, value) {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var ZodParsedType = util.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]);
var getParsedType = function getParsedType(data) {
  var t = _typeof(data);
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType["boolean"];
    case "function":
      return ZodParsedType["function"];
    case "bigint":
      return ZodParsedType.bigint;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType["null"];
      }
      if (data.then && typeof data.then === "function" && data["catch"] && typeof data["catch"] === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
var ZodIssueCode = util.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of"]);
var quotelessJson = function quotelessJson(obj) {
  var json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = function (_Error) {
  _inherits(ZodError, _Error);
  var _super = _createSuper(ZodError);
  function ZodError(issues) {
    var _this;
    _classCallCheck(this, ZodError);
    _this = _super.call(this);
    _this.issues = [];
    _this.addIssue = function (sub) {
      _this.issues = [].concat(_toConsumableArray(_this.issues), [sub]);
    };
    _this.addIssues = function () {
      var subs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      _this.issues = [].concat(_toConsumableArray(_this.issues), _toConsumableArray(subs));
    };
    var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(_assertThisInitialized(_this), actualProto);
    } else {
      _this.__proto__ = actualProto;
    }
    _this.name = "ZodError";
    _this.issues = issues;
    return _this;
  }
  _createClass(ZodError, [{
    key: "errors",
    get: function get() {
      return this.issues;
    }
  }, {
    key: "format",
    value: function format(_mapper) {
      var mapper = _mapper || function (issue) {
        return issue.message;
      };
      var fieldErrors = {
        _errors: []
      };
      var processError = function processError(error) {
        var _iterator4 = _createForOfIteratorHelper(error.issues),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var issue = _step4.value;
            if (issue.code === "invalid_union") {
              issue.unionErrors.map(processError);
            } else if (issue.code === "invalid_return_type") {
              processError(issue.returnTypeError);
            } else if (issue.code === "invalid_arguments") {
              processError(issue.argumentsError);
            } else if (issue.path.length === 0) {
              fieldErrors._errors.push(mapper(issue));
            } else {
              var curr = fieldErrors;
              var i = 0;
              while (i < issue.path.length) {
                var el = issue.path[i];
                var terminal = i === issue.path.length - 1;
                if (!terminal) {
                  curr[el] = curr[el] || {
                    _errors: []
                  };
                } else {
                  curr[el] = curr[el] || {
                    _errors: []
                  };
                  curr[el]._errors.push(mapper(issue));
                }
                curr = curr[el];
                i++;
              }
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      };
      processError(this);
      return fieldErrors;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: "message",
    get: function get() {
      return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.issues.length === 0;
    }
  }, {
    key: "flatten",
    value: function flatten() {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (issue) {
        return issue.message;
      };
      var fieldErrors = {};
      var formErrors = [];
      var _iterator5 = _createForOfIteratorHelper(this.issues),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var sub = _step5.value;
          if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
          } else {
            formErrors.push(mapper(sub));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
      };
    }
  }, {
    key: "formErrors",
    get: function get() {
      return this.flatten();
    }
  }]);
  return ZodError;
}( _wrapNativeSuper(Error));
ZodError.create = function (issues) {
  var error = new ZodError(issues);
  return error;
};
var errorMap = function errorMap(issue, _ctx) {
  var message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, util.jsonStringifyReplacer));
      break;
    case ZodIssueCode.unrecognized_keys:
      message = "Unrecognized key(s) in object: ".concat(util.joinValues(issue.keys, ", "));
      break;
    case ZodIssueCode.invalid_union:
      message = "Invalid input";
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = "Invalid discriminator value. Expected ".concat(util.joinValues(issue.options));
      break;
    case ZodIssueCode.invalid_enum_value:
      message = "Invalid enum value. Expected ".concat(util.joinValues(issue.options), ", received '").concat(issue.received, "'");
      break;
    case ZodIssueCode.invalid_arguments:
      message = "Invalid function arguments";
      break;
    case ZodIssueCode.invalid_return_type:
      message = "Invalid function return type";
      break;
    case ZodIssueCode.invalid_date:
      message = "Invalid date";
      break;
    case ZodIssueCode.invalid_string:
      if (_typeof(issue.validation) === "object") {
        if ("startsWith" in issue.validation) {
          message = "Invalid input: must start with \"".concat(issue.validation.startsWith, "\"");
        } else if ("endsWith" in issue.validation) {
          message = "Invalid input: must end with \"".concat(issue.validation.endsWith, "\"");
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = "Invalid ".concat(issue.validation);
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array") message = "Array must contain ".concat(issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");else if (issue.type === "string") message = "String must contain ".concat(issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");else if (issue.type === "number") message = "Number must be greater than ".concat(issue.inclusive ? "or equal to " : "").concat(issue.minimum);else if (issue.type === "date") message = "Date must be greater than ".concat(issue.inclusive ? "or equal to " : "").concat(new Date(issue.minimum));else message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array") message = "Array must contain ".concat(issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");else if (issue.type === "string") message = "String must contain ".concat(issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");else if (issue.type === "number") message = "Number must be less than ".concat(issue.inclusive ? "or equal to " : "").concat(issue.maximum);else if (issue.type === "date") message = "Date must be smaller than ".concat(issue.inclusive ? "or equal to " : "").concat(new Date(issue.maximum));else message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = "Invalid input";
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = "Intersection results could not be merged";
      break;
    case ZodIssueCode.not_multiple_of:
      message = "Number must be a multiple of ".concat(issue.multipleOf);
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return {
    message: message
  };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
var makeIssue = function makeIssue(params) {
  var data = params.data,
    path = params.path,
    errorMaps = params.errorMaps,
    issueData = params.issueData;
  var fullPath = [].concat(_toConsumableArray(path), _toConsumableArray(issueData.path || []));
  var fullIssue = _objectSpread2(_objectSpread2({}, issueData), {}, {
    path: fullPath
  });
  var errorMessage = "";
  var maps = errorMaps.filter(function (m) {
    return !!m;
  }).slice().reverse();
  var _iterator6 = _createForOfIteratorHelper(maps),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var map = _step6.value;
      errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
      }).message;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return _objectSpread2(_objectSpread2({}, issueData), {}, {
    path: fullPath,
    message: issueData.message || errorMessage
  });
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  var issue = makeIssue({
    issueData: issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), errorMap].filter(function (x) {
      return !!x;
    })
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = function () {
  function ParseStatus() {
    _classCallCheck(this, ParseStatus);
    this.value = "valid";
  }
  _createClass(ParseStatus, [{
    key: "dirty",
    value: function dirty() {
      if (this.value === "valid") this.value = "dirty";
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.value !== "aborted") this.value = "aborted";
    }
  }], [{
    key: "mergeArray",
    value: function mergeArray(status, results) {
      var arrayValue = [];
      var _iterator7 = _createForOfIteratorHelper(results),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var s = _step7.value;
          if (s.status === "aborted") return INVALID;
          if (s.status === "dirty") status.dirty();
          arrayValue.push(s.value);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return {
        status: status.value,
        value: arrayValue
      };
    }
  }, {
    key: "mergeObjectAsync",
    value: function () {
      var _mergeObjectAsync = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(status, pairs) {
        var syncPairs, _iterator8, _step8, pair;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              syncPairs = [];
              _iterator8 = _createForOfIteratorHelper(pairs);
              _context.prev = 2;
              _iterator8.s();
            case 4:
              if ((_step8 = _iterator8.n()).done) {
                _context.next = 17;
                break;
              }
              pair = _step8.value;
              _context.t0 = syncPairs;
              _context.next = 9;
              return pair.key;
            case 9:
              _context.t1 = _context.sent;
              _context.next = 12;
              return pair.value;
            case 12:
              _context.t2 = _context.sent;
              _context.t3 = {
                key: _context.t1,
                value: _context.t2
              };
              _context.t0.push.call(_context.t0, _context.t3);
            case 15:
              _context.next = 4;
              break;
            case 17:
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t4 = _context["catch"](2);
              _iterator8.e(_context.t4);
            case 22:
              _context.prev = 22;
              _iterator8.f();
              return _context.finish(22);
            case 25:
              return _context.abrupt("return", ParseStatus.mergeObjectSync(status, syncPairs));
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 19, 22, 25]]);
      }));
      function mergeObjectAsync(_x2, _x3) {
        return _mergeObjectAsync.apply(this, arguments);
      }
      return mergeObjectAsync;
    }()
  }, {
    key: "mergeObjectSync",
    value: function mergeObjectSync(status, pairs) {
      var finalObject = {};
      var _iterator9 = _createForOfIteratorHelper(pairs),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var pair = _step9.value;
          var key = pair.key,
            value = pair.value;
          if (key.status === "aborted") return INVALID;
          if (value.status === "aborted") return INVALID;
          if (key.status === "dirty") status.dirty();
          if (value.status === "dirty") status.dirty();
          if (typeof value.value !== "undefined" || pair.alwaysSet) {
            finalObject[key.value] = value.value;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return {
        status: status.value,
        value: finalObject
      };
    }
  }]);
  return ParseStatus;
}();
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = function DIRTY(value) {
  return {
    status: "dirty",
    value: value
  };
};
var OK = function OK(value) {
  return {
    status: "valid",
    value: value
  };
};
var isAborted = function isAborted(x) {
  return x.status === "aborted";
};
var isDirty = function isDirty(x) {
  return x.status === "dirty";
};
var isValid = function isValid(x) {
  return x.status === "valid";
};
var isAsync = function isAsync(x) {
  return (typeof Promise === "undefined" ? "undefined" : _typeof(Promise)) !== undefined && x instanceof Promise;
};
var errorUtil;
(function (errorUtil) {
  errorUtil.errToObj = function (message) {
    return typeof message === "string" ? {
      message: message
    } : message || {};
  };
  errorUtil.toString = function (message) {
    return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
  };
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = function () {
  function ParseInputLazyPath(parent, value, path, key) {
    _classCallCheck(this, ParseInputLazyPath);
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  _createClass(ParseInputLazyPath, [{
    key: "path",
    get: function get() {
      return this._path.concat(this._key);
    }
  }]);
  return ParseInputLazyPath;
}();
var handleResult = function handleResult(ctx, result) {
  if (isValid(result)) {
    return {
      success: true,
      data: result.value
    };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    var error = new ZodError(ctx.common.issues);
    return {
      success: false,
      error: error
    };
  }
};
function processCreateParams(params) {
  if (!params) return {};
  var errorMap = params.errorMap,
    invalid_type_error = params.invalid_type_error,
    required_error = params.required_error,
    description = params.description;
  if (errorMap && (invalid_type_error || required_error)) {
    throw new Error("Can't use \"invalid_type_error\" or \"required_error\" in conjunction with custom error map.");
  }
  if (errorMap) return {
    errorMap: errorMap,
    description: description
  };
  var customMap = function customMap(iss, ctx) {
    if (iss.code !== "invalid_type") return {
      message: ctx.defaultError
    };
    if (typeof ctx.data === "undefined") {
      return {
        message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
      };
    }
    return {
      message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
    };
  };
  return {
    errorMap: customMap,
    description: description
  };
}
var ZodType = function () {
  function ZodType(def) {
    _classCallCheck(this, ZodType);
    this.spa = this.safeParseAsync;
    this.superRefine = this._refinement;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this["default"] = this["default"].bind(this);
    this.describe = this.describe.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  _createClass(ZodType, [{
    key: "description",
    get: function get() {
      return this._def.description;
    }
  }, {
    key: "_getType",
    value: function _getType(input) {
      return getParsedType(input.data);
    }
  }, {
    key: "_getOrReturnCtx",
    value: function _getOrReturnCtx(input, ctx) {
      return ctx || {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      };
    }
  }, {
    key: "_processInputParams",
    value: function _processInputParams(input) {
      return {
        status: new ParseStatus(),
        ctx: {
          common: input.parent.common,
          data: input.data,
          parsedType: getParsedType(input.data),
          schemaErrorMap: this._def.errorMap,
          path: input.path,
          parent: input.parent
        }
      };
    }
  }, {
    key: "_parseSync",
    value: function _parseSync(input) {
      var result = this._parse(input);
      if (isAsync(result)) {
        throw new Error("Synchronous parse encountered promise.");
      }
      return result;
    }
  }, {
    key: "_parseAsync",
    value: function _parseAsync(input) {
      var result = this._parse(input);
      return Promise.resolve(result);
    }
  }, {
    key: "parse",
    value: function parse(data, params) {
      var result = this.safeParse(data, params);
      if (result.success) return result.data;
      throw result.error;
    }
  }, {
    key: "safeParse",
    value: function safeParse(data, params) {
      var _a;
      var ctx = {
        common: {
          issues: [],
          async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: data,
        parsedType: getParsedType(data)
      };
      var result = this._parseSync({
        data: data,
        path: ctx.path,
        parent: ctx
      });
      return handleResult(ctx, result);
    }
  }, {
    key: "parseAsync",
    value: function () {
      var _parseAsync2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(data, params) {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.safeParseAsync(data, params);
            case 2:
              result = _context2.sent;
              if (!result.success) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", result.data);
            case 5:
              throw result.error;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function parseAsync(_x4, _x5) {
        return _parseAsync2.apply(this, arguments);
      }
      return parseAsync;
    }()
  }, {
    key: "safeParseAsync",
    value: function () {
      var _safeParseAsync = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(data, params) {
        var ctx, maybeAsyncResult, result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ctx = {
                common: {
                  issues: [],
                  contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                  async: true
                },
                path: (params === null || params === void 0 ? void 0 : params.path) || [],
                schemaErrorMap: this._def.errorMap,
                parent: null,
                data: data,
                parsedType: getParsedType(data)
              };
              maybeAsyncResult = this._parse({
                data: data,
                path: [],
                parent: ctx
              });
              _context3.next = 4;
              return isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult);
            case 4:
              result = _context3.sent;
              return _context3.abrupt("return", handleResult(ctx, result));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function safeParseAsync(_x6, _x7) {
        return _safeParseAsync.apply(this, arguments);
      }
      return safeParseAsync;
    }()
  }, {
    key: "refine",
    value: function refine(check, message) {
      var getIssueProperties = function getIssueProperties(val) {
        if (typeof message === "string" || typeof message === "undefined") {
          return {
            message: message
          };
        } else if (typeof message === "function") {
          return message(val);
        } else {
          return message;
        }
      };
      return this._refinement(function (val, ctx) {
        var result = check(val);
        var setError = function setError() {
          return ctx.addIssue(_objectSpread2({
            code: ZodIssueCode.custom
          }, getIssueProperties(val)));
        };
        if (typeof Promise !== "undefined" && result instanceof Promise) {
          return result.then(function (data) {
            if (!data) {
              setError();
              return false;
            } else {
              return true;
            }
          });
        }
        if (!result) {
          setError();
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: "refinement",
    value: function refinement(check, refinementData) {
      return this._refinement(function (val, ctx) {
        if (!check(val)) {
          ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: "_refinement",
    value: function _refinement(refinement) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: {
          type: "refinement",
          refinement: refinement
        }
      });
    }
  }, {
    key: "optional",
    value: function optional() {
      return ZodOptional.create(this);
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return ZodNullable.create(this);
    }
  }, {
    key: "nullish",
    value: function nullish() {
      return this.optional().nullable();
    }
  }, {
    key: "array",
    value: function array() {
      return ZodArray.create(this);
    }
  }, {
    key: "promise",
    value: function promise() {
      return ZodPromise.create(this);
    }
  }, {
    key: "or",
    value: function or(option) {
      return ZodUnion.create([this, option]);
    }
  }, {
    key: "and",
    value: function and(incoming) {
      return ZodIntersection.create(this, incoming);
    }
  }, {
    key: "transform",
    value: function transform(_transform) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: {
          type: "transform",
          transform: _transform
        }
      });
    }
  }, {
    key: "default",
    value: function _default(def) {
      var defaultValueFunc = typeof def === "function" ? def : function () {
        return def;
      };
      return new ZodDefault({
        innerType: this,
        defaultValue: defaultValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodDefault
      });
    }
  }, {
    key: "brand",
    value: function brand() {
      return new ZodBranded(_objectSpread2({
        typeName: ZodFirstPartyTypeKind.ZodBranded,
        type: this
      }, processCreateParams(undefined)));
    }
  }, {
    key: "describe",
    value: function describe(description) {
      var This = this.constructor;
      return new This(_objectSpread2(_objectSpread2({}, this._def), {}, {
        description: description
      }));
    }
  }, {
    key: "isOptional",
    value: function isOptional() {
      return this.safeParse(undefined).success;
    }
  }, {
    key: "isNullable",
    value: function isNullable() {
      return this.safeParse(null).success;
    }
  }]);
  return ZodType;
}();
var cuidRegex = /^c[^\s-]{8,}$/i;
var uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
var ZodString = function (_ZodType) {
  _inherits(ZodString, _ZodType);
  var _super2 = _createSuper(ZodString);
  function ZodString() {
    var _this2;
    _classCallCheck(this, ZodString);
    _this2 = _super2.apply(this, arguments);
    _this2._regex = function (regex, validation, message) {
      return _this2.refinement(function (data) {
        return regex.test(data);
      }, _objectSpread2({
        validation: validation,
        code: ZodIssueCode.invalid_string
      }, errorUtil.errToObj(message)));
    };
    _this2.nonempty = function (message) {
      return _this2.min(1, errorUtil.errToObj(message));
    };
    _this2.trim = function () {
      return new ZodString(_objectSpread2(_objectSpread2({}, _this2._def), {}, {
        checks: [].concat(_toConsumableArray(_this2._def.checks), [{
          kind: "trim"
        }])
      }));
    };
    return _this2;
  }
  _createClass(ZodString, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.string) {
        var _ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(_ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: _ctx2.parsedType
        }
        );
        return INVALID;
      }
      var status = new ParseStatus();
      var ctx = undefined;
      var _iterator10 = _createForOfIteratorHelper(this._def.checks),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var check = _step10.value;
          if (check.kind === "min") {
            if (input.data.length < check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: check.value,
                type: "string",
                inclusive: true,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "max") {
            if (input.data.length > check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: check.value,
                type: "string",
                inclusive: true,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "email") {
            if (!emailRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "email",
                code: ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "uuid") {
            if (!uuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "uuid",
                code: ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "cuid") {
            if (!cuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "cuid",
                code: ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "url") {
            try {
              new URL(input.data);
            } catch (_a) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "url",
                code: ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "regex") {
            check.regex.lastIndex = 0;
            var testResult = check.regex.test(input.data);
            if (!testResult) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "regex",
                code: ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "trim") {
            input.data = input.data.trim();
          } else if (check.kind === "startsWith") {
            if (!input.data.startsWith(check.value)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: {
                  startsWith: check.value
                },
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "endsWith") {
            if (!input.data.endsWith(check.value)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: {
                  endsWith: check.value
                },
                message: check.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(check);
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return {
        status: status.value,
        value: input.data
      };
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodString(_objectSpread2(_objectSpread2({}, this._def), {}, {
        checks: [].concat(_toConsumableArray(this._def.checks), [check])
      }));
    }
  }, {
    key: "email",
    value: function email(message) {
      return this._addCheck(_objectSpread2({
        kind: "email"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "url",
    value: function url(message) {
      return this._addCheck(_objectSpread2({
        kind: "url"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "uuid",
    value: function uuid(message) {
      return this._addCheck(_objectSpread2({
        kind: "uuid"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "cuid",
    value: function cuid(message) {
      return this._addCheck(_objectSpread2({
        kind: "cuid"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "regex",
    value: function regex(_regex, message) {
      return this._addCheck(_objectSpread2({
        kind: "regex",
        regex: _regex
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "startsWith",
    value: function startsWith(value, message) {
      return this._addCheck(_objectSpread2({
        kind: "startsWith",
        value: value
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "endsWith",
    value: function endsWith(value, message) {
      return this._addCheck(_objectSpread2({
        kind: "endsWith",
        value: value
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "min",
    value: function min(minLength, message) {
      return this._addCheck(_objectSpread2({
        kind: "min",
        value: minLength
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "max",
    value: function max(maxLength, message) {
      return this._addCheck(_objectSpread2({
        kind: "max",
        value: maxLength
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "length",
    value: function length(len, message) {
      return this.min(len, message).max(len, message);
    }
  }, {
    key: "isEmail",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "email";
      });
    }
  }, {
    key: "isURL",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "url";
      });
    }
  }, {
    key: "isUUID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "uuid";
      });
    }
  }, {
    key: "isCUID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "cuid";
      });
    }
  }, {
    key: "minLength",
    get: function get() {
      var min = null;
      var _iterator11 = _createForOfIteratorHelper(this._def.checks),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var ch = _step11.value;
          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return min;
    }
  }, {
    key: "maxLength",
    get: function get() {
      var max = null;
      var _iterator12 = _createForOfIteratorHelper(this._def.checks),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var ch = _step12.value;
          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      return max;
    }
  }]);
  return ZodString;
}(ZodType);
ZodString.create = function (params) {
  return new ZodString(_objectSpread2({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString
  }, processCreateParams(params)));
};
function floatSafeRemainder(val, step) {
  var valDecCount = (val.toString().split(".")[1] || "").length;
  var stepDecCount = (step.toString().split(".")[1] || "").length;
  var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = function (_ZodType2) {
  _inherits(ZodNumber, _ZodType2);
  var _super3 = _createSuper(ZodNumber);
  function ZodNumber() {
    var _this3;
    _classCallCheck(this, ZodNumber);
    _this3 = _super3.apply(this, arguments);
    _this3.min = _this3.gte;
    _this3.max = _this3.lte;
    _this3.step = _this3.multipleOf;
    return _this3;
  }
  _createClass(ZodNumber, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.number) {
        var _ctx3 = this._getOrReturnCtx(input);
        addIssueToContext(_ctx3, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.number,
          received: _ctx3.parsedType
        });
        return INVALID;
      }
      var ctx = undefined;
      var status = new ParseStatus();
      var _iterator13 = _createForOfIteratorHelper(this._def.checks),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var check = _step13.value;
          if (check.kind === "int") {
            if (!util.isInteger(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: "integer",
                received: "float",
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "min") {
            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
            if (tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: check.value,
                type: "number",
                inclusive: check.inclusive,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "max") {
            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
            if (tooBig) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: check.value,
                type: "number",
                inclusive: check.inclusive,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "multipleOf") {
            if (floatSafeRemainder(input.data, check.value) !== 0) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.not_multiple_of,
                multipleOf: check.value,
                message: check.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(check);
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      return {
        status: status.value,
        value: input.data
      };
    }
  }, {
    key: "gte",
    value: function gte(value, message) {
      return this.setLimit("min", value, true, errorUtil.toString(message));
    }
  }, {
    key: "gt",
    value: function gt(value, message) {
      return this.setLimit("min", value, false, errorUtil.toString(message));
    }
  }, {
    key: "lte",
    value: function lte(value, message) {
      return this.setLimit("max", value, true, errorUtil.toString(message));
    }
  }, {
    key: "lt",
    value: function lt(value, message) {
      return this.setLimit("max", value, false, errorUtil.toString(message));
    }
  }, {
    key: "setLimit",
    value: function setLimit(kind, value, inclusive, message) {
      return new ZodNumber(_objectSpread2(_objectSpread2({}, this._def), {}, {
        checks: [].concat(_toConsumableArray(this._def.checks), [{
          kind: kind,
          value: value,
          inclusive: inclusive,
          message: errorUtil.toString(message)
        }])
      }));
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodNumber(_objectSpread2(_objectSpread2({}, this._def), {}, {
        checks: [].concat(_toConsumableArray(this._def.checks), [check])
      }));
    }
  }, {
    key: "int",
    value: function int(message) {
      return this._addCheck({
        kind: "int",
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "positive",
    value: function positive(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "negative",
    value: function negative(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "nonpositive",
    value: function nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "nonnegative",
    value: function nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "multipleOf",
    value: function multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value: value,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "minValue",
    get: function get() {
      var min = null;
      var _iterator14 = _createForOfIteratorHelper(this._def.checks),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var ch = _step14.value;
          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      return min;
    }
  }, {
    key: "maxValue",
    get: function get() {
      var max = null;
      var _iterator15 = _createForOfIteratorHelper(this._def.checks),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var ch = _step15.value;
          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return max;
    }
  }, {
    key: "isInt",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "int";
      });
    }
  }]);
  return ZodNumber;
}(ZodType);
ZodNumber.create = function (params) {
  return new ZodNumber(_objectSpread2({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber
  }, processCreateParams(params)));
};
var ZodBigInt = function (_ZodType3) {
  _inherits(ZodBigInt, _ZodType3);
  var _super4 = _createSuper(ZodBigInt);
  function ZodBigInt() {
    _classCallCheck(this, ZodBigInt);
    return _super4.apply(this, arguments);
  }
  _createClass(ZodBigInt, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.bigint) {
        var ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.bigint,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  }]);
  return ZodBigInt;
}(ZodType);
ZodBigInt.create = function (params) {
  return new ZodBigInt(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodBigInt
  }, processCreateParams(params)));
};
var ZodBoolean = function (_ZodType4) {
  _inherits(ZodBoolean, _ZodType4);
  var _super5 = _createSuper(ZodBoolean);
  function ZodBoolean() {
    _classCallCheck(this, ZodBoolean);
    return _super5.apply(this, arguments);
  }
  _createClass(ZodBoolean, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType["boolean"]) {
        var ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType["boolean"],
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  }]);
  return ZodBoolean;
}(ZodType);
ZodBoolean.create = function (params) {
  return new ZodBoolean(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodBoolean
  }, processCreateParams(params)));
};
var ZodDate = function (_ZodType5) {
  _inherits(ZodDate, _ZodType5);
  var _super6 = _createSuper(ZodDate);
  function ZodDate() {
    _classCallCheck(this, ZodDate);
    return _super6.apply(this, arguments);
  }
  _createClass(ZodDate, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.date) {
        var _ctx4 = this._getOrReturnCtx(input);
        addIssueToContext(_ctx4, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.date,
          received: _ctx4.parsedType
        });
        return INVALID;
      }
      if (isNaN(input.data.getTime())) {
        var _ctx5 = this._getOrReturnCtx(input);
        addIssueToContext(_ctx5, {
          code: ZodIssueCode.invalid_date
        });
        return INVALID;
      }
      var status = new ParseStatus();
      var ctx = undefined;
      var _iterator16 = _createForOfIteratorHelper(this._def.checks),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var check = _step16.value;
          if (check.kind === "min") {
            if (input.data.getTime() < check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                message: check.message,
                inclusive: true,
                minimum: check.value,
                type: "date"
              });
              status.dirty();
            }
          } else if (check.kind === "max") {
            if (input.data.getTime() > check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                message: check.message,
                inclusive: true,
                maximum: check.value,
                type: "date"
              });
              status.dirty();
            }
          } else {
            util.assertNever(check);
          }
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      return {
        status: status.value,
        value: new Date(input.data.getTime())
      };
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodDate(_objectSpread2(_objectSpread2({}, this._def), {}, {
        checks: [].concat(_toConsumableArray(this._def.checks), [check])
      }));
    }
  }, {
    key: "min",
    value: function min(minDate, message) {
      return this._addCheck({
        kind: "min",
        value: minDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "max",
    value: function max(maxDate, message) {
      return this._addCheck({
        kind: "max",
        value: maxDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "minDate",
    get: function get() {
      var min = null;
      var _iterator17 = _createForOfIteratorHelper(this._def.checks),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var ch = _step17.value;
          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      return min != null ? new Date(min) : null;
    }
  }, {
    key: "maxDate",
    get: function get() {
      var max = null;
      var _iterator18 = _createForOfIteratorHelper(this._def.checks),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var ch = _step18.value;
          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      return max != null ? new Date(max) : null;
    }
  }]);
  return ZodDate;
}(ZodType);
ZodDate.create = function (params) {
  return new ZodDate(_objectSpread2({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodDate
  }, processCreateParams(params)));
};
var ZodUndefined = function (_ZodType6) {
  _inherits(ZodUndefined, _ZodType6);
  var _super7 = _createSuper(ZodUndefined);
  function ZodUndefined() {
    _classCallCheck(this, ZodUndefined);
    return _super7.apply(this, arguments);
  }
  _createClass(ZodUndefined, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.undefined) {
        var ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.undefined,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  }]);
  return ZodUndefined;
}(ZodType);
ZodUndefined.create = function (params) {
  return new ZodUndefined(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodUndefined
  }, processCreateParams(params)));
};
var ZodNull = function (_ZodType7) {
  _inherits(ZodNull, _ZodType7);
  var _super8 = _createSuper(ZodNull);
  function ZodNull() {
    _classCallCheck(this, ZodNull);
    return _super8.apply(this, arguments);
  }
  _createClass(ZodNull, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType["null"]) {
        var ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType["null"],
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  }]);
  return ZodNull;
}(ZodType);
ZodNull.create = function (params) {
  return new ZodNull(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodNull
  }, processCreateParams(params)));
};
var ZodAny = function (_ZodType8) {
  _inherits(ZodAny, _ZodType8);
  var _super9 = _createSuper(ZodAny);
  function ZodAny() {
    var _this4;
    _classCallCheck(this, ZodAny);
    _this4 = _super9.apply(this, arguments);
    _this4._any = true;
    return _this4;
  }
  _createClass(ZodAny, [{
    key: "_parse",
    value: function _parse(input) {
      return OK(input.data);
    }
  }]);
  return ZodAny;
}(ZodType);
ZodAny.create = function (params) {
  return new ZodAny(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodAny
  }, processCreateParams(params)));
};
var ZodUnknown = function (_ZodType9) {
  _inherits(ZodUnknown, _ZodType9);
  var _super10 = _createSuper(ZodUnknown);
  function ZodUnknown() {
    var _this5;
    _classCallCheck(this, ZodUnknown);
    _this5 = _super10.apply(this, arguments);
    _this5._unknown = true;
    return _this5;
  }
  _createClass(ZodUnknown, [{
    key: "_parse",
    value: function _parse(input) {
      return OK(input.data);
    }
  }]);
  return ZodUnknown;
}(ZodType);
ZodUnknown.create = function (params) {
  return new ZodUnknown(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodUnknown
  }, processCreateParams(params)));
};
var ZodNever = function (_ZodType10) {
  _inherits(ZodNever, _ZodType10);
  var _super11 = _createSuper(ZodNever);
  function ZodNever() {
    _classCallCheck(this, ZodNever);
    return _super11.apply(this, arguments);
  }
  _createClass(ZodNever, [{
    key: "_parse",
    value: function _parse(input) {
      var ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.never,
        received: ctx.parsedType
      });
      return INVALID;
    }
  }]);
  return ZodNever;
}(ZodType);
ZodNever.create = function (params) {
  return new ZodNever(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodNever
  }, processCreateParams(params)));
};
var ZodVoid = function (_ZodType11) {
  _inherits(ZodVoid, _ZodType11);
  var _super12 = _createSuper(ZodVoid);
  function ZodVoid() {
    _classCallCheck(this, ZodVoid);
    return _super12.apply(this, arguments);
  }
  _createClass(ZodVoid, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.undefined) {
        var ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType["void"],
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  }]);
  return ZodVoid;
}(ZodType);
ZodVoid.create = function (params) {
  return new ZodVoid(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodVoid
  }, processCreateParams(params)));
};
var ZodArray = function (_ZodType12) {
  _inherits(ZodArray, _ZodType12);
  var _super13 = _createSuper(ZodArray);
  function ZodArray() {
    _classCallCheck(this, ZodArray);
    return _super13.apply(this, arguments);
  }
  _createClass(ZodArray, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa = this._processInputParams(input),
        ctx = _this$_processInputPa.ctx,
        status = _this$_processInputPa.status;
      var def = this._def;
      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }
      if (def.minLength !== null) {
        if (ctx.data.length < def.minLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minLength.value,
            type: "array",
            inclusive: true,
            message: def.minLength.message
          });
          status.dirty();
        }
      }
      if (def.maxLength !== null) {
        if (ctx.data.length > def.maxLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxLength.value,
            type: "array",
            inclusive: true,
            message: def.maxLength.message
          });
          status.dirty();
        }
      }
      if (ctx.common.async) {
        return Promise.all(ctx.data.map(function (item, i) {
          return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then(function (result) {
          return ParseStatus.mergeArray(status, result);
        });
      }
      var result = ctx.data.map(function (item, i) {
        return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      });
      return ParseStatus.mergeArray(status, result);
    }
  }, {
    key: "element",
    get: function get() {
      return this._def.type;
    }
  }, {
    key: "min",
    value: function min(minLength, message) {
      return new ZodArray(_objectSpread2(_objectSpread2({}, this._def), {}, {
        minLength: {
          value: minLength,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "max",
    value: function max(maxLength, message) {
      return new ZodArray(_objectSpread2(_objectSpread2({}, this._def), {}, {
        maxLength: {
          value: maxLength,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "length",
    value: function length(len, message) {
      return this.min(len, message).max(len, message);
    }
  }, {
    key: "nonempty",
    value: function nonempty(message) {
      return this.min(1, message);
    }
  }]);
  return ZodArray;
}(ZodType);
ZodArray.create = function (schema, params) {
  return new ZodArray(_objectSpread2({
    type: schema,
    minLength: null,
    maxLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray
  }, processCreateParams(params)));
};
var objectUtil;
(function (objectUtil) {
  objectUtil.mergeShapes = function (first, second) {
    return _objectSpread2(_objectSpread2({}, first), second);
  };
})(objectUtil || (objectUtil = {}));
var AugmentFactory = function AugmentFactory(def) {
  return function (augmentation) {
    return new ZodObject(_objectSpread2(_objectSpread2({}, def), {}, {
      shape: function shape() {
        return _objectSpread2(_objectSpread2({}, def.shape()), augmentation);
      }
    }));
  };
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    var newShape = {};
    for (var key in schema.shape) {
      var fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject(_objectSpread2(_objectSpread2({}, schema._def), {}, {
      shape: function shape() {
        return newShape;
      }
    }));
  } else if (schema instanceof ZodArray) {
    return ZodArray.create(deepPartialify(schema.element));
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map(function (item) {
      return deepPartialify(item);
    }));
  } else {
    return schema;
  }
}
var ZodObject = function (_ZodType13) {
  _inherits(ZodObject, _ZodType13);
  var _super14 = _createSuper(ZodObject);
  function ZodObject() {
    var _this6;
    _classCallCheck(this, ZodObject);
    _this6 = _super14.apply(this, arguments);
    _this6._cached = null;
    _this6.nonstrict = _this6.passthrough;
    _this6.augment = AugmentFactory(_this6._def);
    _this6.extend = AugmentFactory(_this6._def);
    return _this6;
  }
  _createClass(ZodObject, [{
    key: "_getCached",
    value: function _getCached() {
      if (this._cached !== null) return this._cached;
      var shape = this._def.shape();
      var keys = util.objectKeys(shape);
      return this._cached = {
        shape: shape,
        keys: keys
      };
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.object) {
        var _ctx6 = this._getOrReturnCtx(input);
        addIssueToContext(_ctx6, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: _ctx6.parsedType
        });
        return INVALID;
      }
      var _this$_processInputPa2 = this._processInputParams(input),
        status = _this$_processInputPa2.status,
        ctx = _this$_processInputPa2.ctx;
      var _this$_getCached = this._getCached(),
        shape = _this$_getCached.shape,
        shapeKeys = _this$_getCached.keys;
      var extraKeys = [];
      if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
        for (var key in ctx.data) {
          if (!shapeKeys.includes(key)) {
            extraKeys.push(key);
          }
        }
      }
      var pairs = [];
      var _iterator19 = _createForOfIteratorHelper(shapeKeys),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _key4 = _step19.value;
          var keyValidator = shape[_key4];
          var _value = ctx.data[_key4];
          pairs.push({
            key: {
              status: "valid",
              value: _key4
            },
            value: keyValidator._parse(new ParseInputLazyPath(ctx, _value, ctx.path, _key4)),
            alwaysSet: _key4 in ctx.data
          });
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      if (this._def.catchall instanceof ZodNever) {
        var unknownKeys = this._def.unknownKeys;
        if (unknownKeys === "passthrough") {
          var _iterator20 = _createForOfIteratorHelper(extraKeys),
            _step20;
          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var _key = _step20.value;
              pairs.push({
                key: {
                  status: "valid",
                  value: _key
                },
                value: {
                  status: "valid",
                  value: ctx.data[_key]
                }
              });
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        } else if (unknownKeys === "strict") {
          if (extraKeys.length > 0) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.unrecognized_keys,
              keys: extraKeys
            });
            status.dirty();
          }
        } else if (unknownKeys === "strip") ;else {
          throw new Error("Internal ZodObject error: invalid unknownKeys value.");
        }
      } else {
        var catchall = this._def.catchall;
        var _iterator21 = _createForOfIteratorHelper(extraKeys),
          _step21;
        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _key2 = _step21.value;
            var value = ctx.data[_key2];
            pairs.push({
              key: {
                status: "valid",
                value: _key2
              },
              value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, _key2)
              ),
              alwaysSet: _key2 in ctx.data
            });
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
      }
      if (ctx.common.async) {
        return Promise.resolve().then( _asyncToGenerator( _regeneratorRuntime().mark(function _callee4() {
          var syncPairs, _iterator22, _step22, pair, _key3;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                syncPairs = [];
                _iterator22 = _createForOfIteratorHelper(pairs);
                _context4.prev = 2;
                _iterator22.s();
              case 4:
                if ((_step22 = _iterator22.n()).done) {
                  _context4.next = 19;
                  break;
                }
                pair = _step22.value;
                _context4.next = 8;
                return pair.key;
              case 8:
                _key3 = _context4.sent;
                _context4.t0 = syncPairs;
                _context4.t1 = _key3;
                _context4.next = 13;
                return pair.value;
              case 13:
                _context4.t2 = _context4.sent;
                _context4.t3 = pair.alwaysSet;
                _context4.t4 = {
                  key: _context4.t1,
                  value: _context4.t2,
                  alwaysSet: _context4.t3
                };
                _context4.t0.push.call(_context4.t0, _context4.t4);
              case 17:
                _context4.next = 4;
                break;
              case 19:
                _context4.next = 24;
                break;
              case 21:
                _context4.prev = 21;
                _context4.t5 = _context4["catch"](2);
                _iterator22.e(_context4.t5);
              case 24:
                _context4.prev = 24;
                _iterator22.f();
                return _context4.finish(24);
              case 27:
                return _context4.abrupt("return", syncPairs);
              case 28:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[2, 21, 24, 27]]);
        }))).then(function (syncPairs) {
          return ParseStatus.mergeObjectSync(status, syncPairs);
        });
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
  }, {
    key: "shape",
    get: function get() {
      return this._def.shape();
    }
  }, {
    key: "strict",
    value: function strict(message) {
      var _this7 = this;
      errorUtil.errToObj;
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        unknownKeys: "strict"
      }, message !== undefined ? {
        errorMap: function errorMap(issue, ctx) {
          var _a, _b, _c, _d;
          var defaultError = (_c = (_b = (_a = _this7._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys") return {
            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
          };
          return {
            message: defaultError
          };
        }
      } : {}));
    }
  }, {
    key: "strip",
    value: function strip() {
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        unknownKeys: "strip"
      }));
    }
  }, {
    key: "passthrough",
    value: function passthrough() {
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        unknownKeys: "passthrough"
      }));
    }
  }, {
    key: "setKey",
    value: function setKey(key, schema) {
      return this.augment(_defineProperty({}, key, schema));
    }
  }, {
    key: "merge",
    value: function merge(merging) {
      var _this8 = this;
      var merged = new ZodObject({
        unknownKeys: merging._def.unknownKeys,
        catchall: merging._def.catchall,
        shape: function shape() {
          return objectUtil.mergeShapes(_this8._def.shape(), merging._def.shape());
        },
        typeName: ZodFirstPartyTypeKind.ZodObject
      });
      return merged;
    }
  }, {
    key: "catchall",
    value: function catchall(index) {
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        catchall: index
      }));
    }
  }, {
    key: "pick",
    value: function pick(mask) {
      var _this9 = this;
      var _shape = {};
      util.objectKeys(mask).map(function (key) {
        if (_this9.shape[key]) _shape[key] = _this9.shape[key];
      });
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        shape: function shape() {
          return _shape;
        }
      }));
    }
  }, {
    key: "omit",
    value: function omit(mask) {
      var _this10 = this;
      var _shape2 = {};
      util.objectKeys(this.shape).map(function (key) {
        if (util.objectKeys(mask).indexOf(key) === -1) {
          _shape2[key] = _this10.shape[key];
        }
      });
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        shape: function shape() {
          return _shape2;
        }
      }));
    }
  }, {
    key: "deepPartial",
    value: function deepPartial() {
      return deepPartialify(this);
    }
  }, {
    key: "partial",
    value: function partial(mask) {
      var _this11 = this;
      var newShape = {};
      if (mask) {
        util.objectKeys(this.shape).map(function (key) {
          if (util.objectKeys(mask).indexOf(key) === -1) {
            newShape[key] = _this11.shape[key];
          } else {
            newShape[key] = _this11.shape[key].optional();
          }
        });
        return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
          shape: function shape() {
            return newShape;
          }
        }));
      } else {
        for (var key in this.shape) {
          var fieldSchema = this.shape[key];
          newShape[key] = fieldSchema.optional();
        }
      }
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        shape: function shape() {
          return newShape;
        }
      }));
    }
  }, {
    key: "required",
    value: function required() {
      var newShape = {};
      for (var key in this.shape) {
        var fieldSchema = this.shape[key];
        var newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
      return new ZodObject(_objectSpread2(_objectSpread2({}, this._def), {}, {
        shape: function shape() {
          return newShape;
        }
      }));
    }
  }, {
    key: "keyof",
    value: function keyof() {
      return createZodEnum(util.objectKeys(this.shape));
    }
  }]);
  return ZodObject;
}(ZodType);
ZodObject.create = function (_shape3, params) {
  return new ZodObject(_objectSpread2({
    shape: function shape() {
      return _shape3;
    },
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.strictCreate = function (_shape4, params) {
  return new ZodObject(_objectSpread2({
    shape: function shape() {
      return _shape4;
    },
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.lazycreate = function (shape, params) {
  return new ZodObject(_objectSpread2({
    shape: shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
var ZodUnion = function (_ZodType14) {
  _inherits(ZodUnion, _ZodType14);
  var _super15 = _createSuper(ZodUnion);
  function ZodUnion() {
    _classCallCheck(this, ZodUnion);
    return _super15.apply(this, arguments);
  }
  _createClass(ZodUnion, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa3 = this._processInputParams(input),
        ctx = _this$_processInputPa3.ctx;
      var options = this._def.options;
      function handleResults(results) {
        var _iterator23 = _createForOfIteratorHelper(results),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var result = _step23.value;
            if (result.result.status === "valid") {
              return result.result;
            }
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
        var _iterator24 = _createForOfIteratorHelper(results),
          _step24;
        try {
          for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
            var _result = _step24.value;
            if (_result.result.status === "dirty") {
              var _ctx$common$issues;
              (_ctx$common$issues = ctx.common.issues).push.apply(_ctx$common$issues, _toConsumableArray(_result.ctx.common.issues));
              return _result.result;
            }
          }
        } catch (err) {
          _iterator24.e(err);
        } finally {
          _iterator24.f();
        }
        var unionErrors = results.map(function (result) {
          return new ZodError(result.ctx.common.issues);
        });
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors: unionErrors
        });
        return INVALID;
      }
      if (ctx.common.async) {
        return Promise.all(options.map( function () {
          var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee5(option) {
            var childCtx;
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  childCtx = _objectSpread2(_objectSpread2({}, ctx), {}, {
                    common: _objectSpread2(_objectSpread2({}, ctx.common), {}, {
                      issues: []
                    }),
                    parent: null
                  });
                  _context5.next = 3;
                  return option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                  });
                case 3:
                  _context5.t0 = _context5.sent;
                  _context5.t1 = childCtx;
                  return _context5.abrupt("return", {
                    result: _context5.t0,
                    ctx: _context5.t1
                  });
                case 6:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          return function (_x8) {
            return _ref2.apply(this, arguments);
          };
        }())).then(handleResults);
      } else {
        var dirty = undefined;
        var issues = [];
        var _iterator25 = _createForOfIteratorHelper(options),
          _step25;
        try {
          for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
            var option = _step25.value;
            var childCtx = _objectSpread2(_objectSpread2({}, ctx), {}, {
              common: _objectSpread2(_objectSpread2({}, ctx.common), {}, {
                issues: []
              }),
              parent: null
            });
            var result = option._parseSync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx
            });
            if (result.status === "valid") {
              return result;
            } else if (result.status === "dirty" && !dirty) {
              dirty = {
                result: result,
                ctx: childCtx
              };
            }
            if (childCtx.common.issues.length) {
              issues.push(childCtx.common.issues);
            }
          }
        } catch (err) {
          _iterator25.e(err);
        } finally {
          _iterator25.f();
        }
        if (dirty) {
          var _ctx$common$issues2;
          (_ctx$common$issues2 = ctx.common.issues).push.apply(_ctx$common$issues2, _toConsumableArray(dirty.ctx.common.issues));
          return dirty.result;
        }
        var unionErrors = issues.map(function (issues) {
          return new ZodError(issues);
        });
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors: unionErrors
        });
        return INVALID;
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.options;
    }
  }]);
  return ZodUnion;
}(ZodType);
ZodUnion.create = function (types, params) {
  return new ZodUnion(_objectSpread2({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion
  }, processCreateParams(params)));
};
var ZodDiscriminatedUnion = function (_ZodType15) {
  _inherits(ZodDiscriminatedUnion, _ZodType15);
  var _super16 = _createSuper(ZodDiscriminatedUnion);
  function ZodDiscriminatedUnion() {
    _classCallCheck(this, ZodDiscriminatedUnion);
    return _super16.apply(this, arguments);
  }
  _createClass(ZodDiscriminatedUnion, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa4 = this._processInputParams(input),
        ctx = _this$_processInputPa4.ctx;
      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }
      var discriminator = this.discriminator;
      var discriminatorValue = ctx.data[discriminator];
      var option = this.options.get(discriminatorValue);
      if (!option) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union_discriminator,
          options: this.validDiscriminatorValues,
          path: [discriminator]
        });
        return INVALID;
      }
      if (ctx.common.async) {
        return option._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      } else {
        return option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }, {
    key: "discriminator",
    get: function get() {
      return this._def.discriminator;
    }
  }, {
    key: "validDiscriminatorValues",
    get: function get() {
      return Array.from(this.options.keys());
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.options;
    }
  }], [{
    key: "create",
    value: function create(discriminator, types, params) {
      var options = new Map();
      try {
        types.forEach(function (type) {
          var discriminatorValue = type.shape[discriminator].value;
          options.set(discriminatorValue, type);
        });
      } catch (e) {
        throw new Error("The discriminator value could not be extracted from all the provided schemas");
      }
      if (options.size !== types.length) {
        throw new Error("Some of the discriminator values are not unique");
      }
      return new ZodDiscriminatedUnion(_objectSpread2({
        typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
        discriminator: discriminator,
        options: options
      }, processCreateParams(params)));
    }
  }]);
  return ZodDiscriminatedUnion;
}(ZodType);
function mergeValues(a, b) {
  var aType = getParsedType(a);
  var bType = getParsedType(b);
  if (a === b) {
    return {
      valid: true,
      data: a
    };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    var bKeys = util.objectKeys(b);
    var sharedKeys = util.objectKeys(a).filter(function (key) {
      return bKeys.indexOf(key) !== -1;
    });
    var newObj = _objectSpread2(_objectSpread2({}, a), b);
    var _iterator26 = _createForOfIteratorHelper(sharedKeys),
      _step26;
    try {
      for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
        var key = _step26.value;
        var sharedValue = mergeValues(a[key], b[key]);
        if (!sharedValue.valid) {
          return {
            valid: false
          };
        }
        newObj[key] = sharedValue.data;
      }
    } catch (err) {
      _iterator26.e(err);
    } finally {
      _iterator26.f();
    }
    return {
      valid: true,
      data: newObj
    };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return {
        valid: false
      };
    }
    var newArray = [];
    for (var index = 0; index < a.length; index++) {
      var itemA = a[index];
      var itemB = b[index];
      var _sharedValue = mergeValues(itemA, itemB);
      if (!_sharedValue.valid) {
        return {
          valid: false
        };
      }
      newArray.push(_sharedValue.data);
    }
    return {
      valid: true,
      data: newArray
    };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return {
      valid: true,
      data: a
    };
  } else {
    return {
      valid: false
    };
  }
}
var ZodIntersection = function (_ZodType16) {
  _inherits(ZodIntersection, _ZodType16);
  var _super17 = _createSuper(ZodIntersection);
  function ZodIntersection() {
    _classCallCheck(this, ZodIntersection);
    return _super17.apply(this, arguments);
  }
  _createClass(ZodIntersection, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa5 = this._processInputParams(input),
        status = _this$_processInputPa5.status,
        ctx = _this$_processInputPa5.ctx;
      var handleParsed = function handleParsed(parsedLeft, parsedRight) {
        if (isAborted(parsedLeft) || isAborted(parsedRight)) {
          return INVALID;
        }
        var merged = mergeValues(parsedLeft.value, parsedRight.value);
        if (!merged.valid) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_intersection_types
          });
          return INVALID;
        }
        if (isDirty(parsedLeft) || isDirty(parsedRight)) {
          status.dirty();
        }
        return {
          status: status.value,
          value: merged.data
        };
      };
      if (ctx.common.async) {
        return Promise.all([this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })]).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            left = _ref4[0],
            right = _ref4[1];
          return handleParsed(left, right);
        });
      } else {
        return handleParsed(this._def.left._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }));
      }
    }
  }]);
  return ZodIntersection;
}(ZodType);
ZodIntersection.create = function (left, right, params) {
  return new ZodIntersection(_objectSpread2({
    left: left,
    right: right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection
  }, processCreateParams(params)));
};
var ZodTuple = function (_ZodType17) {
  _inherits(ZodTuple, _ZodType17);
  var _super18 = _createSuper(ZodTuple);
  function ZodTuple() {
    _classCallCheck(this, ZodTuple);
    return _super18.apply(this, arguments);
  }
  _createClass(ZodTuple, [{
    key: "_parse",
    value: function _parse(input) {
      var _this12 = this;
      var _this$_processInputPa6 = this._processInputParams(input),
        status = _this$_processInputPa6.status,
        ctx = _this$_processInputPa6.ctx;
      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }
      if (ctx.data.length < this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: this._def.items.length,
          inclusive: true,
          type: "array"
        });
        return INVALID;
      }
      var rest = this._def.rest;
      if (!rest && ctx.data.length > this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: this._def.items.length,
          inclusive: true,
          type: "array"
        });
        status.dirty();
      }
      var items = ctx.data.map(function (item, itemIndex) {
        var schema = _this12._def.items[itemIndex] || _this12._def.rest;
        if (!schema) return null;
        return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
      }).filter(function (x) {
        return !!x;
      });
      if (ctx.common.async) {
        return Promise.all(items).then(function (results) {
          return ParseStatus.mergeArray(status, results);
        });
      } else {
        return ParseStatus.mergeArray(status, items);
      }
    }
  }, {
    key: "items",
    get: function get() {
      return this._def.items;
    }
  }, {
    key: "rest",
    value: function rest(_rest) {
      return new ZodTuple(_objectSpread2(_objectSpread2({}, this._def), {}, {
        rest: _rest
      }));
    }
  }]);
  return ZodTuple;
}(ZodType);
ZodTuple.create = function (schemas, params) {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple(_objectSpread2({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null
  }, processCreateParams(params)));
};
var ZodRecord = function (_ZodType18) {
  _inherits(ZodRecord, _ZodType18);
  var _super19 = _createSuper(ZodRecord);
  function ZodRecord() {
    _classCallCheck(this, ZodRecord);
    return _super19.apply(this, arguments);
  }
  _createClass(ZodRecord, [{
    key: "keySchema",
    get: function get() {
      return this._def.keyType;
    }
  }, {
    key: "valueSchema",
    get: function get() {
      return this._def.valueType;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa7 = this._processInputParams(input),
        status = _this$_processInputPa7.status,
        ctx = _this$_processInputPa7.ctx;
      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }
      var pairs = [];
      var keyType = this._def.keyType;
      var valueType = this._def.valueType;
      for (var key in ctx.data) {
        pairs.push({
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
          value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
      }
      if (ctx.common.async) {
        return ParseStatus.mergeObjectAsync(status, pairs);
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
  }, {
    key: "element",
    get: function get() {
      return this._def.valueType;
    }
  }], [{
    key: "create",
    value: function create(first, second, third) {
      if (second instanceof ZodType) {
        return new ZodRecord(_objectSpread2({
          keyType: first,
          valueType: second,
          typeName: ZodFirstPartyTypeKind.ZodRecord
        }, processCreateParams(third)));
      }
      return new ZodRecord(_objectSpread2({
        keyType: ZodString.create(),
        valueType: first,
        typeName: ZodFirstPartyTypeKind.ZodRecord
      }, processCreateParams(second)));
    }
  }]);
  return ZodRecord;
}(ZodType);
var ZodMap = function (_ZodType19) {
  _inherits(ZodMap, _ZodType19);
  var _super20 = _createSuper(ZodMap);
  function ZodMap() {
    _classCallCheck(this, ZodMap);
    return _super20.apply(this, arguments);
  }
  _createClass(ZodMap, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa8 = this._processInputParams(input),
        status = _this$_processInputPa8.status,
        ctx = _this$_processInputPa8.ctx;
      if (ctx.parsedType !== ZodParsedType.map) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.map,
          received: ctx.parsedType
        });
        return INVALID;
      }
      var keyType = this._def.keyType;
      var valueType = this._def.valueType;
      var pairs = _toConsumableArray(ctx.data.entries()).map(function (_ref5, index) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return {
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
          value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
        };
      });
      if (ctx.common.async) {
        var finalMap = new Map();
        return Promise.resolve().then( _asyncToGenerator( _regeneratorRuntime().mark(function _callee6() {
          var _iterator27, _step27, pair, key, value;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _iterator27 = _createForOfIteratorHelper(pairs);
                _context6.prev = 1;
                _iterator27.s();
              case 3:
                if ((_step27 = _iterator27.n()).done) {
                  _context6.next = 17;
                  break;
                }
                pair = _step27.value;
                _context6.next = 7;
                return pair.key;
              case 7:
                key = _context6.sent;
                _context6.next = 10;
                return pair.value;
              case 10:
                value = _context6.sent;
                if (!(key.status === "aborted" || value.status === "aborted")) {
                  _context6.next = 13;
                  break;
                }
                return _context6.abrupt("return", INVALID);
              case 13:
                if (key.status === "dirty" || value.status === "dirty") {
                  status.dirty();
                }
                finalMap.set(key.value, value.value);
              case 15:
                _context6.next = 3;
                break;
              case 17:
                _context6.next = 22;
                break;
              case 19:
                _context6.prev = 19;
                _context6.t0 = _context6["catch"](1);
                _iterator27.e(_context6.t0);
              case 22:
                _context6.prev = 22;
                _iterator27.f();
                return _context6.finish(22);
              case 25:
                return _context6.abrupt("return", {
                  status: status.value,
                  value: finalMap
                });
              case 26:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[1, 19, 22, 25]]);
        })));
      } else {
        var _finalMap = new Map();
        var _iterator28 = _createForOfIteratorHelper(pairs),
          _step28;
        try {
          for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
            var pair = _step28.value;
            var key = pair.key;
            var value = pair.value;
            if (key.status === "aborted" || value.status === "aborted") {
              return INVALID;
            }
            if (key.status === "dirty" || value.status === "dirty") {
              status.dirty();
            }
            _finalMap.set(key.value, value.value);
          }
        } catch (err) {
          _iterator28.e(err);
        } finally {
          _iterator28.f();
        }
        return {
          status: status.value,
          value: _finalMap
        };
      }
    }
  }]);
  return ZodMap;
}(ZodType);
ZodMap.create = function (keyType, valueType, params) {
  return new ZodMap(_objectSpread2({
    valueType: valueType,
    keyType: keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap
  }, processCreateParams(params)));
};
var ZodSet = function (_ZodType20) {
  _inherits(ZodSet, _ZodType20);
  var _super21 = _createSuper(ZodSet);
  function ZodSet() {
    _classCallCheck(this, ZodSet);
    return _super21.apply(this, arguments);
  }
  _createClass(ZodSet, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa9 = this._processInputParams(input),
        status = _this$_processInputPa9.status,
        ctx = _this$_processInputPa9.ctx;
      if (ctx.parsedType !== ZodParsedType.set) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.set,
          received: ctx.parsedType
        });
        return INVALID;
      }
      var def = this._def;
      if (def.minSize !== null) {
        if (ctx.data.size < def.minSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minSize.value,
            type: "set",
            inclusive: true,
            message: def.minSize.message
          });
          status.dirty();
        }
      }
      if (def.maxSize !== null) {
        if (ctx.data.size > def.maxSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxSize.value,
            type: "set",
            inclusive: true,
            message: def.maxSize.message
          });
          status.dirty();
        }
      }
      var valueType = this._def.valueType;
      function finalizeSet(elements) {
        var parsedSet = new Set();
        var _iterator29 = _createForOfIteratorHelper(elements),
          _step29;
        try {
          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
            var element = _step29.value;
            if (element.status === "aborted") return INVALID;
            if (element.status === "dirty") status.dirty();
            parsedSet.add(element.value);
          }
        } catch (err) {
          _iterator29.e(err);
        } finally {
          _iterator29.f();
        }
        return {
          status: status.value,
          value: parsedSet
        };
      }
      var elements = _toConsumableArray(ctx.data.values()).map(function (item, i) {
        return valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i));
      });
      if (ctx.common.async) {
        return Promise.all(elements).then(function (elements) {
          return finalizeSet(elements);
        });
      } else {
        return finalizeSet(elements);
      }
    }
  }, {
    key: "min",
    value: function min(minSize, message) {
      return new ZodSet(_objectSpread2(_objectSpread2({}, this._def), {}, {
        minSize: {
          value: minSize,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "max",
    value: function max(maxSize, message) {
      return new ZodSet(_objectSpread2(_objectSpread2({}, this._def), {}, {
        maxSize: {
          value: maxSize,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "size",
    value: function size(_size, message) {
      return this.min(_size, message).max(_size, message);
    }
  }, {
    key: "nonempty",
    value: function nonempty(message) {
      return this.min(1, message);
    }
  }]);
  return ZodSet;
}(ZodType);
ZodSet.create = function (valueType, params) {
  return new ZodSet(_objectSpread2({
    valueType: valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet
  }, processCreateParams(params)));
};
var ZodFunction = function (_ZodType21) {
  _inherits(ZodFunction, _ZodType21);
  var _super22 = _createSuper(ZodFunction);
  function ZodFunction() {
    var _this13;
    _classCallCheck(this, ZodFunction);
    _this13 = _super22.apply(this, arguments);
    _this13.validate = _this13.implement;
    return _this13;
  }
  _createClass(ZodFunction, [{
    key: "_parse",
    value: function _parse(input) {
      var _this14 = this;
      var _this$_processInputPa10 = this._processInputParams(input),
        ctx = _this$_processInputPa10.ctx;
      if (ctx.parsedType !== ZodParsedType["function"]) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType["function"],
          received: ctx.parsedType
        });
        return INVALID;
      }
      function makeArgsIssue(args, error) {
        return makeIssue({
          data: args,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), errorMap].filter(function (x) {
            return !!x;
          }),
          issueData: {
            code: ZodIssueCode.invalid_arguments,
            argumentsError: error
          }
        });
      }
      function makeReturnsIssue(returns, error) {
        return makeIssue({
          data: returns,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), errorMap].filter(function (x) {
            return !!x;
          }),
          issueData: {
            code: ZodIssueCode.invalid_return_type,
            returnTypeError: error
          }
        });
      }
      var params = {
        errorMap: ctx.common.contextualErrorMap
      };
      var fn = ctx.data;
      if (this._def.returns instanceof ZodPromise) {
        return OK( _asyncToGenerator( _regeneratorRuntime().mark(function _callee7() {
          var _len,
            args,
            _key5,
            error,
            parsedArgs,
            result,
            parsedReturns,
            _args7 = arguments;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                for (_len = _args7.length, args = new Array(_len), _key5 = 0; _key5 < _len; _key5++) {
                  args[_key5] = _args7[_key5];
                }
                error = new ZodError([]);
                _context7.next = 4;
                return _this14._def.args.parseAsync(args, params)["catch"](function (e) {
                  error.addIssue(makeArgsIssue(args, e));
                  throw error;
                });
              case 4:
                parsedArgs = _context7.sent;
                _context7.next = 7;
                return fn.apply(void 0, _toConsumableArray(parsedArgs));
              case 7:
                result = _context7.sent;
                _context7.next = 10;
                return _this14._def.returns._def.type.parseAsync(result, params)["catch"](function (e) {
                  error.addIssue(makeReturnsIssue(result, e));
                  throw error;
                });
              case 10:
                parsedReturns = _context7.sent;
                return _context7.abrupt("return", parsedReturns);
              case 12:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        })));
      } else {
        return OK(function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key6 = 0; _key6 < _len2; _key6++) {
            args[_key6] = arguments[_key6];
          }
          var parsedArgs = _this14._def.args.safeParse(args, params);
          if (!parsedArgs.success) {
            throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
          }
          var result = fn.apply(void 0, _toConsumableArray(parsedArgs.data));
          var parsedReturns = _this14._def.returns.safeParse(result, params);
          if (!parsedReturns.success) {
            throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
          }
          return parsedReturns.data;
        });
      }
    }
  }, {
    key: "parameters",
    value: function parameters() {
      return this._def.args;
    }
  }, {
    key: "returnType",
    value: function returnType() {
      return this._def.returns;
    }
  }, {
    key: "args",
    value: function args() {
      for (var _len3 = arguments.length, items = new Array(_len3), _key7 = 0; _key7 < _len3; _key7++) {
        items[_key7] = arguments[_key7];
      }
      return new ZodFunction(_objectSpread2(_objectSpread2({}, this._def), {}, {
        args: ZodTuple.create(items).rest(ZodUnknown.create())
      }));
    }
  }, {
    key: "returns",
    value: function returns(returnType) {
      return new ZodFunction(_objectSpread2(_objectSpread2({}, this._def), {}, {
        returns: returnType
      }));
    }
  }, {
    key: "implement",
    value: function implement(func) {
      var validatedFunc = this.parse(func);
      return validatedFunc;
    }
  }, {
    key: "strictImplement",
    value: function strictImplement(func) {
      var validatedFunc = this.parse(func);
      return validatedFunc;
    }
  }], [{
    key: "create",
    value: function create(args, returns, params) {
      return new ZodFunction(_objectSpread2({
        args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
        returns: returns || ZodUnknown.create(),
        typeName: ZodFirstPartyTypeKind.ZodFunction
      }, processCreateParams(params)));
    }
  }]);
  return ZodFunction;
}(ZodType);
var ZodLazy = function (_ZodType22) {
  _inherits(ZodLazy, _ZodType22);
  var _super23 = _createSuper(ZodLazy);
  function ZodLazy() {
    _classCallCheck(this, ZodLazy);
    return _super23.apply(this, arguments);
  }
  _createClass(ZodLazy, [{
    key: "schema",
    get: function get() {
      return this._def.getter();
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa11 = this._processInputParams(input),
        ctx = _this$_processInputPa11.ctx;
      var lazySchema = this._def.getter();
      return lazySchema._parse({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }]);
  return ZodLazy;
}(ZodType);
ZodLazy.create = function (getter, params) {
  return new ZodLazy(_objectSpread2({
    getter: getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy
  }, processCreateParams(params)));
};
var ZodLiteral = function (_ZodType23) {
  _inherits(ZodLiteral, _ZodType23);
  var _super24 = _createSuper(ZodLiteral);
  function ZodLiteral() {
    _classCallCheck(this, ZodLiteral);
    return _super24.apply(this, arguments);
  }
  _createClass(ZodLiteral, [{
    key: "_parse",
    value: function _parse(input) {
      if (input.data !== this._def.value) {
        var ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_literal,
          expected: this._def.value
        });
        return INVALID;
      }
      return {
        status: "valid",
        value: input.data
      };
    }
  }, {
    key: "value",
    get: function get() {
      return this._def.value;
    }
  }]);
  return ZodLiteral;
}(ZodType);
ZodLiteral.create = function (value, params) {
  return new ZodLiteral(_objectSpread2({
    value: value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral
  }, processCreateParams(params)));
};
function createZodEnum(values, params) {
  return new ZodEnum(_objectSpread2({
    values: values,
    typeName: ZodFirstPartyTypeKind.ZodEnum
  }, processCreateParams(params)));
}
var ZodEnum = function (_ZodType24) {
  _inherits(ZodEnum, _ZodType24);
  var _super25 = _createSuper(ZodEnum);
  function ZodEnum() {
    _classCallCheck(this, ZodEnum);
    return _super25.apply(this, arguments);
  }
  _createClass(ZodEnum, [{
    key: "_parse",
    value: function _parse(input) {
      if (typeof input.data !== "string") {
        var ctx = this._getOrReturnCtx(input);
        var expectedValues = this._def.values;
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }
      if (this._def.values.indexOf(input.data) === -1) {
        var _ctx7 = this._getOrReturnCtx(input);
        var _expectedValues = this._def.values;
        addIssueToContext(_ctx7, {
          received: _ctx7.data,
          code: ZodIssueCode.invalid_enum_value,
          options: _expectedValues
        });
        return INVALID;
      }
      return OK(input.data);
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.values;
    }
  }, {
    key: "enum",
    get: function get() {
      var enumValues = {};
      var _iterator30 = _createForOfIteratorHelper(this._def.values),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var val = _step30.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      return enumValues;
    }
  }, {
    key: "Values",
    get: function get() {
      var enumValues = {};
      var _iterator31 = _createForOfIteratorHelper(this._def.values),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var val = _step31.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      return enumValues;
    }
  }, {
    key: "Enum",
    get: function get() {
      var enumValues = {};
      var _iterator32 = _createForOfIteratorHelper(this._def.values),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var val = _step32.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      return enumValues;
    }
  }]);
  return ZodEnum;
}(ZodType);
ZodEnum.create = createZodEnum;
var ZodNativeEnum = function (_ZodType25) {
  _inherits(ZodNativeEnum, _ZodType25);
  var _super26 = _createSuper(ZodNativeEnum);
  function ZodNativeEnum() {
    _classCallCheck(this, ZodNativeEnum);
    return _super26.apply(this, arguments);
  }
  _createClass(ZodNativeEnum, [{
    key: "_parse",
    value: function _parse(input) {
      var nativeEnumValues = util.getValidEnumValues(this._def.values);
      var ctx = this._getOrReturnCtx(input);
      if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
        var expectedValues = util.objectValues(nativeEnumValues);
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }
      if (nativeEnumValues.indexOf(input.data) === -1) {
        var _expectedValues2 = util.objectValues(nativeEnumValues);
        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_enum_value,
          options: _expectedValues2
        });
        return INVALID;
      }
      return OK(input.data);
    }
  }, {
    key: "enum",
    get: function get() {
      return this._def.values;
    }
  }]);
  return ZodNativeEnum;
}(ZodType);
ZodNativeEnum.create = function (values, params) {
  return new ZodNativeEnum(_objectSpread2({
    values: values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum
  }, processCreateParams(params)));
};
var ZodPromise = function (_ZodType26) {
  _inherits(ZodPromise, _ZodType26);
  var _super27 = _createSuper(ZodPromise);
  function ZodPromise() {
    _classCallCheck(this, ZodPromise);
    return _super27.apply(this, arguments);
  }
  _createClass(ZodPromise, [{
    key: "_parse",
    value: function _parse(input) {
      var _this15 = this;
      var _this$_processInputPa12 = this._processInputParams(input),
        ctx = _this$_processInputPa12.ctx;
      if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.promise,
          received: ctx.parsedType
        });
        return INVALID;
      }
      var promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
      return OK(promisified.then(function (data) {
        return _this15._def.type.parseAsync(data, {
          path: ctx.path,
          errorMap: ctx.common.contextualErrorMap
        });
      }));
    }
  }]);
  return ZodPromise;
}(ZodType);
ZodPromise.create = function (schema, params) {
  return new ZodPromise(_objectSpread2({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise
  }, processCreateParams(params)));
};
var ZodEffects = function (_ZodType27) {
  _inherits(ZodEffects, _ZodType27);
  var _super28 = _createSuper(ZodEffects);
  function ZodEffects() {
    _classCallCheck(this, ZodEffects);
    return _super28.apply(this, arguments);
  }
  _createClass(ZodEffects, [{
    key: "innerType",
    value: function innerType() {
      return this._def.schema;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this16 = this;
      var _this$_processInputPa13 = this._processInputParams(input),
        status = _this$_processInputPa13.status,
        ctx = _this$_processInputPa13.ctx;
      var effect = this._def.effect || null;
      if (effect.type === "preprocess") {
        var processed = effect.transform(ctx.data);
        if (ctx.common.async) {
          return Promise.resolve(processed).then(function (processed) {
            return _this16._def.schema._parseAsync({
              data: processed,
              path: ctx.path,
              parent: ctx
            });
          });
        } else {
          return this._def.schema._parseSync({
            data: processed,
            path: ctx.path,
            parent: ctx
          });
        }
      }
      var checkCtx = {
        addIssue: function addIssue(arg) {
          addIssueToContext(ctx, arg);
          if (arg.fatal) {
            status.abort();
          } else {
            status.dirty();
          }
        },
        get path() {
          return ctx.path;
        }
      };
      checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
      if (effect.type === "refinement") {
        var executeRefinement = function executeRefinement(acc
        ) {
          var result = effect.refinement(acc, checkCtx);
          if (ctx.common.async) {
            return Promise.resolve(result);
          }
          if (result instanceof Promise) {
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          }
          return acc;
        };
        if (ctx.common.async === false) {
          var inner = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inner.status === "aborted") return INVALID;
          if (inner.status === "dirty") status.dirty();
          executeRefinement(inner.value);
          return {
            status: status.value,
            value: inner.value
          };
        } else {
          return this._def.schema._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }).then(function (inner) {
            if (inner.status === "aborted") return INVALID;
            if (inner.status === "dirty") status.dirty();
            return executeRefinement(inner.value).then(function () {
              return {
                status: status.value,
                value: inner.value
              };
            });
          });
        }
      }
      if (effect.type === "transform") {
        if (ctx.common.async === false) {
          var base = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (!isValid(base)) return base;
          var result = effect.transform(base.value, checkCtx);
          if (result instanceof Promise) {
            throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
          }
          return {
            status: status.value,
            value: result
          };
        } else {
          return this._def.schema._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }).then(function (base) {
            if (!isValid(base)) return base;
            return Promise.resolve(effect.transform(base.value, checkCtx)).then(function (result) {
              return {
                status: status.value,
                value: result
              };
            });
          });
        }
      }
      util.assertNever(effect);
    }
  }]);
  return ZodEffects;
}(ZodType);
ZodEffects.create = function (schema, effect, params) {
  return new ZodEffects(_objectSpread2({
    schema: schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect: effect
  }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = function (preprocess, schema, params) {
  return new ZodEffects(_objectSpread2({
    schema: schema,
    effect: {
      type: "preprocess",
      transform: preprocess
    },
    typeName: ZodFirstPartyTypeKind.ZodEffects
  }, processCreateParams(params)));
};
var ZodOptional = function (_ZodType28) {
  _inherits(ZodOptional, _ZodType28);
  var _super29 = _createSuper(ZodOptional);
  function ZodOptional() {
    _classCallCheck(this, ZodOptional);
    return _super29.apply(this, arguments);
  }
  _createClass(ZodOptional, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType === ZodParsedType.undefined) {
        return OK(undefined);
      }
      return this._def.innerType._parse(input);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.innerType;
    }
  }]);
  return ZodOptional;
}(ZodType);
ZodOptional.create = function (type, params) {
  return new ZodOptional(_objectSpread2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};
var ZodNullable = function (_ZodType29) {
  _inherits(ZodNullable, _ZodType29);
  var _super30 = _createSuper(ZodNullable);
  function ZodNullable() {
    _classCallCheck(this, ZodNullable);
    return _super30.apply(this, arguments);
  }
  _createClass(ZodNullable, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType === ZodParsedType["null"]) {
        return OK(null);
      }
      return this._def.innerType._parse(input);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.innerType;
    }
  }]);
  return ZodNullable;
}(ZodType);
ZodNullable.create = function (type, params) {
  return new ZodNullable(_objectSpread2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable
  }, processCreateParams(params)));
};
var ZodDefault = function (_ZodType30) {
  _inherits(ZodDefault, _ZodType30);
  var _super31 = _createSuper(ZodDefault);
  function ZodDefault() {
    _classCallCheck(this, ZodDefault);
    return _super31.apply(this, arguments);
  }
  _createClass(ZodDefault, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa14 = this._processInputParams(input),
        ctx = _this$_processInputPa14.ctx;
      var data = ctx.data;
      if (ctx.parsedType === ZodParsedType.undefined) {
        data = this._def.defaultValue();
      }
      return this._def.innerType._parse({
        data: data,
        path: ctx.path,
        parent: ctx
      });
    }
  }, {
    key: "removeDefault",
    value: function removeDefault() {
      return this._def.innerType;
    }
  }]);
  return ZodDefault;
}(ZodType);
ZodDefault.create = function (type, params) {
  return new ZodOptional(_objectSpread2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};
var ZodNaN = function (_ZodType31) {
  _inherits(ZodNaN, _ZodType31);
  var _super32 = _createSuper(ZodNaN);
  function ZodNaN() {
    _classCallCheck(this, ZodNaN);
    return _super32.apply(this, arguments);
  }
  _createClass(ZodNaN, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.nan) {
        var ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.nan,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return {
        status: "valid",
        value: input.data
      };
    }
  }]);
  return ZodNaN;
}(ZodType);
ZodNaN.create = function (params) {
  return new ZodNaN(_objectSpread2({
    typeName: ZodFirstPartyTypeKind.ZodNaN
  }, processCreateParams(params)));
};
var BRAND = Symbol("zod_brand");
var ZodBranded = function (_ZodType32) {
  _inherits(ZodBranded, _ZodType32);
  var _super33 = _createSuper(ZodBranded);
  function ZodBranded() {
    _classCallCheck(this, ZodBranded);
    return _super33.apply(this, arguments);
  }
  _createClass(ZodBranded, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa15 = this._processInputParams(input),
        ctx = _this$_processInputPa15.ctx;
      var data = ctx.data;
      return this._def.type._parse({
        data: data,
        path: ctx.path,
        parent: ctx
      });
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.type;
    }
  }]);
  return ZodBranded;
}(ZodType);
var custom = function custom(check) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fatal = arguments.length > 2 ? arguments[2] : undefined;
  if (check) return ZodAny.create().superRefine(function (data, ctx) {
    if (!check(data)) {
      var p = typeof params === "function" ? params(data) : params;
      var p2 = typeof p === "string" ? {
        message: p
      } : p;
      ctx.addIssue(_objectSpread2(_objectSpread2({
        code: "custom"
      }, p2), {}, {
        fatal: fatal
      }));
    }
  });
  return ZodAny.create();
};
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
  ZodFirstPartyTypeKind["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = function instanceOfType(cls) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    message: "Input not instance of ".concat(cls.name)
  };
  return custom(function (data) {
    return data instanceof cls;
  }, params, true);
};
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var ostring = function ostring() {
  return stringType().optional();
};
var onumber = function onumber() {
  return numberType().optional();
};
var oboolean = function oboolean() {
  return booleanType().optional();
};
var NEVER = INVALID;
var mod = Object.freeze({
  __proto__: null,
  getParsedType: getParsedType,
  ZodParsedType: ZodParsedType,
  defaultErrorMap: errorMap,
  setErrorMap: setErrorMap,
  getErrorMap: getErrorMap,
  makeIssue: makeIssue,
  EMPTY_PATH: EMPTY_PATH,
  addIssueToContext: addIssueToContext,
  ParseStatus: ParseStatus,
  INVALID: INVALID,
  DIRTY: DIRTY,
  OK: OK,
  isAborted: isAborted,
  isDirty: isDirty,
  isValid: isValid,
  isAsync: isAsync,
  ZodType: ZodType,
  ZodString: ZodString,
  ZodNumber: ZodNumber,
  ZodBigInt: ZodBigInt,
  ZodBoolean: ZodBoolean,
  ZodDate: ZodDate,
  ZodUndefined: ZodUndefined,
  ZodNull: ZodNull,
  ZodAny: ZodAny,
  ZodUnknown: ZodUnknown,
  ZodNever: ZodNever,
  ZodVoid: ZodVoid,
  ZodArray: ZodArray,
  get objectUtil() {
    return objectUtil;
  },
  ZodObject: ZodObject,
  ZodUnion: ZodUnion,
  ZodDiscriminatedUnion: ZodDiscriminatedUnion,
  ZodIntersection: ZodIntersection,
  ZodTuple: ZodTuple,
  ZodRecord: ZodRecord,
  ZodMap: ZodMap,
  ZodSet: ZodSet,
  ZodFunction: ZodFunction,
  ZodLazy: ZodLazy,
  ZodLiteral: ZodLiteral,
  ZodEnum: ZodEnum,
  ZodNativeEnum: ZodNativeEnum,
  ZodPromise: ZodPromise,
  ZodEffects: ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional: ZodOptional,
  ZodNullable: ZodNullable,
  ZodDefault: ZodDefault,
  ZodNaN: ZodNaN,
  BRAND: BRAND,
  ZodBranded: ZodBranded,
  custom: custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late: late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  "boolean": booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  'enum': enumType,
  'function': functionType,
  'instanceof': instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  'null': nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean: oboolean,
  onumber: onumber,
  optional: optionalType,
  ostring: ostring,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  transformer: effectsType,
  tuple: tupleType,
  'undefined': undefinedType,
  union: unionType,
  unknown: unknownType,
  'void': voidType,
  NEVER: NEVER,
  ZodIssueCode: ZodIssueCode,
  quotelessJson: quotelessJson,
  ZodError: ZodError
});

var NativeModules = function () {
  function NativeModules() {
    _classCallCheck(this, NativeModules);
    if (this.getWindow().__HYAndroidMessageHandlers) {
      var moduleInfos = this.getWindow().__HYAndroidMessageHandlers.getModuleInfo();
      this.setupModules(JSON.parse(moduleInfos));
    } else if (this.getWindow().__hyNativeModuleInfo__) {
      this.setupModules(this.getWindow().__hyNativeModuleInfo__);
    }
  }
  _createClass(NativeModules, [{
    key: "getWindow",
    value: function getWindow() {
      try {
        if (window.top && window.self != window.top && window.top.document) {
          return window.top;
        }
        return window;
      } catch (e) {
        return window;
      }
    }
  }, {
    key: "setupModules",
    value: function setupModules(moduleInfo) {
      var _this = this;
      moduleInfo.forEach(function (item) {
        var moduleObj = {};
        var moduleName = item['name'];
        if (item.constants) {
          Object.getOwnPropertyNames(item.constants).forEach(function (key) {
            Object.defineProperty(moduleObj, key, {
              enumerable: false,
              configurable: false,
              writable: false,
              value: item.constants[key]
            });
          });
        }
        if (item.methods) {
          item.methods.forEach(function (methodName) {
            var fun = function fun(params) {
              return new Promise(function (resolve, reject) {
                nativeBridge.invokeWithModule(moduleName, methodName, params, function (resp) {
                  if (resp.errorCode === 0) {
                    if (Browser.versions.android && (!getBridge$1() || !getBridge$1().isNewBridge)) {
                      if (resp.data.udbToken && resp.data.udbToken.length) {
                        resp.data.udbToken = encodeURIComponent(resp.data.udbToken);
                      }
                    }
                    resolve(resp.data);
                  } else {
                    reject({
                      errorCode: resp.errorCode,
                      code: resp.errorCode,
                      message: resp.data
                    });
                  }
                });
              });
            };
            Object.defineProperty(moduleObj, methodName, {
              enumerable: false,
              configurable: false,
              writable: false,
              value: fun
            });
          });
        }
        if (item.syncMethods) {
          item.syncMethods.forEach(function (methodName) {
            var fun = function fun(params) {
              var res = nativeBridge.invokeWithModuleSync(moduleName, methodName, params);
              if (res.errorCode === 0) {
                return res.data;
              }
              var error = new Error(res.data);
              error.errMsg = res.data;
              error.errCode = res.errorCode;
              throw error;
            };
            Object.defineProperty(moduleObj, methodName, {
              enumerable: false,
              configurable: false,
              writable: false,
              value: fun
            });
          });
        }
        if (item.isEmitter) {
          var on = function on(eventId, callback, params) {
            nativeBridge.onWithModule(moduleName, eventId, params, callback);
          };
          var off = function off(eventId, callback, params) {
            nativeBridge.offWithModule(moduleName, eventId, params, callback);
          };
          Object.defineProperty(moduleObj, 'on', {
            enumerable: false,
            configurable: false,
            writable: false,
            value: on
          });
          Object.defineProperty(moduleObj, 'off', {
            enumerable: false,
            configurable: false,
            writable: false,
            value: off
          });
        }
        if (_this.hasOwnProperty(moduleName)) {
          console.error("Can not redefine " + moduleName);
        } else {
          Object.defineProperty(_this, moduleName, {
            enumerable: false,
            configurable: false,
            writable: false,
            value: moduleObj
          });
        }
      });
    }
  }]);
  return NativeModules;
}();
var nativeModules = new NativeModules();
window.__hySetupNativeModules__ = nativeModules.setupModules.bind(nativeModules);

var HYLog = {
  debug: function debug() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (nativeModules.HYLog && nativeModules.HYLog.debug) {
      return nativeModules.HYLog.debug(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.debug is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  },
  info: function info() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (nativeModules.HYLog && nativeModules.HYLog.info) {
      return nativeModules.HYLog.info(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.info is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  },
  warn: function warn() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (nativeModules.HYLog && nativeModules.HYLog.warn) {
      return nativeModules.HYLog.warn(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.warn is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  },
  error: function error() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (nativeModules.HYLog && nativeModules.HYLog.error) {
      return nativeModules.HYLog.error(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.error is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  }
};

var NativeEventCenter = nativeModules.HYNativeEventCenter;
var HYNativeEventCenter$1 = function () {
  function HYNativeEventCenter() {
    var _this = this;
    _classCallCheck(this, HYNativeEventCenter);
    this._nativeEventListeners = new Map();
    this._callback = function (params) {
      _this._dispatchEvent(params);
    };
  }
  _createClass(HYNativeEventCenter, [{
    key: "addEventListener",
    value: function addEventListener(listener, eventName, callback) {
      if (!listener || !eventName || !callback) {
        return;
      }
      this._addEventEmitterListenerIfNeed();
      var listeners = this._nativeEventListeners.get(eventName);
      if (!listeners) {
        NativeEventCenter.addEventListener({
          'eventName': eventName
        });
        listeners = new Map();
        this._nativeEventListeners.set(eventName, listeners);
      }
      listeners.set(listener, callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(listener, eventName) {
      if (!listener || !eventName) {
        return;
      }
      var listeners = this._nativeEventListeners.get(eventName);
      if (listeners) {
        listeners["delete"](listener);
        if (listeners.size == 0) {
          this._nativeEventListeners["delete"](eventName);
          NativeEventCenter.removeEventListener({
            'eventName': eventName
          });
        }
      }
      this._removeEventEmitterListenerIfNeed();
    }
  }, {
    key: "clearEventListener",
    value: function clearEventListener(listener) {
      if (!listener) {
        return;
      }
      var emptyEvents = new Array();
      var _iterator = _createForOfIteratorHelper(this._nativeEventListeners.keys()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _eventName = _step.value;
          var listeners = this._nativeEventListeners.get(_eventName);
          if (listeners.size > 0) {
            listeners["delete"](listener);
            if (listeners.size == 0) {
              emptyEvents.push(_eventName);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var index = 0; index < emptyEvents.length; index++) {
        var eventName = emptyEvents[index];
        this._nativeEventListeners["delete"](eventName);
        NativeEventCenter.removeEventListener({
          'eventName': eventName
        });
      }
    }
  }, {
    key: "clearAllListener",
    value: function clearAllListener() {
      var _this2 = this;
      this._nativeEventListeners.forEach(function (value, key) {
        _this2._nativeEventListeners["delete"](key);
        NativeEventCenter.removeEventListener({
          'eventName': key
        });
      });
    }
  }, {
    key: "postEventToNative",
    value: function postEventToNative(eventName, userInfo) {
      NativeEventCenter.postEvent({
        'eventName': eventName,
        'userInfo': userInfo
      });
    }
  }, {
    key: "_addEventEmitterListenerIfNeed",
    value: function _addEventEmitterListenerIfNeed() {
      if (this._nativeEventListeners.size == 0) {
        NativeEventCenter.on('nativeEvent', this._callback);
      }
    }
  }, {
    key: "_removeEventEmitterListenerIfNeed",
    value: function _removeEventEmitterListenerIfNeed() {
      if (this._nativeEventListeners.size == 0) {
        NativeEventCenter.off('nativeEvent', this._callback);
      }
    }
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(reminder) {
      var name = reminder.name;
      var params = reminder.params;
      var listeners = this._nativeEventListeners.get(name);
      if (!listeners) {
        return;
      }
      var _iterator2 = _createForOfIteratorHelper(listeners.keys()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var callback = listeners.get(key);
          callback(params);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
  return HYNativeEventCenter;
}();
var hyNativeEventCenter = new HYNativeEventCenter$1();

function atob$1(data) {
  if (arguments.length === 0) {
    throw new TypeError("1 argument required, but only 0 present.");
  }
  data = "".concat(data);
  data = data.replace(/[ \t\n\f\r]/g, "");
  if (data.length % 4 === 0) {
    data = data.replace(/==?$/, "");
  }
  if (data.length % 4 === 1 || /[^+/0-9A-Za-z]/.test(data)) {
    return null;
  }
  var output = "";
  var buffer = 0;
  var accumulatedBits = 0;
  for (var i = 0; i < data.length; i++) {
    buffer <<= 6;
    buffer |= atobLookup(data[i]);
    accumulatedBits += 6;
    if (accumulatedBits === 24) {
      output += String.fromCharCode((buffer & 0xff0000) >> 16);
      output += String.fromCharCode((buffer & 0xff00) >> 8);
      output += String.fromCharCode(buffer & 0xff);
      buffer = accumulatedBits = 0;
    }
  }
  if (accumulatedBits === 12) {
    buffer >>= 4;
    output += String.fromCharCode(buffer);
  } else if (accumulatedBits === 18) {
    buffer >>= 2;
    output += String.fromCharCode((buffer & 0xff00) >> 8);
    output += String.fromCharCode(buffer & 0xff);
  }
  return output;
}
var keystr$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function atobLookup(chr) {
  var index = keystr$1.indexOf(chr);
  return index < 0 ? undefined : index;
}
var atob_1 = atob$1;

function btoa$1(s) {
  if (arguments.length === 0) {
    throw new TypeError("1 argument required, but only 0 present.");
  }
  var i;
  s = "".concat(s);
  for (i = 0; i < s.length; i++) {
    if (s.charCodeAt(i) > 255) {
      return null;
    }
  }
  var out = "";
  for (i = 0; i < s.length; i += 3) {
    var groupsOfSix = [undefined, undefined, undefined, undefined];
    groupsOfSix[0] = s.charCodeAt(i) >> 2;
    groupsOfSix[1] = (s.charCodeAt(i) & 0x03) << 4;
    if (s.length > i + 1) {
      groupsOfSix[1] |= s.charCodeAt(i + 1) >> 4;
      groupsOfSix[2] = (s.charCodeAt(i + 1) & 0x0f) << 2;
    }
    if (s.length > i + 2) {
      groupsOfSix[2] |= s.charCodeAt(i + 2) >> 6;
      groupsOfSix[3] = s.charCodeAt(i + 2) & 0x3f;
    }
    for (var j = 0; j < groupsOfSix.length; j++) {
      if (typeof groupsOfSix[j] === "undefined") {
        out += "=";
      } else {
        out += btoaLookup(groupsOfSix[j]);
      }
    }
  }
  return out;
}
var keystr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function btoaLookup(index) {
  if (index >= 0 && index < 64) {
    return keystr[index];
  }
  return undefined;
}
var btoa_1 = btoa$1;

var atob = atob_1;
var btoa = btoa_1;
var abab = {
  atob: atob,
  btoa: btoa
};

var Taf = window.Taf || {};
function base64ToArrayBuffer(base64) {
  var binary_string = abab.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}
function arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return abab.btoa(binary);
}
function getWupStructByArrayBuffer(arrayBuffer, rspClass) {
  var wup = new Taf.Wup();
  wup.decode(arrayBuffer);
  var key = wup.newdata.get('tRsp') ? 'tRsp' : 'tResp';
  var wupStruct = new rspClass();
  wup.readStruct(key, wupStruct, rspClass);
  return wupStruct;
}
function createArrayBufferByWupReq(serventName, func, data) {
  var wup = new Taf.Wup();
  wup.setServant(serventName);
  wup.setFunc(func);
  wup.writeStruct('tReq', data);
  var os = wup.encode();
  return os.getBuffer();
}

var NativeDataCenter = nativeModules.HYDataCenter;
var HYDataCenter = function () {
  function HYDataCenter() {
    _classCallCheck(this, HYDataCenter);
  }
  _createClass(HYDataCenter, [{
    key: "setUserIdFunc",
    value:
    function setUserIdFunc(fun) {
      this._userIdFun = fun;
    }
  }, {
    key: "sendWupRequest",
    value: function () {
      var _sendWupRequest = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(cfg, strategy) {
        var userId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!cfg.request) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return this._userIdFun();
            case 3:
              userId = _context.sent;
              cfg.request.tId = userId;
            case 5:
              return _context.abrupt("return", this.sendWupRequestWithCustomUserId(cfg, strategy));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function sendWupRequest(_x, _x2) {
        return _sendWupRequest.apply(this, arguments);
      }
      return sendWupRequest;
    }()
  }, {
    key: "sendWupRequestWithCustomUserId",
    value: function () {
      var _sendWupRequestWithCustomUserId = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(cfg, strategy) {
        var rspClass, request, arrayBuffer, arrayBufferStr, responseData, responseBuf, result, buf, resp;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              rspClass = cfg.rspClass;
              request = cfg.request;
              arrayBuffer = createArrayBufferByWupReq(cfg.servant, cfg.funcname, request);
              arrayBufferStr = arrayBufferToBase64(arrayBuffer);
              cfg.unitPacket = arrayBufferStr;
              cfg.request = null;
              cfg.rspClass = null;
              _context2.prev = 7;
              _context2.next = 10;
              return NativeDataCenter.sendWupRequest(cfg, strategy);
            case 10:
              responseData = _context2.sent;
              responseBuf = base64ToArrayBuffer(responseData);
              result = getWupStructByArrayBuffer(responseBuf, rspClass);
              if (cfg.needLog) {
                HYLog.info('HYRNDataCenter', 'sendRequest :\n' + JSON.stringify(request, null, 4) + '\n result : \n' + JSON.stringify(result, null, 4) + "\n strategy:" + strategy);
              }
              return _context2.abrupt("return", result);
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](7);
              try {
                buf = base64ToArrayBuffer(_context2.t0.message);
                resp = getWupStructByArrayBuffer(buf, rspClass);
                _context2.t0.resp = resp;
              } catch (err) {
                HYLog.info('HYRNDataCenter', 'decode resp failed:' + JSON.stringify(err));
              }
              HYLog.info("HYRNDataCenter", "error :" + JSON.stringify(_context2.t0));
              throw _context2.t0;
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[7, 17]]);
      }));
      function sendWupRequestWithCustomUserId(_x3, _x4) {
        return _sendWupRequestWithCustomUserId.apply(this, arguments);
      }
      return sendWupRequestWithCustomUserId;
    }()
  }]);
  return HYDataCenter;
}();
var hyDataCenter = new HYDataCenter();

setup();

/**
 * 监听合法的 iframe origin
 * @description 默认限制 (msstatic|yaoguo|huya).huya 域名
 */
var testAllow = function (origin) { return /\.(msstatic|yaoguo|huya)\.com(:\d+)?$/.test(origin); };

/**
 * @description 拦截 HUYASdk.addEventListener, HUYASdk.removeEventListener
 */
var createEventName$1 = function (apiName) {
    return {
        req: "KIWI_SDK_FOR_IFRAME_" + apiName + "_REQ",
        res: "KIWI_SDK_FOR_IFRAME_" + apiName + "_RES"
    };
};
var __cacheMap$1 = {};
/** 重写 HUYASdk.addEventListener */
var proxyAddEventListener$1 = {
    __reqId: 0,
    EVENT_NAME: createEventName$1('HUYASdk.addEventListener'),
    override: function (HUYASdk) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HUYASdk === null || HUYASdk === void 0 ? void 0 : HUYASdk.addEventListener) !== 'function')
            return;
        // HUYASdk.addEventListener(HUYASdk.EVENT_ID.LOGIN_SUCCESS, {}, (_rsp) => location.reload());
        // HUYASdk.addEventListener(HUYASdk.EVENT_ID.LOGIN_SUCCESS, (rsp) => location.reload());
        // const oldAddEventListener = HUYASdk.addEventListener.bind(HUYASdk)
        HUYASdk.addEventListener = function (eventName, arg1, arg2) {
            var _a;
            var _b = __read(typeof arg1 === 'function' ? [{}, arg1] : [arg1, arg2], 2), options = _b[0], callback = _b[1];
            proxyAddEventListener$1.__reqId += 1;
            var currentReqId = proxyAddEventListener$1.__reqId + "_HUYASdk.addEventListener_" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyAddEventListener$1.EVENT_NAME.req,
                params: options,
                eventName: eventName
            };
            var handleSendApiReq = function (event) {
                if (!testAllow(event.origin))
                    return;
                if (typeof event.data !== 'object')
                    return;
                var _a = event.data, reqId = _a.reqId, type = _a.type, rsp = _a.rsp;
                if (reqId !== currentReqId)
                    return;
                if (type !== proxyAddEventListener$1.EVENT_NAME.res)
                    return;
                callback === null || callback === void 0 ? void 0 : callback(rsp);
            };
            // 重复触发同一事件，则移除事件监听
            (_a = __cacheMap$1[eventName]) === null || _a === void 0 ? void 0 : _a.call(__cacheMap$1);
            __cacheMap$1[eventName] = function () {
                window.removeEventListener('message', handleSendApiReq, false);
                delete __cacheMap$1[eventName];
            };
            window.addEventListener('message', handleSendApiReq, false);
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) {
        var _a, _b, _c;
        try {
            var data_1 = event === null || event === void 0 ? void 0 : event.data;
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyAddEventListener$1.EVENT_NAME.req)
                return;
            (_c = (_b = HUYASdk) === null || _b === void 0 ? void 0 : _b.addEventListener) === null || _c === void 0 ? void 0 : _c.call(_b, data_1.eventName, data_1.params, function (rsp) {
                var _a, _b;
                var postData = __assign(__assign({}, data_1), { reqId: data_1.reqId, type: proxyAddEventListener$1.EVENT_NAME.res, rsp: rsp });
                if (!((_a = event.source) === null || _a === void 0 ? void 0 : _a.postMessage)) {
                    document.querySelectorAll('iframe').forEach(function (iframeDom) {
                        var _a, _b;
                        (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, postData, '*');
                    });
                }
                else {
                    ;
                    (_b = event.source) === null || _b === void 0 ? void 0 : _b.postMessage(postData, '*');
                }
            });
        }
        catch (error) {
            return console.log('[runMessageEventInTopWindow] TopWindow fail', error);
        }
    },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyAddEventListener$1.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyAddEventListener$1.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
/** 重写 HUYASdk.removeEventListener */
var proxyRemoveEventListener$1 = {
    __reqId: 0,
    EVENT_NAME: createEventName$1('HUYASdk.removeEventListener'),
    override: function (HUYASdk) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HUYASdk === null || HUYASdk === void 0 ? void 0 : HUYASdk.removeEventListener) !== 'function')
            return;
        // HUYASdk.removeEventListener('kKWJSSdkEventIdApp')
        HUYASdk.removeEventListener = function (eventName) {
            proxyRemoveEventListener$1.__reqId += 1;
            var currentReqId = proxyRemoveEventListener$1.__reqId + "_HUYASdk.removeEventListener_" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyRemoveEventListener$1.EVENT_NAME.req,
                eventName: eventName
            };
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) {
        var _a, _b, _c;
        try {
            var data = event === null || event === void 0 ? void 0 : event.data;
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyRemoveEventListener$1.EVENT_NAME.req)
                return;
            (_c = (_b = HUYASdk) === null || _b === void 0 ? void 0 : _b.removeEventListener) === null || _c === void 0 ? void 0 : _c.call(_b, data.eventName);
        }
        catch (error) {
            return console.log('[proxyRemoveEventListener] TopWindow fail', error);
        }
    },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyRemoveEventListener$1.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyRemoveEventListener$1.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
/** 重写 HUYASdk.JSBridge.invoke */
var proxyJSBridgeInvoke = {
    __reqId: 0,
    EVENT_NAME: createEventName$1('HUYASdk.JSBridge.invoke'),
    override: function (HUYASdk) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HUYASdk === null || HUYASdk === void 0 ? void 0 : HUYASdk.removeEventListener) !== 'function')
            return;
        // HUYASdk.JSBridge.invoke('HYUDBMSDKClose', {}, { success: function(response) {} });
        // HUYASdk.JSBridge.invoke('HYUDBMSDKClose', {}, { complete: function(response) {} });
        HUYASdk.JSBridge.invoke = function (eventName, params, options) {
            proxyJSBridgeInvoke.__reqId += 1;
            var currentReqId = proxyJSBridgeInvoke.__reqId + "_HUYASdk.JSBridge.invoke_" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyJSBridgeInvoke.EVENT_NAME.req,
                eventName: eventName,
                params: params
            };
            var handleSendApiReq = function (event) {
                var _a, _b;
                if (!testAllow(event.origin))
                    return;
                if (typeof event.data !== 'object')
                    return;
                var _c = event.data, reqId = _c.reqId, type = _c.type, rsp = _c.rsp, oldSdkEventEmit = _c.oldSdkEventEmit;
                if (reqId !== currentReqId)
                    return;
                if (type !== proxyJSBridgeInvoke.EVENT_NAME.res)
                    return;
                window.removeEventListener('message', handleSendApiReq, false);
                // 处理返回结果
                if ((oldSdkEventEmit === null || oldSdkEventEmit === void 0 ? void 0 : oldSdkEventEmit.success) && (options === null || options === void 0 ? void 0 : options.success)) {
                    (_a = options.success) === null || _a === void 0 ? void 0 : _a.call(options, rsp);
                }
                if ((oldSdkEventEmit === null || oldSdkEventEmit === void 0 ? void 0 : oldSdkEventEmit.complete) && (options === null || options === void 0 ? void 0 : options.complete)) {
                    (_b = options.complete) === null || _b === void 0 ? void 0 : _b.call(options, rsp);
                }
            };
            window.addEventListener('message', handleSendApiReq, false);
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var data_2, oldSdkEventEmit_1, promise, rsp, postData_1, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    data_2 = event === null || event === void 0 ? void 0 : event.data;
                    if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyJSBridgeInvoke.EVENT_NAME.req)
                        return [2 /*return*/];
                    oldSdkEventEmit_1 = {};
                    promise = new Promise(function (resolve) {
                        var _a, _b, _c;
                        (_c = (_a = HUYASdk) === null || _a === void 0 ? void 0 : (_b = _a.JSBridge).invoke) === null || _c === void 0 ? void 0 : _c.call(_b, data_2.eventName, data_2.params || {}, __assign(__assign({}, data_2.params), { success: function (resp) {
                                oldSdkEventEmit_1.success = true;
                                resolve(resp);
                            }, complete: function (resp) {
                                oldSdkEventEmit_1.complete = true;
                                resolve(resp);
                            } }));
                    });
                    return [4 /*yield*/, promise];
                case 1:
                    rsp = _d.sent();
                    postData_1 = __assign(__assign({}, event.data), { type: proxyJSBridgeInvoke.EVENT_NAME.res, rsp: rsp,
                        oldSdkEventEmit: oldSdkEventEmit_1 });
                    if (!((_b = event.source) === null || _b === void 0 ? void 0 : _b.postMessage)) {
                        document.querySelectorAll('iframe').forEach(function (iframeDom) {
                            var _a, _b;
                            (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, postData_1, '*');
                        });
                    }
                    else {
                        (_c = event.source) === null || _c === void 0 ? void 0 : _c.postMessage(postData_1, '*');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _d.sent();
                    return [2 /*return*/, console.log('[proxyJSBridgeInvoke] TopWindow fail', error_1)];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyJSBridgeInvoke.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyJSBridgeInvoke.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
var proxyHUYASdkEvent = {
    list: [proxyAddEventListener$1, proxyRemoveEventListener$1, proxyJSBridgeInvoke],
    override: function () {
        proxyHUYASdkEvent.list.forEach(function (item) { return item.override(HUYASdk); });
    },
    runMessageEventForTopWindow: function (event) {
        proxyHUYASdkEvent.list.forEach(function (item) { return item.runMessageEventForTopWindow(event); });
    },
    runMessageEventForMidWindow: function (event) {
        proxyAddEventListener$1.runMessageEventForMidWindow(event);
        proxyRemoveEventListener$1.runMessageEventForMidWindow(event);
    }
};

var __cacheMap = {};
var clearEvent = function () {
    Object.keys(__cacheMap).forEach(function (key) {
        var _a;
        if (typeof __cacheMap[key] === 'function') {
            (_a = __cacheMap[key]) === null || _a === void 0 ? void 0 : _a.call(__cacheMap);
            delete __cacheMap[key];
        }
    });
};
var listenerShare = {};
var createEventName = function (apiName) {
    return {
        req: "KIWI_SDK_FOR_IFRAME_" + apiName + "_REQ",
        res: "KIWI_SDK_FOR_IFRAME_" + apiName + "_RES"
    };
};
/** HYNativeEventCenter.addEventListener */
var proxyAddEventListener = {
    __reqId: 0,
    EVENT_NAME: createEventName('HYNativeEventCenter.addEventListener'),
    /** 重写 HYNativeEventCenter.addEventListener */
    override: function (HYNativeEventCenter) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HYNativeEventCenter === null || HYNativeEventCenter === void 0 ? void 0 : HYNativeEventCenter.addEventListener) !== 'function')
            return;
        // @example
        // HYNativeEventCenter.addEventListener(listener, "kNotificationFastRechargeSuccess", () => {
        //   disposer.push(cb?.());
        // });
        HYNativeEventCenter.addEventListener = function (_listener, eventName, callback) {
            var _a;
            proxyAddEventListener.__reqId += 1;
            var currentReqId = proxyAddEventListener.__reqId + "_HYNativeEventCenter.addEventListener_" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyAddEventListener.EVENT_NAME.req,
                eventName: eventName
            };
            var handleSendApiReq = function (event) {
                if (!testAllow(event.origin))
                    return;
                if (typeof event.data !== 'object')
                    return;
                var _a = event.data, reqId = _a.reqId, type = _a.type, rsp = _a.rsp;
                if (reqId !== currentReqId)
                    return;
                if (type !== proxyAddEventListener.EVENT_NAME.res)
                    return;
                callback === null || callback === void 0 ? void 0 : callback(rsp);
            };
            // 重复触发同一事件，则移除事件监听
            (_a = __cacheMap[eventName]) === null || _a === void 0 ? void 0 : _a.call(__cacheMap);
            __cacheMap[eventName] = function () {
                window.removeEventListener('message', handleSendApiReq, false);
                delete __cacheMap[eventName];
            };
            window.addEventListener('message', handleSendApiReq, false);
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) {
        var _a, _b, _c;
        try {
            var data_1 = event === null || event === void 0 ? void 0 : event.data;
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyAddEventListener.EVENT_NAME.req)
                return;
            (_c = (_b = HYNativeEventCenter) === null || _b === void 0 ? void 0 : _b.addEventListener) === null || _c === void 0 ? void 0 : _c.call(_b, listenerShare, data_1.eventName, function (rsp) {
                var _a, _b;
                var postData = __assign(__assign({}, data_1), { reqId: data_1.reqId, type: proxyAddEventListener.EVENT_NAME.res, rsp: rsp });
                if (!((_a = event.source) === null || _a === void 0 ? void 0 : _a.postMessage)) {
                    document.querySelectorAll('iframe').forEach(function (iframeDom) {
                        var _a, _b;
                        (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, postData, '*');
                    });
                }
                else {
                    ;
                    (_b = event.source) === null || _b === void 0 ? void 0 : _b.postMessage(postData, '*');
                }
            });
        }
        catch (error) {
            return console.log('[runMessageEventInTopWindow] TopWindow fail', error);
        }
    },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyAddEventListener.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyAddEventListener.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
/** HYNativeEventCenter.removeEventListener */
var proxyRemoveEventListener = {
    __reqId: 0,
    EVENT_NAME: createEventName('HYNativeEventCenter.removeEventListener'),
    /** 重写 HYNativeEventCenter.removeEventListener */
    override: function (HYNativeEventCenter) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HYNativeEventCenter === null || HYNativeEventCenter === void 0 ? void 0 : HYNativeEventCenter.removeEventListener) !== 'function')
            return;
        // HYNativeEventCenter.removeEventListener(listener, "kNotificationFastRechargeSuccess");
        HYNativeEventCenter.removeEventListener = function (_listener, eventName) {
            proxyRemoveEventListener.__reqId += 1;
            var currentReqId = proxyRemoveEventListener.__reqId + "_HYNativeEventCenter.removeEventListener_" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyRemoveEventListener.EVENT_NAME.req,
                eventName: eventName
            };
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) {
        var _a, _b, _c;
        try {
            var data = event === null || event === void 0 ? void 0 : event.data;
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyRemoveEventListener.EVENT_NAME.req)
                return;
            (_c = (_b = HYNativeEventCenter) === null || _b === void 0 ? void 0 : _b.removeEventListener) === null || _c === void 0 ? void 0 : _c.call(_b, listenerShare, data.eventName);
        }
        catch (error) {
            return console.log('[proxyRemoveEventListener] TopWindow fail', error);
        }
    },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyRemoveEventListener.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyRemoveEventListener.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
/** HYNativeEventCenter.clearEventListener */
var proxyClearEventListener = {
    __reqId: 0,
    EVENT_NAME: createEventName('HYNativeEventCenter.clearEventListener'),
    /** 重写 HYNativeEventCenter.clearEventListener */
    override: function (HYNativeEventCenter) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HYNativeEventCenter === null || HYNativeEventCenter === void 0 ? void 0 : HYNativeEventCenter.clearEventListener) !== 'function')
            return;
        // clearEventListener: (listener: any) => void
        HYNativeEventCenter.clearEventListener = function (_listener) {
            proxyClearEventListener.__reqId += 1;
            var currentReqId = proxyClearEventListener.__reqId + "_HYNativeEventCenter.clearEventListener_" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyClearEventListener.EVENT_NAME.req
            };
            clearEvent();
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) {
        var _a, _b, _c;
        try {
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyClearEventListener.EVENT_NAME.req)
                return;
            (_c = (_b = HYNativeEventCenter) === null || _b === void 0 ? void 0 : _b.clearEventListener) === null || _c === void 0 ? void 0 : _c.call(_b, listenerShare);
        }
        catch (error) {
            return console.log('[proxyClearEventListener] TopWindow fail', error);
        }
    },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyClearEventListener.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyClearEventListener.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
/** HYNativeEventCenter.clearAllListener */
var proxyClearAllListener = {
    __reqId: 0,
    EVENT_NAME: createEventName('HYNativeEventCenter.clearAllListener'),
    /** 重写 HYNativeEventCenter.clearAllListener */
    override: function (HYNativeEventCenter) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HYNativeEventCenter === null || HYNativeEventCenter === void 0 ? void 0 : HYNativeEventCenter.clearAllListener) !== 'function')
            return;
        // clearAllListener: () => void
        HYNativeEventCenter.clearAllListener = function () {
            proxyClearAllListener.__reqId += 1;
            var currentReqId = proxyClearAllListener.__reqId + "_HYNativeEventCenter.clearAllListener_" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyClearAllListener.EVENT_NAME.req
            };
            clearEvent();
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) {
        var _a, _b, _c;
        try {
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyClearAllListener.EVENT_NAME.req)
                return;
            (_c = (_b = HYNativeEventCenter) === null || _b === void 0 ? void 0 : _b.clearAllListener) === null || _c === void 0 ? void 0 : _c.call(_b);
        }
        catch (error) {
            return console.log('[proxyClearAllListener] TopWindow fail', error);
        }
    },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyClearAllListener.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyClearAllListener.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
/** HYNativeEventCenter.postEventToNative */
var proxyPostEventToNative = {
    __reqId: 0,
    EVENT_NAME: createEventName('HYNativeEventCenter.postEventToNative'),
    /** 重写 HYNativeEventCenter.postEventToNative */
    override: function (HYNativeEventCenter) {
        if (ROLE !== ERole.MidWindow)
            return;
        if (!isCrossDomainInApp())
            return;
        if (!canUseCrossDomain())
            return;
        if (typeof (HYNativeEventCenter === null || HYNativeEventCenter === void 0 ? void 0 : HYNativeEventCenter.postEventToNative) !== 'function')
            return;
        // postEventToNative: (eventName: string, userInfo: any) => void
        HYNativeEventCenter.postEventToNative = function (eventName, userInfo) {
            proxyPostEventToNative.__reqId += 1;
            var currentReqId = proxyPostEventToNative.__reqId + "_HYNativeEventCenter.postEventToNative" + createRandomId();
            var reqData = {
                reqId: currentReqId,
                type: proxyPostEventToNative.EVENT_NAME.req,
                eventName: eventName,
                userInfo: userInfo
            };
            clearEvent();
            window.parent.postMessage(reqData, '*');
        };
    },
    runMessageEventForTopWindow: function (event) {
        var _a, _b;
        try {
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) !== proxyPostEventToNative.EVENT_NAME.req)
                return;
            if (!((_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.eventName))
                return;
            HYNativeEventCenter.postEventToNative(event.data.eventName, event.data.userInfo);
        }
        catch (error) {
            return console.log('[proxyPostEventToNative] TopWindow fail', error);
        }
    },
    runMessageEventForMidWindow: function (event) {
        var type = event.data.type;
        if (type === proxyPostEventToNative.EVENT_NAME.req) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === proxyPostEventToNative.EVENT_NAME.res) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    }
};
// type HYNativeEventCenter = {
//   addEventListener: (listener: any, eventName?: string, callback?: (params: any) => void) => void
//   removeEventListener: (listener: any, eventName?: string) => void
//   clearEventListener: (listener: any) => void
//   clearAllListener: () => void
//   postEventToNative: (eventName: string, userInfo: any) => void
//   on: (eventId: string, callback: () => void, params?: object) => void
//   off: (eventId: string, callback: () => void, params?: object) => void
// }
/** on、off没人用，同时为了减少代码体积，因此不实现 */
var proxyHYNativeEventCenter = {
    list: [
        proxyAddEventListener,
        proxyRemoveEventListener,
        proxyClearEventListener,
        proxyClearAllListener,
        proxyPostEventToNative
    ],
    override: function () {
        proxyHYNativeEventCenter.list.forEach(function (item) { return item.override(HYNativeEventCenter); });
    },
    runMessageEventForTopWindow: function (event) {
        proxyHYNativeEventCenter.list.forEach(function (item) { return item.runMessageEventForTopWindow(event); });
    },
    runMessageEventForMidWindow: function (event) {
        proxyHYNativeEventCenter.list.forEach(function (item) { return item.runMessageEventForMidWindow(event); });
    }
};

var proxyList = [proxyHUYASdkEvent, proxyHYNativeEventCenter];
var isTopWindow = window.top === window.self;
var isCrossDomainInApp = function () {
    var _a, _b;
    var ua = ((_b = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a)) || '';
    /** pc观众端 */
    var isPC = /huya-pc/.test(ua);
    /** pc主播端 */
    var isPCAnchor = /hyanchor/.test(ua);
    /** 虎牙助手端 */
    var isZSApp = /huya-zs/.test(ua);
    /**
     * @description 是否为虎牙的app;仅适用虎牙观众端，小鹿
     */
    var isHUYAApp = /huya|hy/.test(ua) && !isPC && !isZSApp && !isPCAnchor;
    return isHUYAApp && !isTopWindow && !getBridge$1();
};
/**
 * @description 窗口角色
 * 1. TopWindow-顶部窗口，只有发消息
 * 2. MidWindow-中间窗口。
 * - 可能是消费者：消费者没办法执行huyasdk方法，传递数据给父窗口执行，再接受父窗口返回结果
 * - 可能是转发者：转发父窗口、子窗口消息
 * 3. EmptyWindow-空窗口，什么也不做
 */
var ERole;
(function (ERole) {
    /** 顶部窗口，只有发消息 */
    ERole["TopWindow"] = "TopWindow";
    /** 中间窗口，可能是消费者或转发者 */
    ERole["MidWindow"] = "MidWindow";
    /** 空窗口，什么也不做 */
    ERole["EmptyWindow"] = "EmptyWindow";
})(ERole || (ERole = {}));
var ROLE = isTopWindow
    ? ERole.TopWindow
    : isCrossDomainInApp()
        ? ERole.MidWindow
        : ERole.EmptyWindow;
var __reqId = 0;
var KIWI_SDK_FOR_IFRAME_API_REQ = 'KIWI_SDK_FOR_IFRAME_API_REQ';
var KIWI_SDK_FOR_IFRAME_API_RES = 'KIWI_SDK_FOR_IFRAME_API_RES';
/**
 * @description 调用方式
 * 1. 使用旧版sdk调用 HUYASdk?.JSBridge?.invoke
 * 2. 使用特殊处理模块 options?.specialHandle
 * 3. 模块方式调用 NativeModules[moduleName][nativeApiName](params || {})
 */
var EApiRunType;
(function (EApiRunType) {
    EApiRunType[EApiRunType["invoke"] = 1] = "invoke";
    EApiRunType[EApiRunType["specialHandle"] = 2] = "specialHandle";
    EApiRunType[EApiRunType["moduleRun"] = 3] = "moduleRun";
    EApiRunType[EApiRunType["unknow"] = -99999] = "unknow";
})(EApiRunType || (EApiRunType = {}));
var getRunType = function (runTypeInfo) {
    var _a;
    if ((_a = nativeModules === null || nativeModules === void 0 ? void 0 : nativeModules[runTypeInfo.moduleName]) === null || _a === void 0 ? void 0 : _a[runTypeInfo.nativeApiName]) {
        if ((runTypeInfo === null || runTypeInfo === void 0 ? void 0 : runTypeInfo.isUseSdk) && runTypeInfo.isCompatibleOldSdkFlag)
            return EApiRunType.invoke;
        if (runTypeInfo === null || runTypeInfo === void 0 ? void 0 : runTypeInfo.isSpecialHandle)
            return EApiRunType.specialHandle;
        return EApiRunType.moduleRun;
    }
    if (runTypeInfo === null || runTypeInfo === void 0 ? void 0 : runTypeInfo.isUseSdk)
        return EApiRunType.invoke;
    return EApiRunType.unknow;
};
var COMMUNICATOR_NAME = window.location.href;
var canUseCrossDomain = function () {
    var conf = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.getInnerConfig();
    return !!conf.useCrossDomainApi;
};
var shouldWrapApiRun = function () { return canUseCrossDomain() && ROLE === ERole.MidWindow; };
function handleApiRunBefore(moduleName, nativeApiName, originParams, options) {
    if (ROLE !== ERole.MidWindow)
        return;
    var apiPath = [moduleName, nativeApiName].join('.');
    __reqId += 1;
    var currentReqId = __reqId + "__" + apiPath + "__" + COMMUNICATOR_NAME;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var _a = originParams || {}, complete = _a.complete, success = _a.success; _a.fail; _a.cancel; var rest = __rest(_a, ["complete", "success", "fail", "cancel"]);
    var oldSdkEvent = {
        success: typeof success === 'function',
        complete: typeof complete === 'function'
    };
    var reqData = {
        /** @example HUYASdk.openUrl */
        apiPath: apiPath,
        type: KIWI_SDK_FOR_IFRAME_API_REQ,
        reqId: currentReqId,
        oldSdkEvent: oldSdkEvent,
        params: typeof rest === 'object' && rest ? JSON.parse(JSON.stringify(rest)) : undefined,
        runTypeInfo: {
            moduleName: moduleName,
            nativeApiName: nativeApiName,
            isUseSdk: options === null || options === void 0 ? void 0 : options.isUseSdk,
            isCompatibleOldSdkFlag: isCompatibleOldSdk(originParams),
            isSpecialHandle: !!(options === null || options === void 0 ? void 0 : options.specialHandle)
        }
    };
    var promise = new Promise(function (resolve, _reject) {
        var handleSendApiReq = function (event) {
            if (!testAllow(event.origin))
                return;
            if (typeof event.data !== 'object')
                return;
            var _a = event.data, reqId = _a.reqId, type = _a.type;
            if (reqId !== currentReqId)
                return;
            if (type !== KIWI_SDK_FOR_IFRAME_API_RES)
                return;
            resolve(event.data);
            // console.log('[handleSendApiReq] 完成api调用', event.data, options)
            window.removeEventListener('message', handleSendApiReq, false);
        };
        window.addEventListener('message', handleSendApiReq, false);
        window.parent.postMessage(reqData, '*');
    });
    promise.then(function (_result) {
        /**
         * @description 调用方式
         * 1. 使用旧版sdk调用 HUYASdk?.JSBridge?.invoke
         * 2. 使用特殊处理模块 options?.specialHandle
         * 3. 模块方式调用 NativeModules[moduleName][nativeApiName](params || {})
         */
        // console.log('完成api调用', result, options)
    });
    // @ts-ignore
    return promise.then(function (result) {
        var _a, _b, _c;
        // const apiRunType = result.apiRunType
        // if ([EApiRunType.moduleRun, EApiRunType.specialHandle].includes(apiRunType)) {
        //   return result.res
        // }
        if (((_a = reqData === null || reqData === void 0 ? void 0 : reqData.oldSdkEvent) === null || _a === void 0 ? void 0 : _a.success) && ((_b = result === null || result === void 0 ? void 0 : result.oldSdkEventEmit) === null || _b === void 0 ? void 0 : _b.success)) {
            success === null || success === void 0 ? void 0 : success(result.res);
        }
        if ((_c = reqData === null || reqData === void 0 ? void 0 : reqData.oldSdkEvent) === null || _c === void 0 ? void 0 : _c.complete) {
            complete === null || complete === void 0 ? void 0 : complete(result.res);
        }
        return result.res;
    });
}
var onMesssageForTopWindow = function () {
    if (!canUseCrossDomain())
        return;
    return window.addEventListener('message', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var data_1, apiPath, apiRunType_1, resultRunner_1, oldSdkEventEmit_1, promise, res, postData_1, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!testAllow(event.origin))
                        return [2 /*return*/];
                    proxyList.forEach(function (item) { return item.runMessageEventForTopWindow(event); });
                    if (typeof event.data !== 'object')
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    data_1 = event === null || event === void 0 ? void 0 : event.data;
                    if (!(data_1.type === KIWI_SDK_FOR_IFRAME_API_REQ)) return [3 /*break*/, 3];
                    apiPath = data_1.apiPath.split('.');
                    apiRunType_1 = getRunType(data_1.runTypeInfo);
                    if (apiRunType_1 === EApiRunType.unknow)
                        return [2 /*return*/];
                    resultRunner_1 = apiPath.reduce(function (acc, cur) {
                        acc = acc === null || acc === void 0 ? void 0 : acc[cur];
                        return acc;
                    }, AllApi);
                    oldSdkEventEmit_1 = {};
                    promise = new Promise(function (resolve) {
                        if ([EApiRunType.moduleRun, EApiRunType.specialHandle].includes(apiRunType_1)) {
                            return resolve(resultRunner_1 === null || resultRunner_1 === void 0 ? void 0 : resultRunner_1(data_1.params));
                        }
                        if (apiRunType_1 === EApiRunType.invoke) {
                            var finalParams = __assign(__assign({}, data_1.params), { success: function (resp) {
                                    oldSdkEventEmit_1.success = true;
                                    resolve(resp);
                                }, complete: function (resp) {
                                    oldSdkEventEmit_1.complete = true;
                                    resolve(resp);
                                } });
                            return resultRunner_1 === null || resultRunner_1 === void 0 ? void 0 : resultRunner_1(finalParams);
                        }
                    });
                    return [4 /*yield*/, promise];
                case 2:
                    res = _c.sent();
                    postData_1 = __assign(__assign({}, event.data), { type: KIWI_SDK_FOR_IFRAME_API_RES, res: res,
                        oldSdkEventEmit: oldSdkEventEmit_1,
                        apiRunType: apiRunType_1 });
                    if (!((_a = event.source) === null || _a === void 0 ? void 0 : _a.postMessage)) {
                        document.querySelectorAll('iframe').forEach(function (iframeDom) {
                            var _a, _b;
                            (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, postData_1, '*');
                        });
                    }
                    else {
                        (_b = event.source) === null || _b === void 0 ? void 0 : _b.postMessage(postData_1, '*');
                    }
                    _c.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _c.sent();
                    return [2 /*return*/, console.log('[onMesssageForTopWindow] TopWindow fail', error_1)];
                case 5: return [2 /*return*/];
            }
        });
    }); });
};
var onMessageForMidWindow = function () {
    return window.addEventListener('message', function (event) {
        if (!testAllow(event.origin))
            return;
        proxyList.forEach(function (item) { return item.runMessageEventForMidWindow(event); });
        if (typeof event.data !== 'object')
            return;
        var type = event.data.type;
        if (type === KIWI_SDK_FOR_IFRAME_API_REQ) {
            window.parent.postMessage(event.data, '*');
        }
        if (type === KIWI_SDK_FOR_IFRAME_API_RES) {
            document.querySelectorAll('iframe').forEach(function (iframeDom) {
                var _a, _b;
                (_b = (_a = iframeDom.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, event.data, '*');
            });
        }
    });
};
var overrideForMidWindow = function () {
    proxyList.forEach(function (item) { return item.override(); });
};
var onMessageForCrossDomain = function () {
    runOnceInGlobal(function () {
        if (ROLE === ERole.EmptyWindow)
            return;
        if (ROLE === ERole.TopWindow) {
            onMesssageForTopWindow();
        }
        if (ROLE === ERole.MidWindow) {
            overrideForMidWindow();
            onMessageForMidWindow();
        }
    }, 'onMessageForCrossDomain');
};
/**
 * @description 强制初始化iframe事件
 */
var forceOnMessage = function () {
    HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.config({ useCrossDomainApi: true });
    onMessageForCrossDomain();
};

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isTopWindow: isTopWindow,
    isCrossDomainInApp: isCrossDomainInApp,
    get ERole () { return ERole; },
    ROLE: ROLE,
    canUseCrossDomain: canUseCrossDomain,
    shouldWrapApiRun: shouldWrapApiRun,
    handleApiRunBefore: handleApiRunBefore,
    onMessageForCrossDomain: onMessageForCrossDomain,
    forceOnMessage: forceOnMessage
});

var isNotInApp = !getBridge$1();
var outerHandler = function (msg, nativeApiName) {
    var conf = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.getInnerConfig();
    if (conf && (conf === null || conf === void 0 ? void 0 : conf.outerHandle)) {
        if (typeof conf.outerHandle === 'function') {
            conf === null || conf === void 0 ? void 0 : conf.outerHandle();
        }
        else {
            var local = window.location.href || 'https://www.huya.com';
            var redirectUrl = (conf === null || conf === void 0 ? void 0 : conf.redirectUrl) || 'https://hd.huya.com/h5/app/index.html';
            // ios 目前需encode两次,adr 只需encode一次
            window.location.href = redirectUrl + "?url=" + encodeURIComponent(encodeURIComponent(local));
        }
    }
    reportApiMess(nativeApiName, {
        errorCode: -1,
        message: msg
    });
    return new Promise(function (_resolve, reject) {
        reject({
            errorCode: -1,
            message: msg
        });
    });
};
/**
 * 生成共用sdk api
 * @param schema zod schema对象
 * @param moduleName 模块名
 * @param nativeApiName 原生方法名
 * @param options 扩展选项
 * @returns
 */
var generateCommonAPI = function (moduleName, nativeApiName, schema, options) {
    return function (params) {
        var _a, _b, _c, _d, _e, _f;
        if (params && ((_a = options === null || options === void 0 ? void 0 : options.lifecycle) === null || _a === void 0 ? void 0 : _a.beforeParse)) {
            (_b = options === null || options === void 0 ? void 0 : options.lifecycle) === null || _b === void 0 ? void 0 : _b.beforeParse(params);
        }
        if (schema && params) {
            var parseRes = schema.safeParse(params);
            if (!parseRes.success) {
                if ((_c = options === null || options === void 0 ? void 0 : options.lifecycle) === null || _c === void 0 ? void 0 : _c.handleError) {
                    return (_d = options === null || options === void 0 ? void 0 : options.lifecycle) === null || _d === void 0 ? void 0 : _d.handleError(parseRes.error);
                }
                var e = createSDKError(parseRes.error, moduleName + "." + nativeApiName);
                console.warn(e);
                return {
                    success: false,
                    error: e
                };
            }
        }
        if (params && ((_e = options === null || options === void 0 ? void 0 : options.lifecycle) === null || _e === void 0 ? void 0 : _e.afterParse)) {
            (_f = options === null || options === void 0 ? void 0 : options.lifecycle) === null || _f === void 0 ? void 0 : _f.afterParse(params);
        }
        return sdkApiCommonRun(moduleName, nativeApiName, params, options);
    };
};
function enhanceApiTypesWithModule(moduleName) {
    /**
     * @description generateCommonAPI 的再次封装，内聚方法的出入参，加强类型推断
     */
    return function enhanceApiTypes(fnObj) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return generateCommonAPI.apply(void 0, __spread([moduleName, fnObj.name, fnObj.input], args));
    };
}
/**
 * api 错误处理
 * @param moduleName 模块名
 * @param nativeApiName 方法名
 * @param nativeModuleNameStr 原生方法字符串
 * @returns 错误 promise
 */
function apiErrorHandle(moduleName, nativeApiName, nativeModuleNameStr) {
    if (isNotInApp) {
        return outerHandler("\u975E\u7AEF\u5185\u6253\u5F00\uFF0C\u4E0D\u5B58\u5728Bridge\u6865\u63A5\u5BF9\u8C61, \u65B9\u6CD5: " + moduleName + "." + nativeApiName + " \u8C03\u7528\u5931\u8D25", moduleName + "." + nativeApiName);
    }
    var errMessage = moduleName + "." + nativeApiName + " is not find in " + moduleName + ":" + nativeModuleNameStr;
    // if (window.onerror) {
    //   window.onerror(errMessage)
    // }
    if (console.warn) {
        console.warn(errMessage);
    }
    reportApiMess(moduleName + "." + nativeApiName, {
        errorCode: -1,
        message: errMessage
    });
    return new Promise(function (_resolve, reject) {
        reject({
            errorCode: -1,
            message: errMessage
        });
    });
}
/**
 * api HUYASdk 支援部分方法
 * @param params 参数
 * @param nativeApiName
 * @returns 处理promise
 */
function apiHuyaSdkHandle(moduleName, nativeApiName, params) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var _b = params || {}; _b.complete; _b.success; var fail = _b.fail, rest = __rest(_b, ["complete", "success", "fail"]);
    var wrapFail = function (res) {
        reportApiMess("HUYASdk." + nativeApiName, res);
        fail && fail(res);
    };
    if (typeof HUYASdk$1 !== 'undefined') {
        if (isNotInApp) {
            return outerHandler("\u975E\u7AEF\u5185\u6253\u5F00\uFF0C\u4E0D\u5B58\u5728Bridge\u6865\u63A5\u5BF9\u8C61, \u65B9\u6CD5: " + nativeApiName + " \u8C03\u7528\u5931\u8D25", "HUYASdk." + nativeApiName);
        }
        console.log('旧调用处理调用：', nativeApiName);
        if (isCompatibleOldSdk(params)) {
            (_a = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.JSBridge) === null || _a === void 0 ? void 0 : _a.invoke(nativeApiName, rest, __assign(__assign({}, params), { fail: wrapFail }));
        }
        else {
            return new Promise(function (resolve, reject) {
                var _a;
                if (typeof HUYASdk$1 !== 'undefined') {
                    try {
                        (_a = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.JSBridge) === null || _a === void 0 ? void 0 : _a.invoke(nativeApiName, __assign({}, rest), __assign(__assign({}, params), { success: resolve, cancel: reject, fail: reject }));
                    }
                    catch (err) {
                        reportApiMess("HUYASdk." + nativeApiName, err);
                        reject(err);
                    }
                }
            });
        }
    }
}
/**
 * api 处理方法
 * @param params 入参
 * @param moduleName 模块名
 * @param nativeApiName 原生方法名
 * @param isUseSdk 是否使用sdk处理
 * @returns
 */
function sdkApiCommonRun(moduleName, nativeApiName, originParams, options
// isUseSdk?: boolean
) {
    var _a;
    // const { NativeModules } = require('@hy-hybrid/hy-js-sdk')
    var isUseSdk = (options === null || options === void 0 ? void 0 : options.isUseSdk) || false;
    var params = originParams;
    if (shouldWrapApiRun()) {
        return handleApiRunBefore(moduleName, nativeApiName, originParams, options);
    }
    if (nativeModules[moduleName] && nativeModules[moduleName][nativeApiName]) {
        // 兼容旧方式调用
        if (isUseSdk && isCompatibleOldSdk(params)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var _b = params || {}; _b.complete; _b.success; var fail_1 = _b.fail, rest = __rest(_b, ["complete", "success", "fail"]);
            var wrapFail = function (res) {
                reportApiMess(moduleName + "." + nativeApiName, res);
                fail_1 === null || fail_1 === void 0 ? void 0 : fail_1(res);
            };
            (_a = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.JSBridge) === null || _a === void 0 ? void 0 : _a.invoke(nativeApiName, JSON.parse(JSON.stringify(rest)), __assign(__assign({}, params), { fail: wrapFail }));
            console.log('兼容旧的方式调用：', nativeApiName);
            return;
        }
        // 特殊处理模块
        if (options === null || options === void 0 ? void 0 : options.specialHandle) {
            console.log('特殊处理调用：', nativeApiName);
            return options === null || options === void 0 ? void 0 : options.specialHandle(params);
        }
        console.log('模块方式调用：', moduleName, nativeApiName);
        return nativeModules[moduleName][nativeApiName](params || {}).catch(function (err) {
            reportApiMess(moduleName + "." + nativeApiName, err);
            return Promise.reject(err);
        });
    }
    else {
        return isUseSdk
            ? apiHuyaSdkHandle(moduleName, nativeApiName, params)
            : apiErrorHandle(moduleName, nativeApiName, JSON.stringify(nativeModules[moduleName]));
    }
}
/**
 * api 模块 on off处理方法

 * @param moduleName 模块名
 * @param nativeApiName on|off 原生方法名
 * @param schema zod schema对象
 * @returns
 */
var generateCommonEvent = function (moduleName, nativeApiName) {
    return function (eventId, callback, params) {
        // const { NativeModules } = require('@hy-hybrid/hy-js-sdk')
        if (nativeModules[moduleName] && nativeModules[moduleName][nativeApiName]) {
            nativeModules[moduleName][nativeApiName](eventId, callback, params);
        }
        else {
            HUYASdk$1.JSBridge[nativeApiName](eventId, params, callback);
        }
    };
};
/**
 * 用于验证void 传入function
 */
var functionScheme = mod.object({
    success: mod.function().args(mod.any()).optional(),
    cancel: mod.function().args(mod.any()).optional(),
    fail: mod.function().args(mod.any()).optional(),
    complete: mod.function().args(mod.any()).optional()
});

var ECode;
(function (ECode) {
    /** 无JSBridge */
    ECode[ECode["hasNotJSBridge"] = -9999] = "hasNotJSBridge";
    /** 调用超时 */
    ECode[ECode["timeout"] = -9998] = "timeout";
})(ECode || (ECode = {}));

var win = window;
var cbprefix = 'hypcgamescb_';
var setCallbackConnect = function (AppInfo, callbackFunction, flag) {
    var callbackFunctionName = cbprefix + "_" + flag + "_" + (AppInfo === null || AppInfo === void 0 ? void 0 : AppInfo.PackageName.replace(/\./g, ''));
    if (win[callbackFunctionName]) {
        console.log(flag + " callbackFunctionName: " + callbackFunctionName + " is already defined");
    }
    else {
        // @ts-ignore
        var wrapCallBack = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (typeof callbackFunction === 'function') {
                // @ts-ignore
                callbackFunction.apply(void 0, __spread(args.map(parseJsonForNewPC)));
            }
            else {
                console.log("callbackFunctionName: " + callbackFunctionName + " is not a function");
            }
        };
        win[callbackFunctionName] = wrapCallBack;
    }
    return {
        callbackFunctionName: callbackFunctionName
    };
};
var setTitle$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                return [4 /*yield*/, select({
                        pc_exe: oldFn,
                        pc_exe_external: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.external) === null || _b === void 0 ? void 0 : _b.setTitle) === 'function') {
                                    return [2 /*return*/, (_d = (_c = window) === null || _c === void 0 ? void 0 : _c.external) === null || _d === void 0 ? void 0 : _d.setTitle(params.title)];
                                }
                                return [2 /*return*/, oldFn()];
                            });
                        }); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };
var launchAppCompat = function (_oldFn) { return function (params, callback) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params, callback); };
                return [4 /*yield*/, select({
                        pc_exe: oldFn,
                        pc_exe_external: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var callbackFunctionName;
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.external) === null || _b === void 0 ? void 0 : _b.launchAppV2) === 'function') {
                                    callbackFunctionName = setCallbackConnect(params, callback, 'launchAppV2').callbackFunctionName;
                                    return [2 /*return*/, (_d = (_c = window) === null || _c === void 0 ? void 0 : _c.external) === null || _d === void 0 ? void 0 : _d.launchAppV2(params, callbackFunctionName)];
                                }
                                return [2 /*return*/, oldFn()];
                            });
                        }); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };
var hide$2 = function (_oldFn) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select({
                    pc_exe: _oldFn,
                    pc_exe_external: function () { return __awaiter(void 0, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                        return [2 /*return*/, (_b = (_a = win.external) === null || _a === void 0 ? void 0 : _a.hide) === null || _b === void 0 ? void 0 : _b.call(_a)];
                    }); }); }
                })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : _oldFn()];
        }
    });
}); }; };
var downloadApp$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                return [4 /*yield*/, select({
                        pc_exe: oldFn,
                        pc_exe_external: function () { return __awaiter(void 0, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                            return [2 /*return*/, (_b = (_a = win.external) === null || _a === void 0 ? void 0 : _a.downLoadApp) === null || _b === void 0 ? void 0 : _b.call(_a, params)];
                        }); }); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : _oldFn()];
        }
    });
}); }; };
var listenAppState = function (_oldFn) { return function (params, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params, cb); };
                return [4 /*yield*/, select({
                        pc_exe: oldFn,
                        pc_exe_external: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var callbackFunctionName;
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.external) === null || _b === void 0 ? void 0 : _b.listenAppState) === 'function') {
                                    callbackFunctionName = setCallbackConnect(params, cb, 'listenAppState').callbackFunctionName;
                                    return [2 /*return*/, (_c = win === null || win === void 0 ? void 0 : win.external) === null || _c === void 0 ? void 0 : _c.listenAppState(params, callbackFunctionName)];
                                }
                                return [2 /*return*/, oldFn()];
                            });
                        }); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };

/** 0:未初始化 1：未安装，跳转下载 2：启动成功 3:启动失败 */
var ELaunchPcGameState;
(function (ELaunchPcGameState) {
    /** 未初始化 */
    ELaunchPcGameState[ELaunchPcGameState["UN_INIT"] = 0] = "UN_INIT";
    /** 未安装，跳转下载 */
    ELaunchPcGameState[ELaunchPcGameState["DOWNLOAD"] = 1] = "DOWNLOAD";
    /** 启动成功 */
    ELaunchPcGameState[ELaunchPcGameState["START_SUCCESS"] = 2] = "START_SUCCESS";
    /** 启动失败 */
    ELaunchPcGameState[ELaunchPcGameState["START_FAIL"] = 3] = "START_FAIL";
})(ELaunchPcGameState || (ELaunchPcGameState = {}));
/**
 * 0未初始化, 1 未安装 2:下载安装中 3:已安装  4:下载或安装失败  5用户取消下载
 */
var InstallStateEnum;
(function (InstallStateEnum) {
    /** 未初始化 */
    InstallStateEnum["NOT_INIT"] = "0";
    /** 未安装 */
    InstallStateEnum["NOT_INSTALL"] = "1";
    /** 下载安装中 */
    InstallStateEnum["DOWNLOADING"] = "2";
    /** 已安装 */
    InstallStateEnum["INSTALLED"] = "3";
    /** 下载或安装失败 */
    InstallStateEnum["DOWNLOAD_INSTALLED_FAILED"] = "4";
    /** 用户取消下载 */
    InstallStateEnum["DOWNLOAD_CANCEL"] = "5";
})(InstallStateEnum || (InstallStateEnum = {}));
/**
 * 0未启动, 1启动中, 2启动完成, 3 启动失败 app未安装
 */
var LaunchStateEnum;
(function (LaunchStateEnum) {
    /** 未启动 */
    LaunchStateEnum["NOT_START"] = "0";
    /** 启动中 */
    LaunchStateEnum["STARTING"] = "1";
    /** 启动完成 */
    LaunchStateEnum["STARTED"] = "2";
    /** 启动失败 app未安装 */
    LaunchStateEnum["START_FAILED"] = "3";
})(LaunchStateEnum || (LaunchStateEnum = {}));

var _a$S;
var moduleName$R = 'HYPCLive';
var enhanceApiTypes$2 = enhanceApiTypesWithModule(moduleName$R);
/**
 * @description 监听应用状态变化
 * 使用`listenAppState`接口时，需要提前使用该方法监听
 */
var onAppStateChange = function (cb, appInfo) {
    var finalCb = function (res) {
        var appStateResult = parseJsonForNewPC(res);
        console.log('[appStateChange] 事件', appStateResult);
        if (appInfo && appInfo.PackageName !== appStateResult.PackageName)
            return;
        cb === null || cb === void 0 ? void 0 : cb(appStateResult);
    };
    HUYASdk.addEventListener('appStateChange', finalCb);
    return function () {
        HUYASdk.removeEventListener('appStateChange');
    };
};
var TIMEOUT_FOR_PC = 1200;
function wrapCompleteToPromise(fn, option) {
    return function (params) {
        return new Promise(function (resolve, reject) {
            var _a, _b;
            if (!params && (option === null || option === void 0 ? void 0 : option.checkEmpty)) {
                return reject({
                    message: "[" + (option === null || option === void 0 ? void 0 : option.fnName) + "] empty params",
                    platformValue: (_a = option === null || option === void 0 ? void 0 : option.platformValue) !== null && _a !== void 0 ? _a : 'unknown',
                    errorCode: ECode.timeout
                });
            }
            var timer = setTimeout(function () {
                var _a;
                reject({
                    message: "[" + (option === null || option === void 0 ? void 0 : option.fnName) + "] timeout",
                    platformValue: (_a = option === null || option === void 0 ? void 0 : option.platformValue) !== null && _a !== void 0 ? _a : 'unknown',
                    errorCode: ECode.timeout
                });
            }, (_b = option === null || option === void 0 ? void 0 : option.timeoutMS) !== null && _b !== void 0 ? _b : TIMEOUT_FOR_PC);
            fn(__assign(__assign({}, params), { complete: function (res) {
                    var _a;
                    clearTimeout(timer);
                    var result = parseJsonForNewPC(res);
                    (_a = params === null || params === void 0 ? void 0 : params.complete) === null || _a === void 0 ? void 0 : _a.call(params, result);
                    resolve(result);
                } }));
        });
    };
}
/** launchPcGame 拉起本地游戏
 * @param {json} ILaunchPcGameInfo - 游戏信息
 * @returns {Promise<ILaunchPcGameResp>} 返回游戏状态
 */
var launchPcGame = {
    name: 'launchPcGame',
    input: undefined,
    output: undefined
};
/**
 *  getAdvEnv 获取广告相关信息
 */
var getAdvEnv = {
    name: 'getAdvEnv',
    input: functionScheme.optional(),
    output: undefined
};
/**
 *  获取设备相关信息
 */
var getDeviceInfo$2 = {
    name: 'getDeviceInfo',
    input: functionScheme.optional(),
    output: undefined
};
/** downloadApp 触发游戏下载
 * @param {json} AppInfo - 游戏信息
 */
var downloadApp = {
    name: 'downloadApp',
    input: undefined,
    output: undefined
};
/** 启动 APP
 * @param {json} AppInfo - 游戏信息
 * @returns {Promise<ILaunchPcGameResp>} 返回游戏状态
 */
var launchApp = {
    name: 'launchApp',
    input: undefined,
    output: undefined
};
/** 设置窗口标题栏 */
var setTitle = {
    name: 'setTitle',
    input: mod.object({
        title: mod.string()
    }),
    output: undefined
};
/** 最小化窗口 */
var hide$1 = {
    name: 'hide',
    input: undefined,
    output: undefined
};
var launchAppApi = wrapCompleteToPromise(enhanceApiTypes$2(launchApp, {
    isUseSdk: true
}), {
    fnName: launchApp.name,
    platformValue: 'pc_exe',
    checkEmpty: true,
    /** pc端同事要求 5 秒 */
    timeoutMS: 5000
});
var HYPCLive = (_a$S = {},
    /**
     * @example
      ```ts
      HYPCLive.launchPcGame({
        // 游戏信息 ...
      })
        .then((res) => console.log('游戏状态信息', res))
        .catch((err) => console.log('调用api失败' + ':' + err?.message))
      ```
     * @description 拉起本地游戏.pc观众端 7.9.2.0 支持
     */
    _a$S[launchPcGame.name] = wrapCompleteToPromise(enhanceApiTypes$2(launchPcGame, {
        isUseSdk: true
    }), {
        fnName: launchPcGame.name,
        platformValue: 'pc_exe',
        checkEmpty: true,
        /** pc端同事要求 5 秒 */
        timeoutMS: 5000
    }),
    /**
     * @example
      ```ts
      HYPCLive.getAdvEnv({
        // 广告信息 ...
      })
        .then((res) => console.log('广告信息', res))
        .catch((err) => console.log('调用api失败' + ':' + err?.message))
      ```
     * @description 获取广告相关信息。pc观众端 6.1.0.0 支持
     */
    _a$S[getAdvEnv.name] = wrapCompleteToPromise(enhanceApiTypes$2(getAdvEnv, {
        isUseSdk: true
    }), {
        fnName: getAdvEnv.name,
        platformValue: 'pc_exe'
    }),
    /**
     * @example
      ```ts
      HYPCLive.getDeviceInfo({
        // 设备信息 ...
      })
        .then((res) => console.log('设备信息', res))
        .catch((err) => console.log('调用api失败' + ':' + err?.message))
      ```
     * @description 获取设备信息。pc观众端 7.9.2.0 支持
     */
    _a$S[getDeviceInfo$2.name] = wrapCompleteToPromise(enhanceApiTypes$2(getDeviceInfo$2, {
        isUseSdk: true
    }), {
        fnName: getDeviceInfo$2.name,
        platformValue: 'pc_exe'
    }),
    /**
     * @example
      ```ts
      HYPCLive.downloadApp({
        // 游戏信息 ...
      })
        .then((res) => console.log('sdk默认信息', res))
        .catch((err) => console.log('调用api失败' + ':' + err?.message))
      ```
     * @description 触发游戏下载。pc观众端 7.10.0.0 支持
     */
    _a$S[downloadApp.name] = downloadApp$1(wrapCompleteToPromise(enhanceApiTypes$2(downloadApp, {
        isUseSdk: true
    }), {
        fnName: downloadApp.name,
        platformValue: 'pc_exe',
        checkEmpty: true
    })),
    /**
     * @example
      ```ts
      HYPCLive.launchApp({
        // 游戏信息 ...
      })
        .then((res) => console.log('游戏状态信息', res))
        .catch((err) => console.log('调用api失败' + ':' + err?.message))
      ```
     * @description 启动 APP。pc观众端 7.10.0.0 支持
     */
    _a$S[launchApp.name] = launchAppApi,
    /**
     * @description 启动 APP。pc观众端 7.10.0.0 支持
     * - 为兼容旧版sdk使用方式而封装
     */
    _a$S.launchAppCompat = launchAppCompat(function (appInfo, callback) {
        var result = HYPCLive.launchApp(appInfo);
        result.then(function (resp) { return callback === null || callback === void 0 ? void 0 : callback(resp); });
        return result;
    }),
    /**
     * @example
      ```ts
      HYPCLive.setTitle({ title: "窗口标题" })
      // 旧版使用: window.external.setTitle("窗口标题")
      // 新版使用: HYPCLive.setTitle({ title: "窗口标题" })
      ```
     * @description 设置窗口标题栏。pc观众端 7.10.0.0 支持
     */
    _a$S[setTitle.name] = setTitle$1(wrapCompleteToPromise(enhanceApiTypes$2(setTitle, {
        isUseSdk: true
    }), {
        fnName: setTitle.name,
        platformValue: 'pc_exe',
        checkEmpty: true
    })),
    /**
     * @example
      ```ts
      HYPCLive.hide()
      ```
     * @description 最小化窗口。pc观众端 7.10.0.0 支持
     */
    _a$S[hide$1.name] = hide$2(wrapCompleteToPromise(enhanceApiTypes$2(hide$1, {
        isUseSdk: true
    }), {
        fnName: hide$1.name,
        platformValue: 'pc_exe'
    })),
    /**
     * @example
      ```ts
      // `getAppInstallState`、`getDownloadProcess`等方法都通过此方法替换
      HYPCLive.listenAppState(
        {
          // 游戏信息 ...
        },
        (appState) => console.log('app状态变化', appState)
      )
      ```
     * @description 获取APP状态。pc观众端 7.10.0.0 支持
     * - `getAppInstallState`、`getDownloadProcess`等方法都通过此方法替换
     */
    _a$S.listenAppState = listenAppState(function (appInfo, cb) {
        var fnName = 'listenAppState';
        var _listenAppStateFunction = wrapCompleteToPromise(generateCommonAPI(moduleName$R, fnName, undefined, {
            isUseSdk: true
        }), {
            fnName: fnName,
            platformValue: 'pc_exe'
        });
        onAppStateChange(cb, appInfo);
        return _listenAppStateFunction(appInfo);
    }),
    /**
     * @description 移除`appStateChange`事件监听
     */
    _a$S.unlistenAppState = function () {
        return HUYASdk.removeEventListener('appStateChange');
    },
    /**
     *
     * @description PC观众端暗黑模式，基于skinChange事件实现。pc 观众端版本 6.1.0.0
     * @see https://s1-static.huya.info/kiwisdkdoc/index.html#/modules?id=skinchange
     */
    _a$S.getDarkMode = function () {
        return new Promise(function (resolve) {
            // 监听后就会立马收到1次触发
            HUYASdk.addEventListener('skinChange', function (resp) {
                resolve({ darkmode: [1, '1', true].includes(resp.darkmode) });
            });
        });
    },
    _a$S.InstallStateEnum = InstallStateEnum,
    _a$S.LaunchStateEnum = LaunchStateEnum,
    _a$S);

/**
 * @file HYDevice 跨端实现
 * 旧版：支持端内（虎牙app端、pc端）
 * 新版：支持端内（虎牙app端、pc端、web主站、端外）
 */
var copyToClipboardInBrowser = function (str) {
    if (navigator.clipboard && window.parent === window) {
        navigator.clipboard.writeText(str);
        return;
    }
    var el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    var currentSelection = document.getSelection();
    if (currentSelection) {
        var selected = currentSelection.rangeCount > 0 ? currentSelection.getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
            currentSelection = document.getSelection();
            if (currentSelection) {
                currentSelection.removeAllRanges();
                currentSelection.addRange(selected);
            }
        }
    }
};
var copyToClipboard$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, _copyToClipboardInBrowser, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                _copyToClipboardInBrowser = function () {
                    if (!(params === null || params === void 0 ? void 0 : params.text))
                        return;
                    copyToClipboardInBrowser((params === null || params === void 0 ? void 0 : params.text) || '');
                };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: _copyToClipboardInBrowser,
                        pc_exe_external: _copyToClipboardInBrowser,
                        pc_anchor: _copyToClipboardInBrowser,
                        main_web_inner: _copyToClipboardInBrowser,
                        main_web_iframe: _copyToClipboardInBrowser,
                        outer_mobile: _copyToClipboardInBrowser,
                        outer_pc: _copyToClipboardInBrowser
                    })];
            case 1:
                action = _a.sent();
                action ? action() : oldFn();
                return [2 /*return*/, undefined];
        }
    });
}); }; };
var getCurrentNetworkType$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    /**
     * @description 网络类型 0.无网络 1.wifi, 2.4g/3g, 3. 有网络，但不确定是wifi还是4g/3g，非 app 环境会出现
     */
    function getNetworkType() {
        return __awaiter(this, void 0, void 0, function () {
            var navigator, connection, connectionType;
            return __generator(this, function (_a) {
                navigator = window.navigator;
                connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                connectionType = connection === null || connection === void 0 ? void 0 : connection.type;
                if (!window.navigator.onLine)
                    return [2 /*return*/, 0];
                if (connectionType === 'wifi')
                    return [2 /*return*/, 1];
                if (connectionType === 'cellular')
                    return [2 /*return*/, 2
                        // 即使是 2g 也算是有网络，虽然是极端场景
                    ];
                // 即使是 2g 也算是有网络，虽然是极端场景
                if (['slow-2g', '2g', '3g', '4g'].includes((connection === null || connection === void 0 ? void 0 : connection.effectiveType) || ''))
                    return [2 /*return*/, 2];
                if (window.navigator.onLine)
                    return [2 /*return*/, 3];
                return [2 /*return*/, 0];
            });
        });
    }
    var wrapForResult, oldFn, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                wrapForResult = function (fn) { return __awaiter(void 0, void 0, void 0, function () {
                    var result, _a;
                    var _b, _c, _d;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0:
                                result = { networkType: 0 };
                                _e.label = 1;
                            case 1:
                                _e.trys.push([1, 3, 4, 5]);
                                _a = result;
                                return [4 /*yield*/, fn()];
                            case 2:
                                _a.networkType = _e.sent();
                                (_b = params === null || params === void 0 ? void 0 : params.success) === null || _b === void 0 ? void 0 : _b.call(params, result);
                                return [3 /*break*/, 5];
                            case 3:
                                _e.sent();
                                (_c = params === null || params === void 0 ? void 0 : params.fail) === null || _c === void 0 ? void 0 : _c.call(params, result);
                                return [3 /*break*/, 5];
                            case 4:
                                (_d = params === null || params === void 0 ? void 0 : params.complete) === null || _d === void 0 ? void 0 : _d.call(params, result);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/, result];
                        }
                    });
                }); };
                oldFn = function () { return _oldFn(params); };
                return [4 /*yield*/, select({
                        app: oldFn,
                        kiwi: oldFn,
                        pitaya: oldFn,
                        /** 截止2024-12-18，getNetworkType 仅有观众端 app、小鹿 app支持，其他端走浏览器api */
                        zs: function () { return wrapForResult(getNetworkType); },
                        game: function () { return wrapForResult(getNetworkType); },
                        pc_exe: function () { return wrapForResult(getNetworkType); },
                        pc_exe_external: function () { return wrapForResult(getNetworkType); },
                        pc_anchor: function () { return wrapForResult(getNetworkType); },
                        main_web_inner: function () { return wrapForResult(getNetworkType); },
                        main_web_iframe: function () { return wrapForResult(getNetworkType); },
                        outer_mobile: function () { return wrapForResult(getNetworkType); },
                        outer_pc: function () { return wrapForResult(getNetworkType); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };
var getDarkMode$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    function isDarkMode() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches];
            });
        });
    }
    var wrapForResult, oldFn, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                wrapForResult = function (fn) { return __awaiter(void 0, void 0, void 0, function () {
                    var result, _a;
                    var _b, _c, _d;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0:
                                result = { darkmode: false };
                                _e.label = 1;
                            case 1:
                                _e.trys.push([1, 3, 4, 5]);
                                _a = result;
                                return [4 /*yield*/, fn()];
                            case 2:
                                _a.darkmode = _e.sent();
                                (_b = params === null || params === void 0 ? void 0 : params.success) === null || _b === void 0 ? void 0 : _b.call(params, result);
                                return [3 /*break*/, 5];
                            case 3:
                                _e.sent();
                                (_c = params === null || params === void 0 ? void 0 : params.fail) === null || _c === void 0 ? void 0 : _c.call(params, result);
                                return [3 /*break*/, 5];
                            case 4:
                                (_d = params === null || params === void 0 ? void 0 : params.complete) === null || _d === void 0 ? void 0 : _d.call(params, result);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/, result];
                        }
                    });
                }); };
                oldFn = function () { return _oldFn(params); };
                return [4 /*yield*/, select({
                        app: oldFn,
                        kiwi: oldFn,
                        pitaya: oldFn,
                        /** 截止2025-06-23，getDarkMode 仅有观众端 app、小鹿 app、PC观众端支持，其他端走浏览器api */
                        zs: function () { return wrapForResult(isDarkMode); },
                        game: function () { return wrapForResult(isDarkMode); },
                        pc_exe: function () {
                            return new Promise(function (resolve) {
                                var timer = setTimeout(function () {
                                    resolve(isDarkMode());
                                    console.log('[HYDevice.getDarkMode] pc_exe timeout, fallback to browser API');
                                }, 1500);
                                return HYPCLive.getDarkMode().then(function (_a) {
                                    var darkmode = _a.darkmode;
                                    clearTimeout(timer);
                                    resolve(darkmode);
                                });
                            });
                        },
                        pc_exe_external: function () { return wrapForResult(isDarkMode); },
                        pc_anchor: function () { return wrapForResult(isDarkMode); },
                        main_web_inner: function () { return wrapForResult(isDarkMode); },
                        main_web_iframe: function () { return wrapForResult(isDarkMode); },
                        outer_mobile: function () { return wrapForResult(isDarkMode); },
                        outer_pc: function () { return wrapForResult(isDarkMode); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };
var defaultAppInfo = {
    appVersion: '',
    systemVersion: '',
    appName: '',
    huyaUA: '',
    privilegeUseIAP: '',
    experiment: ''
};
function oldFnToPromiseFactory(options) {
    return new Promise(function (resolve, reject) {
        var timer = setTimeout(function () {
            var _a;
            reject({
                message: options.timeoutConfig.message || 'timeout',
                platformValue: (_a = options.timeoutConfig) === null || _a === void 0 ? void 0 : _a.platformValue,
                errorCode: ECode.timeout
            });
        }, 1000);
        options.oldFn(__assign(__assign({}, options.params), { complete: function (resp) {
                var _a, _b;
                clearTimeout(timer);
                (_b = (_a = options.params) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a, resp);
                resolve(resp);
            } }));
    });
}
var defaultDeviceInfo = {
    idfa: '',
    machineModel: '',
    guid: '',
    systemVersion: '',
    openUDID: '',
    insetTop: 0,
    sSdid: '',
    sUUID: '',
    androidid: '',
    imei: '',
    sQIMEI: ''
};
var getAppInfo$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, oldFnToPromise, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                oldFnToPromise = function (platformValue) {
                    return oldFnToPromiseFactory({
                        oldFn: _oldFn,
                        params: params,
                        timeoutConfig: {
                            platformValue: platformValue,
                            message: '[getAppInfo] timeout',
                            ms: 1000
                        }
                    });
                };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: function () { return oldFnToPromise('pc_exe'); },
                        pc_exe_external: function () {
                            return Promise.reject({
                                errorCode: ECode.hasNotJSBridge,
                                message: 'PC客户端external内核，暂不支持HUYASdk调用',
                                platformValue: 'pc_exe_external'
                            });
                        },
                        pc_anchor: function () { return oldFnToPromise('pc_anchor'); },
                        main_web_inner: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var nextRsp;
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        _e.trys.push([0, 3, , 4]);
                                        if (!(typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TT) === null || _b === void 0 ? void 0 : _b.getWebUaInfo) === 'function')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, ((_d = (_c = window) === null || _c === void 0 ? void 0 : _c.TT) === null || _d === void 0 ? void 0 : _d.getWebUaInfo())];
                                    case 1:
                                        nextRsp = _e.sent();
                                        return [2 /*return*/, __assign(__assign({}, defaultAppInfo), { appName: 'main_web_inner', huyaUA: nextRsp.webUa })];
                                    case 2: return [3 /*break*/, 4];
                                    case 3:
                                        _e.sent();
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/, Promise.reject({
                                            errorCode: ECode.hasNotJSBridge,
                                            message: 'window.TT 获取 UA 失败',
                                            platformValue: 'main_web_inner'
                                        })];
                                }
                            });
                        }); },
                        main_web_iframe: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var nextRsp;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, getMainRsp(null, 1000, 'GetWebUaInfoReq', 'GetWebUaInfoRes')];
                                    case 1:
                                        nextRsp = _a.sent();
                                        return [2 /*return*/, __assign(__assign({}, defaultAppInfo), { appName: 'main_web_iframe', huyaUA: nextRsp.webUa })];
                                    case 2:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/, Promise.reject({
                                            errorCode: ECode.hasNotJSBridge,
                                            message: '主站 iframe 获取 UA 失败',
                                            platformValue: 'main_web_iframe'
                                        })];
                                }
                            });
                        }); },
                        outer_mobile: function () {
                            return Promise.reject({
                                errorCode: ECode.hasNotJSBridge,
                                message: '暂不支持端外移动端',
                                platformValue: 'outer_mobile'
                            });
                        },
                        outer_pc: function () {
                            return Promise.reject({
                                errorCode: ECode.hasNotJSBridge,
                                message: '暂不支持端外pc端',
                                platformValue: 'outer_pc'
                            });
                        }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };
var getDeviceInfo$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, new Promise(function (resolve, reject) {
                                        var timer = setTimeout(function () {
                                            reject({
                                                message: '[getDeviceInfo] timeout',
                                                platformValue: 'pc_exe',
                                                errorCode: ECode.timeout
                                            });
                                        }, 3000);
                                        (function () { return __awaiter(void 0, void 0, void 0, function () {
                                            var pcDeviceInfo;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, HYPCLive.getDeviceInfo()];
                                                    case 1:
                                                        pcDeviceInfo = _a.sent();
                                                        clearTimeout(timer);
                                                        return [2 /*return*/, resolve(__assign(__assign({}, defaultDeviceInfo), pcDeviceInfo))];
                                                }
                                            });
                                        }); })();
                                    })];
                            });
                        }); },
                        pc_exe_external: oldFn,
                        pc_anchor: oldFn,
                        main_web_inner: oldFn,
                        main_web_iframe: oldFn,
                        outer_mobile: oldFn,
                        outer_pc: oldFn
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };
var getScreenSize$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, screenInfoInBrowser, oldFnToPromise, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                screenInfoInBrowser = {
                    screenWidth: window.innerWidth,
                    screenHeight: window.innerHeight
                };
                oldFnToPromise = function (platformValue) {
                    return oldFnToPromiseFactory({
                        oldFn: _oldFn,
                        params: params,
                        timeoutConfig: {
                            platformValue: platformValue,
                            message: '[getScreenSize] timeout',
                            ms: 1000
                        }
                    });
                };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: function () { return oldFnToPromise('pc_exe'); },
                        pc_exe_external: function () { return screenInfoInBrowser; },
                        pc_anchor: function () { return oldFnToPromise('pc_anchor'); },
                        main_web_inner: function () { return screenInfoInBrowser; },
                        main_web_iframe: function () { return screenInfoInBrowser; },
                        outer_mobile: function () { return screenInfoInBrowser; },
                        outer_pc: function () { return screenInfoInBrowser; }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };

var _a$R;
var moduleName$Q = 'HYDevice';
var getAppInfo = 'getAppInfo';
var getDeviceInfo = 'getDeviceInfo';
var copyToClipboard = 'copyToClipboard';
var getCurrentNetworkType = 'getCurrentNetworkType';
var getClientLocalIP = 'getClientLocalIP';
var getScreenSize = 'getScreenSize';
var getDarkMode = 'getDarkMode';
var getScreenRecordStatus = 'getScreenRecordStatus';
var forbidScreenRecord = 'forbidScreenRecord';
var setOrientation = 'setOrientation';
var on$a = 'on';
var off$a = 'off';
var paramsScheme$v = functionScheme.optional();
var copyToClipboardScheme = mod.object({
    text: mod.string()
});
var setOrientationScheme = mod.object({
    orientation: mod.union([mod.literal('portrait'), mod.literal('landscape')])
});
var willResignActive = 'WILL_RESIGN_ACTIVE';
var didBecomeActive = 'DID_BECOME_ACTIVE';
var networkChanged = 'NETWORK_CHANGED';
var screenRecordChanged = 'SCREEN_RECORD_CHANGED';
var HYDevice = (_a$R = {},
    _a$R[getAppInfo] = getAppInfo$1(generateCommonAPI(moduleName$Q, getAppInfo, paramsScheme$v, {
        isUseSdk: true
    })),
    _a$R[getDeviceInfo] = getDeviceInfo$1(generateCommonAPI(moduleName$Q, getDeviceInfo, paramsScheme$v, {
        isUseSdk: true
    })),
    _a$R[copyToClipboard] = copyToClipboard$1(generateCommonAPI(moduleName$Q, copyToClipboard, copyToClipboardScheme, {
        isUseSdk: true
    })),
    _a$R[getClientLocalIP] = generateCommonAPI(moduleName$Q, getClientLocalIP, paramsScheme$v, {
        isUseSdk: true
    }),
    _a$R[getCurrentNetworkType] = getCurrentNetworkType$1(generateCommonAPI(moduleName$Q, getCurrentNetworkType, paramsScheme$v, {
        isUseSdk: true
    })),
    _a$R[getScreenSize] = getScreenSize$1(generateCommonAPI(moduleName$Q, getScreenSize, paramsScheme$v, {
        isUseSdk: true
    })),
    _a$R[getDarkMode] = getDarkMode$1(function () {
        var func = generateCommonAPI(moduleName$Q, getDarkMode, paramsScheme$v, {
            isUseSdk: true
        });
        return func().then(function (_a) {
            var darkmode = _a.darkmode;
            return {
                darkmode: darkmode === 'true' || darkmode === 1
            };
        });
    }),
    _a$R[getScreenRecordStatus] = generateCommonAPI(moduleName$Q, getScreenRecordStatus, paramsScheme$v, {
        isUseSdk: true
    }),
    _a$R[forbidScreenRecord] = generateCommonAPI(moduleName$Q, forbidScreenRecord, paramsScheme$v, {
        isUseSdk: true
    }),
    _a$R[setOrientation] = generateCommonAPI(moduleName$Q, setOrientation, setOrientationScheme),
    _a$R[on$a] = generateCommonEvent(moduleName$Q, on$a),
    _a$R[off$a] = generateCommonEvent(moduleName$Q, off$a),
    _a$R);

var _a$Q, _b;
var ua = ((_b = (_a$Q = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a$Q === void 0 ? void 0 : _a$Q.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a$Q)) || '';
var isHarmonyOSMobile = /Harmony/i.test(navigator.userAgent) && /Mobile|Tablet/i.test(navigator.userAgent);
var isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) || isHarmonyOSMobile;
var isMainWebLink = function (url) { return url.indexOf('www') !== -1 && url.indexOf('.huya.com') !== -1; };
/**
 * @description 检查是否处于主站内嵌 iframe 中
 * - 注意：多层级 iframe 无法识别
 * - 用直播间的获取用户信息的方法来识别，暂无非直播间嵌入 h5 的场景
 */
var checkMainWebIframe = once(function () { return __awaiter(void 0, void 0, void 0, function () {
    var promise;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(window.parent !== window)) return [3 /*break*/, 2];
                promise = getGlobalValue(function () {
                    return getMainRsp(null, 1500, 'UserInfoReq', 'UserInfoRes');
                }, 'checkMainWebIframe');
                return [4 /*yield*/, promise
                    // 非超时说明处于主站中
                ];
            case 1:
                _a.sent();
                // 非超时说明处于主站中
                return [2 /*return*/, true];
            case 2: return [2 /*return*/, false];
        }
    });
}); });
/**
 * @description 快速判断是否被主站嵌入
 * - 缺点：一旦通过 location.href、location.replace 等方法跳转后的页面，document.referrer 都会变化，此时判断失效
 */
var checkMainWebIframeSync = function () {
    return window.parent !== window && isMainWebLink(document.referrer);
};
var getAppName = once(function (defaultName) {
    if (defaultName === void 0) { defaultName = ''; }
    return new Promise(function (resolve) {
        var timer = setTimeout(function () {
            resolve(defaultName);
        }, 1000);
        HYDevice === null || HYDevice === void 0 ? void 0 : HYDevice.getAppInfo({
            complete: function (resp) {
                clearTimeout(timer);
                resp = parseRespJson(resp);
                var result = (function () {
                    var appName = (resp === null || resp === void 0 ? void 0 : resp.appName) || '';
                    if (HUYAConfig.isHuyaApp(appName))
                        return 'kiwi';
                    if (HUYAConfig.isPitayaApp(appName))
                        return 'pitaya';
                    if (HUYAConfig.isHuyaLive(appName))
                        return 'zs';
                    if (HUYAConfig.isHuyaGame(appName))
                        return 'game';
                    return defaultName ? defaultName : appName;
                })();
                resolve(result);
            }
        });
    });
});
var canUseSDKForPC = once(function () { return __awaiter(void 0, void 0, void 0, function () {
    var appName;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAppName('')];
            case 1:
                appName = (_a.sent());
                return [2 /*return*/, appName === 'huya-pc'];
        }
    });
}); });
var simplePlatform = (function () {
    /** pc 主播端 */
    if (/pc_exe_template/.test(ua))
        return 'pc_anchor';
    /** pc 观众端。注意，pc主播端也会有这个huya-pc，所以要提前判断 */
    if (/huya-pc/.test(ua))
        return 'pc_exe';
    /** app 环境：虎牙观众端、助手端、小鹿等 */
    if (HUYASdk$1.isInHuyaApp())
        return 'app';
    if (isMobile && ['huya-zs', 'huya'].some(function (key) { return ua.indexOf(key) !== -1; }))
        return 'app';
    /** 在 web 主站内部 */
    if (isMainWebLink(window.location.origin))
        return 'main_web_inner';
    /** 被 web 主站用 iframe 嵌入 */
    if (checkMainWebIframeSync())
        return 'main_web_iframe';
    /** 端外-移动端场景 */
    if (isMobile)
        return 'outer_mobile';
    /** 被 web 主站用 iframe 嵌入/端外pc场景(电脑浏览器)/其他 web 场景 */
    return 'web_mode_pc';
})();
/**
 * @warning 需要在dom加载完再执行，否则 getBridge() 会执行错误
 * @description 客户端环境适配简化版
 * @example
    ```ts
      const reportNum = simpleSelect({
        // 虎牙app
        app: 1,
        // pc 观众端
        pc_exe: 2,
        // pc 主播端
        pc_anchor: 3,
        // web 主站内部
        main_web_inner: 4,
        // 端外-移动端场景
        outer_mobile: 5,
        // 被 web 主站用 iframe 嵌入/端外pc场景(电脑浏览器)/其他 web 场景
        web_mode_pc: 6,
      })
    ```
 */
function simpleSelect(params) {
    var _a;
    var platformOverride = (_a = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.getInnerConfig()) === null || _a === void 0 ? void 0 : _a.platformOverride;
    if (platformOverride)
        return params[platformOverride];
    return params[simplePlatform];
}
/** kiwi-虎牙观众端，pitaya-小鹿app，zs-虎牙助手端，game-虎牙手游，app-未知虎牙app */
var APP_VALUE = ['kiwi', 'pitaya', 'zs', 'game', 'app'];
/** pc_exe--PC观众端-支持 HUYASdk 交互, pc_exe_external--PC观众端-不支持 HUYASdk，external方式交互*/
var PC_EXE_VALUE = ['pc_exe', 'pc_exe_external'];
/** main_web_iframe-被 web 主站用 iframe 嵌入；outer_pc-端外pc场景(电脑浏览器)/其他 web 场景 */
var WEB_MODE_PC_VALUE = ['main_web_iframe', 'outer_pc', 'web_mode_pc'];
var getPlatformOS = once(function () { return __awaiter(void 0, void 0, void 0, function () {
    var action;
    return __generator(this, function (_a) {
        action = simpleSelect({
            app: function () { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getAppName('app')];
                        case 1:
                            result = (_a.sent()) || 'app';
                            return [2 /*return*/, result];
                    }
                });
            }); },
            pc_exe: function () { return __awaiter(void 0, void 0, void 0, function () {
                var canUseSDK;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, canUseSDKForPC()];
                        case 1:
                            canUseSDK = _a.sent();
                            return [2 /*return*/, canUseSDK ? 'pc_exe' : 'pc_exe_external'];
                    }
                });
            }); },
            web_mode_pc: function () { return __awaiter(void 0, void 0, void 0, function () {
                var isMainWebIframe;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            if (checkMainWebIframeSync())
                                return [2 /*return*/, 'main_web_iframe'];
                            return [4 /*yield*/, checkMainWebIframe()];
                        case 1:
                            isMainWebIframe = _a.sent();
                            if (isMainWebIframe)
                                return [2 /*return*/, 'main_web_iframe'];
                            return [2 /*return*/, 'outer_pc'];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, 'outer_pc'];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
            outer_mobile: function () { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getAppName('')];
                        case 1:
                            result = _a.sent();
                            if (result)
                                return [2 /*return*/, result];
                            return [2 /*return*/, 'outer_mobile'];
                    }
                });
            }); }
        });
        return [2 /*return*/, action ? action() : simplePlatform];
    });
}); });
/**
 * @description 客户端环境适配
 * @example
    ```ts
      const reportNum = await select({
        // 虎牙观众端
        kiwi: 1,
        // 小鹿app
        pitaya: 2,
        // 虎牙助手端
        zs: 3,
        // 虎牙手游
        game: 4,
        // 未知虎牙app，或兜底 app 场景
        app: 5,
        // pc 观众端-支持 HUYASdk 交互, 或兜底 pc 观众端场景
        pc_exe: 6,
        // pc 观众端-不支持 HUYASdk，external方式交互
        pc_exe_external: 7,
        // pc 主播端
        pc_anchor: 8,
        // web 主站内部
        main_web_inner: 9,
        // 被 web 主站用 iframe 嵌入
        main_web_iframe: 10,
        // 端外-移动端场景
        outer_mobile: 11,
        // 端外-pc端电脑浏览器场景/或其他 web 场景，如个人中心/视频站
        outer_pc: 12,
      })
    ```
 */
function select(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var platformOverride, platformOSValue, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    platformOverride = (_a = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.getInnerConfig()) === null || _a === void 0 ? void 0 : _a.platformOverride;
                    if (!platformOverride) return [3 /*break*/, 1];
                    _b = platformOverride;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, getPlatformOS()];
                case 2:
                    _b = _c.sent();
                    _c.label = 3;
                case 3:
                    platformOSValue = _b;
                    if (APP_VALUE.some(function (key) { return key === platformOSValue; })) {
                        return [2 /*return*/, params[platformOSValue] || params['app']];
                    }
                    if (PC_EXE_VALUE.some(function (key) { return key === platformOSValue; })) {
                        return [2 /*return*/, params[platformOSValue] || params['pc_exe']];
                    }
                    if (WEB_MODE_PC_VALUE.some(function (key) { return key === platformOSValue; })) {
                        return [2 /*return*/, params[platformOSValue] || params['outer_pc']];
                    }
                    return [2 /*return*/, params[platformOSValue]];
            }
        });
    });
}
/**
 * @description 初始化内部判断
 */
var initPlatformCheck = once(function () {
    runWhenIdle(getPlatformOS);
});

var PlatformCompat = /*#__PURE__*/Object.freeze({
    __proto__: null,
    checkMainWebIframe: checkMainWebIframe,
    checkMainWebIframeSync: checkMainWebIframeSync,
    canUseSDKForPC: canUseSDKForPC,
    simplePlatform: simplePlatform,
    simpleSelect: simpleSelect,
    getPlatformOS: getPlatformOS,
    select: select,
    initPlatformCheck: initPlatformCheck
});

var _a$P;
var moduleName$P = 'HYGift';
var showGiftPanel = 'showGiftPanel';
var sendGift = 'sendGift';
var showGiftPanelScheme = mod
    .object({
    tabName: mod.string().optional(),
    giftId: mod.number().optional()
})
    .merge(functionScheme)
    .optional();
var sendGiftScheme = mod.object({
    giftId: mod.string(),
    giftCount: mod.number(),
    presenteeUid: mod.number().optional(),
    // 12.0.0 版本以上支持
    forceAlert: mod.string().optional(),
    alertKey: mod.string().optional(),
    showPrompt: mod.string().optional(),
    forceRecord: mod.string().optional(),
    /**
     * - 送礼来源，例如粉丝牌送礼来源为成为粉丝拉起的界面，或者来源于福袋（此字段一般可以不填，特殊统计地方可以和产品协商便于统计）
     * - 虎牙观众端 12.5.40 版本及以上支持
     */
    srcType: mod.string().optional()
});
var HYGift = (_a$P = {},
    _a$P[showGiftPanel] = generateCommonAPI(moduleName$P, showGiftPanel, showGiftPanelScheme, {
        isUseSdk: true
    }),
    _a$P[sendGift] = generateCommonAPI(moduleName$P, sendGift, sendGiftScheme, {
        isUseSdk: true
    }),
    _a$P);

var defaultChannelInfo = {
    aSid: '',
    topSid: '',
    subSid: '',
    presenterId: 0,
    presenterName: '',
    currentNickName: '',
    currentLogoUrl: '',
    currentUid: 0,
    presenterLogoUrl: '',
    durationAfterJoinSuccess: 0,
    gameId: '',
    subscribeState: 0,
    isLiving: 0
};
var DEFAULT_USER_INFO = {
    uid: getCookie('udb_uid') || 0,
    nick: '',
    avatar: ''
};
var currentChannelInfo$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, oldFnToPromise, wrapForResult, webDataToChannelInfo, currentChannelInWindow, currentChannelInIframe, currentChannelNotSupport, currentChannelInPCExternal, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                oldFnToPromise = function (platformValue) {
                    return new Promise(function (resolve, reject) {
                        var timer = setTimeout(function () {
                            reject({
                                message: '[currentChannelInfo] timeout',
                                platformValue: platformValue,
                                errorCode: ECode.timeout
                            });
                        }, 3000);
                        _oldFn(__assign(__assign({}, params), { complete: function (resp) {
                                var _a;
                                clearTimeout(timer);
                                var result = parseRespJson(resp);
                                (_a = params === null || params === void 0 ? void 0 : params.complete) === null || _a === void 0 ? void 0 : _a.call(params, result);
                                resolve(result);
                            } }));
                    });
                };
                wrapForResult = function (fn) { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    var _a, _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                result = defaultChannelInfo;
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, 4, 5]);
                                return [4 /*yield*/, fn()];
                            case 2:
                                result = _d.sent();
                                (_a = params === null || params === void 0 ? void 0 : params.success) === null || _a === void 0 ? void 0 : _a.call(params, result);
                                return [3 /*break*/, 5];
                            case 3:
                                _d.sent();
                                (_b = params === null || params === void 0 ? void 0 : params.fail) === null || _b === void 0 ? void 0 : _b.call(params, result);
                                return [3 /*break*/, 5];
                            case 4:
                                (_c = params === null || params === void 0 ? void 0 : params.complete) === null || _c === void 0 ? void 0 : _c.call(params, result);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/, result];
                        }
                    });
                }); };
                webDataToChannelInfo = function (roomData, profileDataInWeb, userInfo) {
                    var _a, _b;
                    if (!roomData || !profileDataInWeb || !userInfo)
                        return __assign({}, defaultChannelInfo);
                    return __assign(__assign({}, defaultChannelInfo), { aSid: roomData.id, topSid: roomData.channel, subSid: roomData.sid, presenterId: profileDataInWeb.lp, presenterName: profileDataInWeb.nick, currentNickName: (_a = userInfo.userNick) !== null && _a !== void 0 ? _a : userInfo.nick, currentLogoUrl: (_b = userInfo.userLogo) !== null && _b !== void 0 ? _b : userInfo.avatar, currentUid: userInfo.uid, presenterLogoUrl: profileDataInWeb.avatar, gameId: String(roomData.gid), subscribeState: 0, isLiving: roomData.state === 'ON' ? 1 : 0 });
                };
                currentChannelInWindow = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var roomData, profileData, getUserInfo, userInfo;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                roomData = window.TT_ROOM_DATA;
                                profileData = window.TT_PROFILE_INFO;
                                getUserInfo = function () {
                                    return new Promise(function (resolve) {
                                        var _a, _b;
                                        var TTgetUserInfo = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TT) === null || _b === void 0 ? void 0 : _b.getUserInfo;
                                        if (typeof TTgetUserInfo !== 'function') {
                                            return resolve(DEFAULT_USER_INFO);
                                        }
                                        var timer = setTimeout(function () {
                                            resolve(DEFAULT_USER_INFO);
                                        }, 3000);
                                        TTgetUserInfo(function (resp) {
                                            clearTimeout(timer);
                                            resolve(resp);
                                        });
                                    });
                                };
                                return [4 /*yield*/, getUserInfo()];
                            case 1:
                                userInfo = _a.sent();
                                return [2 /*return*/, webDataToChannelInfo(roomData, profileData, userInfo)];
                        }
                    });
                }); };
                currentChannelInIframe = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a, roomData, profileData, userInfo;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, Promise.all([
                                    getMainRsp(null, 3000, 'RoomInfoReq', 'RoomInfoRes'),
                                    getMainRsp(null, 3000, 'RoomPresenterInfoReq', 'RoomPresenterInfoRes'),
                                    getMainRsp(null, 3000, 'UserInfoReq', 'UserInfoRes')
                                ])];
                            case 1:
                                _a = __read.apply(void 0, [_b.sent(), 3]), roomData = _a[0], profileData = _a[1], userInfo = _a[2];
                                return [2 /*return*/, webDataToChannelInfo(roomData, profileData, userInfo)];
                        }
                    });
                }); };
                currentChannelNotSupport = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/, (__assign({}, defaultChannelInfo))];
                }); }); };
                currentChannelInPCExternal = function () {
                    // https://s1-static.huya.info/pc-external-js-sdk-doc/index.html#/quick-start?id=commons
                    return new Promise(function (resolve, reject) {
                        var _a, _b;
                        var win = window;
                        var cbName = "pc_getChannelInfo_invoke_" + Date.now();
                        win[cbName] = function (resp) {
                            var info = parseRespJson(resp);
                            // if (typeof listener === 'function') {
                            //   listener(info)
                            // }
                            resolve(info);
                        };
                        if ((_a = win.external) === null || _a === void 0 ? void 0 : _a.getChannelInfo) {
                            (_b = win.external) === null || _b === void 0 ? void 0 : _b.getChannelInfo(cbName);
                        }
                        else {
                            reject({
                                errorCode: ECode.hasNotJSBridge,
                                message: '[currentChannelInfo] PC客户端external内核，暂不支持HUYASdk调用',
                                platformValue: 'pc_exe_external'
                            });
                        }
                    });
                };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: function () { return oldFnToPromise('pc_exe'); },
                        pc_anchor: function () { return oldFnToPromise('pc_anchor'); },
                        pc_exe_external: function () { return wrapForResult(currentChannelInPCExternal); },
                        main_web_inner: function () { return wrapForResult(currentChannelInWindow); },
                        main_web_iframe: function () { return wrapForResult(currentChannelInIframe); },
                        outer_mobile: function () { return wrapForResult(currentChannelNotSupport); },
                        outer_pc: function () { return wrapForResult(currentChannelNotSupport); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };

var _a$O;
var moduleName$O = 'HYLive';
var getChannelIds = 'getChannelIds';
var getTraceId = 'getTraceId';
var currentChannelInfo = 'currentChannelInfo';
var getJumpChannelInfo = 'getJumpChannelInfo';
var joinChannel = 'joinChannel';
var leaveChannel = 'leaveChannel';
var isFullScreen = 'isFullScreen';
var setAudioMute = 'setAudioMute';
var getJoinMicUserList = 'getJoinMicUserList';
var getRefInfo = 'getRefInfo';
var on$9 = 'on';
var off$9 = 'off';
var liveFunctionScheme = functionScheme.optional();
mod.object({
    aSid: mod.string(),
    topSid: mod.string(),
    subSid: mod.string(),
    presenterId: mod.number(),
    presenterName: mod.string(),
    currentNickName: mod.string(),
    currentLogoUrl: mod.string(),
    currentUid: mod.number(),
    presenterLogoUrl: mod.string(),
    durationAfterJoinSuccess: mod.number(),
    gameId: mod.string(),
    subscribeState: mod.number(),
    isLiving: mod.number() //		是否开播 1正在直播，0不在直播
});
mod.object({
    anchoruid: mod.number(),
    channelid: mod.number(),
    subchannelid: mod.number(),
    presentername: mod.string()
});
mod.object({
    isFullScreen: mod.boolean()
});
var setAudioMuteScheme = mod.object({
    isMute: mod.boolean()
});
var kKWJSSdkEventIdApp = 'kKWJSSdkEventIdApp';
var HYLive = (_a$O = {},
    _a$O[getChannelIds] = generateCommonAPI(moduleName$O, getChannelIds, liveFunctionScheme),
    _a$O[getTraceId] = generateCommonAPI(moduleName$O, getTraceId),
    _a$O[getRefInfo] = generateCommonAPI(moduleName$O, getRefInfo),
    // @ts-ignore
    _a$O[currentChannelInfo] = currentChannelInfo$1(generateCommonAPI(moduleName$O, currentChannelInfo, liveFunctionScheme, {
        isUseSdk: true
    })),
    _a$O[getJumpChannelInfo] = generateCommonAPI(moduleName$O, getJumpChannelInfo, liveFunctionScheme, {
        isUseSdk: true
    }),
    _a$O[joinChannel] = generateCommonAPI(moduleName$O, joinChannel, liveFunctionScheme),
    _a$O[leaveChannel] = generateCommonAPI(moduleName$O, leaveChannel, liveFunctionScheme),
    _a$O[isFullScreen] = generateCommonAPI(moduleName$O, isFullScreen, liveFunctionScheme),
    _a$O[setAudioMute] = generateCommonAPI(moduleName$O, setAudioMute, setAudioMuteScheme),
    _a$O[getJoinMicUserList] = generateCommonAPI(moduleName$O, getJoinMicUserList),
    _a$O[on$9] = generateCommonEvent(moduleName$O, on$9),
    _a$O[off$9] = generateCommonEvent(moduleName$O, off$9),
    _a$O);

var _a$N;
var moduleName$N = 'HYLivingRoomActivity';
var isActivityWindowExpanded = 'isActivityWindowExpanded';
var expandActivityWindow = 'expandActivityWindow';
var on$8 = 'on';
var off$8 = 'off';
var activityWindowSizeChanged = 'ACTIVITY_WINDOW_SIZE_CHANGED';
var expandActivityWindowScheme = mod.object({
    expand: mod.boolean()
});
var isActivityWindowExpandedScheme = mod.string().optional();
var HYLivingRoomActivity = (_a$N = {},
    _a$N[isActivityWindowExpanded] = generateCommonAPI(moduleName$N, isActivityWindowExpanded, isActivityWindowExpandedScheme, { isUseSdk: true }),
    _a$N[expandActivityWindow] = generateCommonAPI(moduleName$N, expandActivityWindow, expandActivityWindowScheme, { isUseSdk: true }),
    _a$N[on$8] = generateCommonEvent(moduleName$N, on$8),
    _a$N[off$8] = generateCommonEvent(moduleName$N, off$8),
    _a$N);

var Constants = {
    /** openUrl 事件 */
    EVENT_NAME_OPEN_URL_IN_WEB: 'openurl_in_web',
    /** 是否处于 web 宿主环境事件 */
    EVENT_NAME_IS_IN_WEB: 'kiwi_sdk_is_in_web',
    /** 在 window 注入方法名 */
    INJECT_GLOBAL_OPENURL_URL_NAME: '__kiwi_sdk_global_openurl_fn__'
};

var EOpenUrlCodeWeb;
(function (EOpenUrlCodeWeb) {
    /** 成功打开 */
    EOpenUrlCodeWeb[EOpenUrlCodeWeb["success"] = 0] = "success";
    /** 参数错误 */
    EOpenUrlCodeWeb[EOpenUrlCodeWeb["paramError"] = 1] = "paramError";
    /** 未定义的接口名 */
    EOpenUrlCodeWeb[EOpenUrlCodeWeb["notFound"] = 2] = "notFound";
    /** 默认错误 */
    EOpenUrlCodeWeb[EOpenUrlCodeWeb["defaultFail"] = 3] = "defaultFail";
    /** 执行错误 */
    EOpenUrlCodeWeb[EOpenUrlCodeWeb["logicError"] = 4] = "logicError";
})(EOpenUrlCodeWeb || (EOpenUrlCodeWeb = {}));
({
    code: EOpenUrlCodeWeb.defaultFail,
    msg: '打开失败',
    data: {}
});
({
    code: EOpenUrlCodeWeb.success,
    msg: '打开成功',
    data: null
});
/**
 * @description 优先执行全局 openUrl，否则执行 fallback
 */
var runInGlobalOpenUrl = function (options, fallback) {
    var openUrlGlobal = window[Constants.INJECT_GLOBAL_OPENURL_URL_NAME];
    if (typeof openUrlGlobal === 'function')
        return openUrlGlobal(options);
    return fallback === null || fallback === void 0 ? void 0 : fallback();
};
/**
 * @description 通知 web 端（如 web 主站、视频站...）打开 hyaction
 */
var emitOpenUrlInWeb = function (options) {
    if (getBridge$1())
        return;
    return runInGlobalOpenUrl(options, function () {
        window.parent.postMessage(JSON.stringify({
            type: Constants.EVENT_NAME_OPEN_URL_IN_WEB,
            data: options
        }), '*');
    });
};

var openUrl$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, openUrlInOuter, isMainWebLink, isMLink, hasHyactionParams, shouldUseOpenApp, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                openUrlInOuter = function (params) {
                    return runInGlobalOpenUrl(params, function () { return window.open(params.url); });
                };
                isMainWebLink = function (url) {
                    return url.indexOf('www') !== -1 && url.indexOf('.huya.com') !== -1;
                };
                isMLink = function (url) { return url.indexOf('m.huya.com') !== -1; };
                hasHyactionParams = function (url) { return url.indexOf('hyaction=') !== -1; };
                shouldUseOpenApp = function (url) {
                    return (isMainWebLink(url) || isMLink(url)) && hasHyactionParams(url);
                };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: oldFn,
                        pc_exe_external: function () {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            // copy from pc-external-js-sdk
                            if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.external) === null || _b === void 0 ? void 0 : _b.openGameURL) === 'function') {
                                return (_d = (_c = window) === null || _c === void 0 ? void 0 : _c.external) === null || _d === void 0 ? void 0 : _d.openGameURL(params.url);
                            }
                            // WebJumpUrlCallback: (
                            //   url: string, // 跳转的url
                            //   webToken?: boolean, // webToken 登录态
                            //   shouldCloseWnd?: boolean // 打开链接时是否关闭当前窗口
                            // ) => void;
                            if (typeof ((_f = (_e = window) === null || _e === void 0 ? void 0 : _e.external) === null || _f === void 0 ? void 0 : _f.webJumpUrlCallback) === 'function') {
                                return (_h = (_g = window) === null || _g === void 0 ? void 0 : _g.external) === null || _h === void 0 ? void 0 : _h.webJumpUrlCallback(params.url, true, false);
                            }
                            return openUrlInOuter(params);
                        },
                        pc_anchor: oldFn,
                        main_web_inner: function () { return emitOpenUrlInWeb(params); },
                        main_web_iframe: function () { return emitOpenUrlInWeb(params); },
                        outer_mobile: function () {
                            if (shouldUseOpenApp(params.url))
                                return openAppByCDN({ url: encodeURIComponent(params.url) });
                            openUrlInOuter(params);
                        },
                        outer_pc: function () {
                            var _a;
                            if ((_a = window) === null || _a === void 0 ? void 0 : _a.TT)
                                return emitOpenUrlInWeb(params);
                            if (shouldUseOpenApp(params.url))
                                return openAppByCDN({ url: encodeURIComponent(params.url) });
                            openUrlInOuter(params);
                        }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };

var _a$M;
var moduleName$M = 'HYRouter';
var showExchange = 'showExchange';
var showPrivileges = 'showPrivileges';
var showGuard = 'showGuard';
var openUrl = 'openUrl';
var quit = 'quit';
var canOpenApp = 'canOpenApp';
var goBack = 'goBack';
var showExchangeScheme = mod.object({
    // type: z.enum(['silver', 'ycoin', 'golden'])
    type: mod.string()
});
var showPrivilegesScheme = functionScheme.extend({
    type: mod.string(),
    needYYCoin: mod.string(),
    nobleLevel: mod.string(),
    nobleName: mod.string(),
    transmitData: mod.any(),
    needBackRefresh: mod.boolean() //返回页面时是否需要刷新
});
var showGuardScheme = functionScheme.extend({
    type: mod.string(),
    needYYCoin: mod.string(),
    guardLevelBefore: mod.string(),
    guardLevel: mod.string(),
    transmitData: mod.any(),
    needBackRefresh: mod.boolean(),
    month: mod.string(),
    presenterUid: mod.string(),
    presenterNick: mod.string(),
    presenterYYId: mod.string() //主播yy号
});
var openUrlScheme = mod.object({
    url: mod.string()
});
var quitScheme = mod
    .object({
    source: mod.string(),
    data: mod.any().optional()
})
    .partial({
    source: true
});
var canOpenAppScheme = functionScheme.extend({
    appkey: mod.string() //scheme或包名
});
var goBackScheme = functionScheme.optional();
var HYRouter = (_a$M = {},
    _a$M[showExchange] = generateCommonAPI(moduleName$M, showExchange, showExchangeScheme, { isUseSdk: true }),
    _a$M[showPrivileges] = generateCommonAPI(moduleName$M, showPrivileges, showPrivilegesScheme, { isUseSdk: true }),
    _a$M[showGuard] = generateCommonAPI(moduleName$M, showGuard, showGuardScheme, {
        isUseSdk: true
    }),
    _a$M[openUrl] = openUrl$1(function (params) {
        var func = generateCommonAPI(moduleName$M, openUrl, openUrlScheme, {
            isUseSdk: true
        });
        return func(params);
    }),
    _a$M[quit] = generateCommonAPI(moduleName$M, quit, quitScheme, { isUseSdk: true }),
    _a$M[canOpenApp] = generateCommonAPI(moduleName$M, canOpenApp, canOpenAppScheme, {
        isUseSdk: true
    }),
    _a$M[goBack] = generateCommonAPI(moduleName$M, goBack, goBackScheme, { isUseSdk: true }),
    _a$M);

/**
 * @file HYUserInfo 跨端实现
 * 旧版：支持端内（虎牙app端、pc端）
 * 新版：支持端内（虎牙app端、pc端、web主站、端外）
 */
var defaultUserInfo = {
    imid: 0,
    uid: 0,
    status: '',
    udbToken: '',
    ticketType: '',
    avatarUrl: '',
    sex: '',
    name: '',
    sign: '',
    userLevel: 0,
    userCurrentExp: 0,
    nextLeveExp: 0,
    dailyExp: 0,
    nobleInfo: {
        isNoble: false,
        uid: 0,
        validDate: 0,
        nobleName: '',
        nobleLevel: 0,
        nobleNick: '',
        channelInfo: {
            tid: '',
            sid: '',
            pid: 0,
            presenterNick: '',
            isGuard: false,
            guardLevel: 0,
            isFans: false,
            fansLevel: 0,
            fansName: ''
        }
    }
};
var getCurrentUserInfo$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, wrapForResult, getUserByCookieAndTafApi, wrapTafApi, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                wrapForResult = function (fn) { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    var _a, _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                result = defaultUserInfo;
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, 4, 5]);
                                return [4 /*yield*/, fn()];
                            case 2:
                                result = _d.sent();
                                (_a = params === null || params === void 0 ? void 0 : params.success) === null || _a === void 0 ? void 0 : _a.call(params, result);
                                return [3 /*break*/, 5];
                            case 3:
                                _d.sent();
                                (_b = params === null || params === void 0 ? void 0 : params.fail) === null || _b === void 0 ? void 0 : _b.call(params, result);
                                return [3 /*break*/, 5];
                            case 4:
                                (_c = params === null || params === void 0 ? void 0 : params.complete) === null || _c === void 0 ? void 0 : _c.call(params, result);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/, result];
                        }
                    });
                }); };
                getUserByCookieAndTafApi = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var conf, uid, tafApi, _a, GetUserProfileRsp, NobleInfoRsp;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                conf = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.getInnerConfig();
                                if (!conf.tafApiConfig)
                                    return [2 /*return*/, defaultUserInfo];
                                uid = getCookie('udb_uid');
                                if (!Number(uid))
                                    return [2 /*return*/, defaultUserInfo];
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 4, , 5]);
                                return [4 /*yield*/, fetchTafApi()];
                            case 2:
                                tafApi = _b.sent();
                                tafApi.configure(conf.tafApiConfig);
                                return [4 /*yield*/, Promise.all([
                                        tafApi.getUserProfile({ lUid: uid }),
                                        tafApi.GetNobleInfo({ lUid: uid })
                                    ])];
                            case 3:
                                _a = __read.apply(void 0, [_b.sent(), 2]), GetUserProfileRsp = _a[0], NobleInfoRsp = _a[1];
                                return [2 /*return*/, __assign(__assign({}, defaultUserInfo), { imid: GetUserProfileRsp.tUserProfile.tUserBase.lYYId, uid: uid, udbToken: getCookie('udb_biztoken') || '', status: 'ok', avatarUrl: GetUserProfileRsp.tUserProfile.tUserBase.sAvatarUrl, sex: String(GetUserProfileRsp.tUserProfile.tUserBase.iGender), name: GetUserProfileRsp.tUserProfile.tUserBase.sNickName, sign: GetUserProfileRsp.tUserProfile.tUserBase.sSign, userLevel: GetUserProfileRsp.tUserProfile.tUserBase.iUserLevel, userCurrentExp: Number(GetUserProfileRsp.tUserProfile.tUserBase.lUserExp), nobleInfo: __assign(__assign({}, defaultUserInfo.nobleInfo), { 
                                            /**
                                             // 贵族状态
                                              export enum NobleStatus {
                                                ISNOT_NOBLE = 1, // 不是贵族
                                                IS_NOBLE = 2, // 是贵族
                                                LESS_DAY_NOBLE = 3, // 有效期少于N天的贵族
                                                PROTECT_NOBLE = 4, // 已过期,在N天保护期里的贵族
                                              }
                                             */
                                            isNoble: NobleInfoRsp.tInfo.iNobleStatus !== 1, nobleName: NobleInfoRsp.tInfo.sNobleName, nobleLevel: NobleInfoRsp.tInfo.iNobleLevel, nobleNick: GetUserProfileRsp.tUserProfile.tUserBase.sNickName, uid: uid, validDate: Number(NobleInfoRsp.tInfo.lValidDate) }) })];
                            case 4:
                                _b.sent();
                                return [2 /*return*/, defaultUserInfo];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); };
                wrapTafApi = function () { return wrapForResult(getUserByCookieAndTafApi); };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: oldFn,
                        pc_exe_external: wrapTafApi,
                        pc_anchor: oldFn,
                        main_web_inner: wrapTafApi,
                        main_web_iframe: wrapTafApi,
                        outer_mobile: wrapTafApi,
                        outer_pc: wrapTafApi
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };

var _a$L;
var moduleName$L = 'HYUserInfo';
var getCurrentUserInfo = 'getCurrentUserInfo';
var getMyPresenterInfo = 'getMyPresenterInfo';
var getUserId = 'getUserId';
var getCurrentUserInfoScheme = functionScheme.optional();
var HYUserInfo = (_a$L = {},
    _a$L[getCurrentUserInfo] = getCurrentUserInfo$1(generateCommonAPI(moduleName$L, getCurrentUserInfo, getCurrentUserInfoScheme, {
        isUseSdk: true
    })),
    _a$L[getMyPresenterInfo] = generateCommonAPI(moduleName$L, getMyPresenterInfo, getCurrentUserInfoScheme, {
        isUseSdk: true
    }),
    _a$L[getUserId] = generateCommonAPI(moduleName$L, getUserId, getCurrentUserInfoScheme, {
        isUseSdk: true
    }),
    _a$L);

var isLogin$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, wrapForResult, isLoginInCookie, isLoginInPCWithSDK, isLoginInMainWebIframe, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                wrapForResult = function (fn) { return __awaiter(void 0, void 0, void 0, function () {
                    var result, isLogin_1;
                    var _a, _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                result = {
                                    isLogin: false
                                };
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, 4, 5]);
                                return [4 /*yield*/, fn()];
                            case 2:
                                isLogin_1 = _d.sent();
                                result.isLogin = isLogin_1;
                                (_a = params === null || params === void 0 ? void 0 : params.success) === null || _a === void 0 ? void 0 : _a.call(params, result);
                                return [3 /*break*/, 5];
                            case 3:
                                _d.sent();
                                (_b = params === null || params === void 0 ? void 0 : params.fail) === null || _b === void 0 ? void 0 : _b.call(params, result);
                                return [3 /*break*/, 5];
                            case 4:
                                (_c = params === null || params === void 0 ? void 0 : params.complete) === null || _c === void 0 ? void 0 : _c.call(params, result);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/, result];
                        }
                    });
                }); };
                isLoginInCookie = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/, Number(getCookie('udb_uid')) > 0];
                }); }); };
                isLoginInPCWithSDK = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var userInfo;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getUidAndToken(HYUserInfo)];
                            case 1:
                                userInfo = _a.sent();
                                return [2 /*return*/, Number(userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid) > 0];
                        }
                    });
                }); };
                isLoginInMainWebIframe = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var userInfo;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getMainRsp(null, 1000, 'UserInfoReq', 'UserInfoRes')];
                            case 1:
                                userInfo = _a.sent();
                                return [2 /*return*/, Number(userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid) > 0];
                        }
                    });
                }); };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: function () { return wrapForResult(isLoginInPCWithSDK); },
                        pc_exe_external: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var _isLogin_1;
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        if (!(typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.external) === null || _b === void 0 ? void 0 : _b.isLogin) === 'function')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, ((_d = (_c = window) === null || _c === void 0 ? void 0 : _c.external) === null || _d === void 0 ? void 0 : _d.isLogin())];
                                    case 1:
                                        _isLogin_1 = (_e.sent());
                                        return [2 /*return*/, wrapForResult(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                                return [2 /*return*/, _isLogin_1];
                                            }); }); })];
                                    case 2: return [2 /*return*/, wrapForResult(isLoginInCookie)];
                                }
                            });
                        }); },
                        pc_anchor: oldFn,
                        main_web_inner: function () { return wrapForResult(isLoginInCookie); },
                        main_web_iframe: function () { return wrapForResult(isLoginInMainWebIframe); },
                        outer_mobile: function () { return wrapForResult(isLoginInCookie); },
                        outer_pc: function () { return wrapForResult(isLoginInCookie); }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };
var showLogin$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, TTLogin, outerLogin, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                TTLogin = function () { var _a, _b; return (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TT) === null || _b === void 0 ? void 0 : _b.login.login(); };
                outerLogin = function () {
                    var conf = HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.getInnerConfig();
                    var URL_TEST = 'https://aq-test.huya.com/m/login.html';
                    var URL_PRO = 'https://aq.huya.com/m/login.html';
                    var _isTestEnv = (conf === null || conf === void 0 ? void 0 : conf.isTestEnv) === undefined ? window.location.host.indexOf('test') !== -1 : conf === null || conf === void 0 ? void 0 : conf.isTestEnv;
                    var redirectUrl = (_isTestEnv ? URL_TEST : URL_PRO) + "?redirect=" + encodeURIComponent(window.location.href);
                    return window.location.replace(redirectUrl);
                };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: oldFn,
                        /** copy from @huyafed/pc-external-js-sdk */
                        pc_exe_external: function () {
                            var _a, _b, _c, _d;
                            if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.external) === null || _b === void 0 ? void 0 : _b.showLogin) === 'function') {
                                return (_d = (_c = window) === null || _c === void 0 ? void 0 : _c.external) === null || _d === void 0 ? void 0 : _d.showLogin();
                            }
                            return oldFn();
                        },
                        pc_anchor: oldFn,
                        main_web_inner: TTLogin,
                        main_web_iframe: function () { return getMainRsp(null, 5000, 'RoomLoginReq', 'RoomLoginRes'); },
                        outer_mobile: outerLogin,
                        outer_pc: function () {
                            var _a, _b;
                            if ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TT) === null || _b === void 0 ? void 0 : _b.login.login)
                                return TTLogin();
                            return outerLogin();
                        }
                    })];
            case 1:
                action = _a.sent();
                return [2 /*return*/, action ? action() : oldFn()];
        }
    });
}); }; };

var _a$K;
var moduleName$K = 'HYLogin';
var isThirdPartyLogin = 'isThirdPartyLogin';
var isLogin = 'isLogin';
var logout = 'logout';
var showLogin = 'showLogin';
var thirdAuthorize = 'thirdAuthorize';
var getCarrierPhoneNumber = 'getCarrierPhoneNumber';
var getCarrierAuthorization = 'getCarrierAuthorization';
var on$7 = 'on';
var off$7 = 'off';
var loginFunctionScheme = functionScheme.optional();
var showLoginScheme = mod
    .object({
    type: mod.number().optional()
})
    .optional();
var loginSuccess = 'loginSuccess';
var loginFailed = 'loginFailed';
var kickOff = 'kickOff';
var HYLogin = (_a$K = {},
    _a$K[isThirdPartyLogin] = generateCommonAPI(moduleName$K, isThirdPartyLogin, loginFunctionScheme, {
        isUseSdk: true
    }),
    _a$K[isLogin] = isLogin$1(generateCommonAPI(moduleName$K, isLogin, loginFunctionScheme, {
        isUseSdk: true
    })),
    _a$K[logout] = generateCommonAPI(moduleName$K, logout, loginFunctionScheme, {
        isUseSdk: true
    }),
    _a$K[showLogin] = showLogin$1(generateCommonAPI(moduleName$K, showLogin, showLoginScheme, {
        isUseSdk: true
    })),
    _a$K[thirdAuthorize] = generateCommonAPI(moduleName$K, thirdAuthorize, showLoginScheme, {
        isUseSdk: true
    }),
    _a$K[getCarrierPhoneNumber] = generateCommonAPI(moduleName$K, getCarrierPhoneNumber, loginFunctionScheme, {
        isUseSdk: true
    }),
    _a$K[getCarrierAuthorization] = generateCommonAPI(moduleName$K, getCarrierAuthorization, loginFunctionScheme, {
        isUseSdk: true
    }),
    _a$K[on$7] = generateCommonEvent(moduleName$K, on$7),
    _a$K[off$7] = generateCommonEvent(moduleName$K, off$7),
    _a$K);

var getBridge = function () {
    if (window.top && window.self != window.top) {
        return window.top.KiwiJSBridge;
    }
    else {
        return window.KiwiJSBridge;
    }
};
var jumpScheme = mod.object({
    needUdbCookie: mod.boolean().optional(),
    url: mod.string(),
    title: mod.string().optional()
});
var HYPortraitActivity = {
    /**
     * jump 替代 PortraitActivity.jump
     * @param params.title
     * @param params.url
     * @param params.needUdbCookie
     * @returns
     */
    jump: function (params) {
        if (params) {
            var parseRes = jumpScheme.safeParse(params);
            if (!parseRes.success) {
                var e = createSDKError(parseRes.error);
                console.warn(e);
                return {
                    success: false,
                    error: e
                };
            }
        }
        var jumpUrl = params.url;
        if (params.needUdbCookie) {
            // const { Browser } = require('@hy-hybrid/hy-js-sdk')
            jumpUrl = Browser.versions.android ? encodeURIComponent(params.url) : params.url;
            jumpUrl = "https://lgn.huya.com/lgn/jump/authentication.do?ticket=&appid=5060&busiId=&busiUrl=" + encodeURIComponent(jumpUrl) + "&yyuid=&reqDomainList=huya.com&action=authenticate";
        }
        var url = "http://kiwijs.jump.huya.com/?jumpTitle=" + encodeURIComponent(params.title || '') + "&jumpUrl=" + encodeURIComponent(jumpUrl);
        location.href = url;
    },
    /**
     * show 替代 PortraitActivity.show
     * @returns
     */
    show: function () {
        // 用于统计用户有没有调用这个方法
        if (window.performanceInfo) {
            window.performanceInfo.callshow = +new Date();
        }
        if (!getBridge()) {
            //如果客户端还没注入，则走拦截的方式
            location.href = 'http://kiwijs.domready.huya.com/';
            return;
        }
        // const { Utils } = require('@hy-hybrid/hy-js-sdk')
        HYDevice.getAppInfo({
            complete: function (resp) {
                if (resp.appVersion) {
                    var limitVersion = '5.10.0'; //5.10以上版本才支持jssdk回调
                    if (Utils.versionCompare(resp.appVersion, limitVersion) >= 0) {
                        HUYASdk$1 === null || HUYASdk$1 === void 0 ? void 0 : HUYASdk$1.JSBridge.invoke('show', {}, {});
                    }
                    else {
                        location.href = 'http://kiwijs.domready.huya.com/';
                    }
                }
                else {
                    location.href = 'http://kiwijs.domready.huya.com/';
                }
            }
        });
    }
};

var OldHYNativeEventCenter = /** @class */ (function () {
    function OldHYNativeEventCenter() {
        var _this = this;
        this._nativeEventListeners = new Map();
        this._callback = function (params) {
            _this._dispatchEvent(params);
        };
    }
    OldHYNativeEventCenter.prototype.addEventListener = function (listener, eventName, callback) {
        if (!listener || !eventName || !callback) {
            return;
        }
        this._addEventEmitterListenerIfNeed();
        var listeners = this._nativeEventListeners.get(eventName);
        if (!listeners) {
            HUYASdk$1.JSBridge.invoke('addEventListener', { eventName: eventName });
            listeners = new Map();
            this._nativeEventListeners.set(eventName, listeners);
        }
        listeners.set(listener, callback);
    };
    OldHYNativeEventCenter.prototype.removeEventListener = function (listener, eventName) {
        if (!listener || !eventName) {
            return;
        }
        var listeners = this._nativeEventListeners.get(eventName);
        if (listeners) {
            listeners.delete(listener);
            if (listeners.size == 0) {
                this._nativeEventListeners.delete(eventName);
                HUYASdk$1.JSBridge.invoke('removeEventListener', { eventName: eventName });
            }
        }
        this._removeEventEmitterListenerIfNeed();
    };
    OldHYNativeEventCenter.prototype.clearEventListener = function (listener) {
        var e_1, _a;
        if (!listener) {
            return;
        }
        var emptyEvents = [];
        try {
            for (var _b = __values(this._nativeEventListeners.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var eventName = _c.value;
                var listeners = this._nativeEventListeners.get(eventName);
                if (listeners && listeners.size > 0) {
                    listeners.delete(listener);
                    if (listeners.size == 0) {
                        emptyEvents.push(eventName);
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        for (var index = 0; index < emptyEvents.length; index++) {
            var eventName = emptyEvents[index];
            this._nativeEventListeners.delete(eventName);
            HUYASdk$1.JSBridge.invoke('removeEventListener', { eventName: eventName });
        }
    };
    OldHYNativeEventCenter.prototype.clearAllListener = function () {
        var _this = this;
        this._nativeEventListeners.forEach(function (value, key) {
            _this._nativeEventListeners.delete(key);
            HUYASdk$1.JSBridge.invoke('removeEventListener', { eventName: key });
        });
    };
    OldHYNativeEventCenter.prototype.postEventToNative = function (eventName, userInfo) {
        HUYASdk$1.JSBridge.invoke('postEvent', { eventName: eventName, userInfo: userInfo });
    };
    OldHYNativeEventCenter.prototype._addEventEmitterListenerIfNeed = function () {
        if (this._nativeEventListeners.size == 0) {
            HUYASdk$1.JSBridge.on('nativeEvent', {}, this._callback);
        }
    };
    OldHYNativeEventCenter.prototype._removeEventEmitterListenerIfNeed = function () {
        if (this._nativeEventListeners.size == 0) {
            HUYASdk$1.JSBridge.off('nativeEvent', {}, this._callback);
        }
    };
    OldHYNativeEventCenter.prototype._dispatchEvent = function (reminder) {
        var e_2, _a;
        var name = reminder.name;
        var params = reminder.params;
        var listeners = this._nativeEventListeners.get(name);
        if (!listeners) {
            return;
        }
        try {
            for (var _b = __values(listeners.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var callback = listeners.get(key);
                callback && callback(params);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    return OldHYNativeEventCenter;
}());
var oldHYNativeEventCenter = new OldHYNativeEventCenter();

var _a$J;
var moduleName$J = 'HYNativeEventCenter';
var addEventListener = 'addEventListener';
var removeEventListener = 'removeEventListener';
var clearEventListener = 'clearEventListener';
var clearAllListener = 'clearAllListener';
var postEventToNative = 'postEventToNative';
var on$6 = 'on';
var off$6 = 'off';
var generateNativeCommonEvent = function (nativeApiName, listener, eventName, callback) {
    // const { NativeModules, HYNativeEventCenter: EventCenter } = require('@hy-hybrid/hy-js-sdk')
    if (nativeModules.HYNativeEventCenter && nativeModules.HYNativeEventCenter[nativeApiName]) {
        hyNativeEventCenter[nativeApiName](listener, eventName, callback);
    }
    else {
        oldHYNativeEventCenter[nativeApiName](listener, eventName, callback);
    }
};
var anyScheme = mod.any();
var HYNativeEventCenter = (_a$J = {},
    _a$J[addEventListener] = function (listener, eventName, callback) {
        var listenerParse = anyScheme.safeParse(listener);
        var e = null;
        if (!e && !listenerParse.success) {
            e = createSDKError(listenerParse.error, "HYNativeEventCenter.addEventListener");
        }
        if (e) {
            console.warn('[HYNativeEventCenter] error', e);
            return {
                success: false,
                error: e
            };
        }
        generateNativeCommonEvent(addEventListener, listener, eventName, callback);
    },
    _a$J[removeEventListener] = function (listener, eventName) {
        return generateNativeCommonEvent(removeEventListener, listener, eventName);
    },
    _a$J[clearEventListener] = function (listener) { return generateNativeCommonEvent(clearEventListener, listener); },
    _a$J[clearAllListener] = function () { return generateNativeCommonEvent(clearAllListener); },
    _a$J[postEventToNative] = function (eventName, userInfo) {
        // const { NativeModules, HYNativeEventCenter: EventCenter } = require('@hy-hybrid/hy-js-sdk')
        if (nativeModules.HYNativeEventCenter && nativeModules.HYNativeEventCenter.postEvent) {
            hyNativeEventCenter.postEventToNative(eventName, userInfo);
        }
        else {
            oldHYNativeEventCenter.postEventToNative(eventName, userInfo);
        }
    },
    _a$J[on$6] = generateCommonEvent(moduleName$J, on$6),
    _a$J[off$6] = generateCommonEvent(moduleName$J, off$6),
    _a$J);

var OldEventCenter = {
    addEventListener: function (eventId, params, listener) {
        if (typeof params == 'function') {
            listener = params;
            params = {};
        }
        if (!params) {
            params = {};
        }
        params.useContextByDefault = HUYASdk$1.useContextByDefault;
        params.useProcolByDefault = HUYASdk$1.useProcolByDefault;
        params.usePostMessageByDefault = HUYASdk$1.usePostMessageByDefault;
        //这里要包裹一下
        if (eventId == HUYASdk$1.EVENT_ID.WUP_TRANSMIT) {
            var originListener_1 = listener;
            listener = function (resp) {
                //wup透传回包数据是回包二进制流的base64字符串，需要做一次转换到ArrayBuffer
                if (resp.data) {
                    resp.data = HUYASdk$1.Utils.base64ToArrayBuffer(resp.data);
                }
                if (resp.subUri && resp.subUri == 10000) {
                    var userInfo = resp.userInfo;
                    var requestId = userInfo.__wupBridgeRequestId;
                    var reqParams = HUYASdk$1.wupRequstMap[requestId];
                    if (reqParams) {
                        HUYASdk$1.handleResponse(HUYASdk$1.EVENT_ID.WUP_TRANSMIT, resp, reqParams);
                    }
                    if (originListener_1) {
                        originListener_1(resp);
                    }
                    //使用完就不需要了
                    HUYASdk$1.wupRequstMap[requestId] = null;
                }
                else {
                    if (originListener_1) {
                        originListener_1(resp);
                    }
                }
            };
        }
        HUYASdk$1.JSBridge.on(eventId, params, listener);
    },
    removeEventListener: function (eventId) {
        var params = {};
        params.useContextByDefault = HUYASdk$1.useContextByDefault;
        params.useProcolByDefault = HUYASdk$1.useProcolByDefault;
        params.usePostMessageByDefault = HUYASdk$1.usePostMessageByDefault;
        HUYASdk$1.JSBridge.off(eventId, params);
    }
};

// eslint-disable-next-line
var Toast = function () { };
var ROOT_DOM_ID = 'hy-toast-container-id';
var rootNode;
var map = {};
var id = 0;
var hide = function (node) {
    rootNode.removeChild(node);
};
var show = function (children, waitMS) {
    if (waitMS === void 0) { waitMS = 2000; }
    if (!rootNode)
        rootNode = document.getElementById(ROOT_DOM_ID);
    if (!rootNode) {
        rootNode = document.createElement('div');
        rootNode.id = ROOT_DOM_ID;
        rootNode.classList.add('hy-toast-container');
        document.body.appendChild(rootNode);
        // 创建style元素
        var styleElement = document.createElement('style');
        document.body.appendChild(styleElement);
        styleElement.innerHTML = "\n      .hy-toast-container {\n        position: fixed;\n        z-index: 9999;\n        top: 30vh;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        margin: 0 40px;\n      }\n      .hy-toast-container .hy-toast-content {\n        background: rgba(0, 0, 0, 0.6);\n        border-radius: 4px;\n        min-width: 100px;\n        min-height: 36px;\n        color: #fff;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-top: 12px;\n        padding: 8px 12px;\n        box-sizing: border-box;\n        word-break: break-all;\n      }\n      .hy-toast-container .hy-toast-content:first-child {\n        margin-top: 0;\n      }";
    }
    var content = document.createElement('div');
    content.classList.add('hy-toast-content');
    content.textContent = children;
    rootNode.appendChild(content);
    var key = id++;
    var timer = setTimeout(function () {
        hide(content);
        delete map[key];
    }, waitMS);
    map[key] = {
        clear: function () {
            clearTimeout(timer);
            hide(content);
            delete map[key];
        }
    };
};
Toast.show = show;
Toast.hide = hide;
Toast.hideAll = function () {
    Object.keys(map).forEach(function (key) { var _a, _b; return (_b = (_a = map[key]) === null || _a === void 0 ? void 0 : _a.clear) === null || _b === void 0 ? void 0 : _b.call(_a); });
};
/**
 * @description 只展示一个Toast
 */
Toast.show1 = function (children, waitMS) {
    if (waitMS === void 0) { waitMS = 2000; }
    Toast.hideAll();
    Toast.show(children, waitMS);
};

var showToast$1 = function (_oldFn) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var oldFn, toastInWeb, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oldFn = function () { return _oldFn(params); };
                toastInWeb = function () {
                    if (!(params === null || params === void 0 ? void 0 : params.message))
                        return;
                    Toast.show1(params === null || params === void 0 ? void 0 : params.message);
                };
                return [4 /*yield*/, select({
                        app: oldFn,
                        pc_exe: toastInWeb,
                        pc_exe_external: toastInWeb,
                        pc_anchor: toastInWeb,
                        main_web_inner: toastInWeb,
                        main_web_iframe: toastInWeb,
                        outer_mobile: toastInWeb,
                        outer_pc: toastInWeb
                    })];
            case 1:
                action = _a.sent();
                action ? action() : oldFn();
                return [2 /*return*/];
        }
    });
}); }; };

var _a$I;
var moduleName$I = 'HYToast';
var showToast = 'showToast';
var showToastScheme = mod.object({
    message: mod.string()
});
var HYToast = (_a$I = {},
    _a$I[showToast] = showToast$1(generateCommonAPI(moduleName$I, showToast, showToastScheme, {
        isUseSdk: true
    })),
    _a$I);

var _a$H;
var moduleName$H = 'HYCache';
var addCache = 'addCache';
var clearCache = 'clearCache';
var getCache = 'getCache';
var hasCache = 'hasCache';
var removeCache = 'removeCache';
var addCacheScheme = functionScheme.extend({
    key: mod.string(),
    value: mod.string()
});
var paramsScheme$u = functionScheme.optional();
var getCacheScheme = functionScheme.extend({
    key: mod.string() // {string}
});
var HYCache = (_a$H = {},
    _a$H[addCache] = generateCommonAPI(moduleName$H, addCache, addCacheScheme, {
        isUseSdk: true
    }),
    _a$H[clearCache] = generateCommonAPI(moduleName$H, clearCache, paramsScheme$u, {
        isUseSdk: true
    }),
    _a$H[getCache] = generateCommonAPI(moduleName$H, getCache, getCacheScheme, {
        isUseSdk: true
    }),
    _a$H[hasCache] = generateCommonAPI(moduleName$H, hasCache, getCacheScheme, {
        isUseSdk: true
    }),
    _a$H[removeCache] = generateCommonAPI(moduleName$H, removeCache, getCacheScheme, {
        isUseSdk: true
    }),
    _a$H);

var _a$G;
var moduleName$G = 'HYDiskConfig';
var addConfig = 'addConfig';
var getConfig = 'getConfig';
var removeConfig = 'removeConfig';
var addConfigScheme = functionScheme.extend({
    key: mod.string(),
    value: mod.string()
});
var getConfigScheme = functionScheme.extend({
    key: mod.string() // {string}
});
var HYDiskConfig = (_a$G = {},
    _a$G[addConfig] = generateCommonAPI(moduleName$G, addConfig, addConfigScheme, {
        isUseSdk: true
    }),
    _a$G[getConfig] = generateCommonAPI(moduleName$G, getConfig, getConfigScheme, {
        isUseSdk: true
    }),
    _a$G[removeConfig] = generateCommonAPI(moduleName$G, removeConfig, getConfigScheme, {
        isUseSdk: true
    }),
    _a$G);

var _a$F;
var moduleName$F = 'HYTipOff';
var getTipOffPicture = 'getTipOffPicture';
var paramsScheme$t = functionScheme.optional();
var HYTipOff = (_a$F = {},
    _a$F[getTipOffPicture] = generateCommonAPI(moduleName$F, getTipOffPicture, paramsScheme$t),
    _a$F);

var _a$E;
var moduleName$E = 'HYShare';
var setShareInfo = 'setShareInfo';
var setIEGSceneData = 'setIEGSceneData';
var shareTo = 'shareTo';
var setShareInfoScheme = mod.object({
    url: mod.string().optional(),
    isShow: mod.union([mod.boolean(), mod.string()]),
    title: mod.string().optional(),
    content: mod.string().optional(),
    shareUrl: mod.string().optional(),
    imageUrl: mod.string().optional(),
    imageData: mod.string().optional(),
    mediaType: mod.union([mod.string(), mod.number()]).optional(),
    miniprogramUrl: mod.string().optional() //小程序的url
});
var shareToScheme = mod.object({
    //分享平台， 'weixin', 'circle', 'qq', 'qzone', 'sinaweibo', 'copy'
    platform: mod.string(),
    title: mod.string().optional(),
    content: mod.string().optional(),
    shareUrl: mod.string().optional(),
    imageUrl: mod.string().optional(),
    imageData: mod.string().optional(),
    mediaType: mod.union([mod.string(), mod.number()]).optional(),
    miniprogramUrl: mod.string().optional(),
    isShareImage: mod.boolean().optional(),
    needRequestShareUrl: mod.boolean().optional() //是否需要请求url，app直播间分享使用
});
var setIEGSceneDataScheme = mod.object({
    gameID: mod.string(),
    subSceneName: mod.string(),
    sceneName: mod.string(),
    sceneId: mod.string(),
    gameAppid: mod.string()
});
var HYShare = (_a$E = {},
    _a$E[setShareInfo] = function (params) {
        var isShow = params.isShow, rest = __rest(params, ["isShow"]);
        var fixShow = isShow;
        //ios全部转成'1','0'
        if (Browser.versions.ios) {
            fixShow = (+isShow).toString();
        }
        else {
            //and全部转成 true, false
            fixShow = Boolean(+isShow);
        }
        return generateCommonAPI(moduleName$E, setShareInfo, setShareInfoScheme, {
            isUseSdk: true
        })(__assign(__assign({}, rest), { isShow: fixShow }));
    },
    _a$E[setIEGSceneData] = generateCommonAPI(moduleName$E, setIEGSceneData, setIEGSceneDataScheme),
    _a$E[shareTo] = generateCommonAPI(moduleName$E, shareTo, shareToScheme, {
        isUseSdk: true
    }),
    _a$E);

var _a$D;
var moduleName$D = 'HYSubscribe';
var subscribePresenter = 'subscribePresenter';
var unSubscribePresenter = 'unSubscribePresenter';
var paramsScheme$s = functionScheme.extend({
    uid: mod.string()
});
var HYSubscribe = (_a$D = {},
    _a$D[subscribePresenter] = generateCommonAPI(moduleName$D, subscribePresenter, paramsScheme$s, {
        isUseSdk: true
    }),
    _a$D[unSubscribePresenter] = generateCommonAPI(moduleName$D, unSubscribePresenter, paramsScheme$s, {
        isUseSdk: true
    }),
    _a$D);

var _a$C;
var moduleName$C = 'HYFeedBack';
var sendFeedBack = 'sendFeedBack';
var paramsScheme$r = functionScheme.extend({
    content: mod.string(),
    typeId: mod.string().optional(),
    typeName: mod.string(),
    picUrls: mod.string().optional(),
    contact: mod.string().optional(),
    needProgress: mod.string().optional()
});
var HYFeedBack = (_a$C = {},
    _a$C[sendFeedBack] = generateCommonAPI(moduleName$C, sendFeedBack, paramsScheme$r, {
        isUseSdk: true
    }),
    _a$C);

var _a$B;
var moduleName$B = 'HYDownload';
var getAppDownloadInfo = 'getAppDownloadInfo';
var startDownload = 'startDownload';
var startBatchDownload = 'startBatchDownload';
var pauseDownload = 'pauseDownload';
var pauseAllDownload = 'pauseAllDownload';
var startApp = 'startApp';
var cancelDownLoad = 'cancelDownLoad';
var cancelAllDownload = 'cancelAllDownload';
var intallApk = 'intallApk';
var shareAssistFinish = 'shareAssistFinish';
var getGameResDownloadInfo = 'getGameResDownloadInfo';
var gameResStartDownload = 'gameResStartDownload';
var gameResPauseDownload = 'gameResPauseDownload';
var getGameMonitorInfo = 'getGameMonitorInfo';
var reportAppInstallState = 'reportAppInstallState';
var isYybCloudGame = 'isYybCloudGame';
var launchYybCloudGame = 'launchYybCloudGame';
var getInstalledGameInfo = 'getInstalledGameInfo';
var on$5 = 'on';
var off$5 = 'off';
var paramsScheme$q = functionScheme.optional();
var getAppDownloadInfoScheme = functionScheme.extend({
    packageName: mod.string(),
    gameId: mod.union([mod.number(), mod.string()]),
    adrPackageName: mod.string().optional(),
    url: mod.string(),
    fileMd5: mod.string().optional(),
    name: mod.string().optional(),
    versionCode: mod.union([mod.number(), mod.string()]).optional()
});
var startDownloadScheme = functionScheme.extend({
    packageName: mod.string().optional(),
    gameId: mod.union([mod.number(), mod.string()]),
    adrPackageName: mod.string().optional(),
    fromId: mod.string(),
    fileMd5: mod.string().optional(),
    url: mod.string(),
    extra: mod.any().optional(),
    name: mod.string().optional(),
    actid: mod.string(),
    anchoruid: mod.string().optional(),
    type: mod.string(),
    gameIcon: mod.string(),
    versionCode: mod.union([mod.number(), mod.string()]).optional(),
    joint: mod.union([mod.number(), mod.string()]).optional(),
    shareAssistUrl: mod.string().optional(),
    assist_desc: mod.string().optional(),
    action_btn_desc: mod.string().optional(),
    chid: mod.union([mod.number(), mod.string()]).optional(),
    superuseruid: mod.union([mod.number(), mod.string()]).optional(),
    download_user_type: mod.union([mod.number(), mod.string()]).optional(),
    tagtype: mod.union([mod.number(), mod.string()]).optional(),
    traceid: mod.string().optional(),
    ext_fromid: mod.string().optional(),
    cur_fromid: mod.string().optional(),
    launchcloud: mod.number().optional(),
    autoDownload: mod.number().optional(),
    vid: mod.string().optional(),
    post: mod.string().optional() //社区动态id
});
// 新增的方法
var startBatchDownloadScheme = mod.object({
    downloadGameList: mod.string()
});
var pauseDownloadScheme = functionScheme.extend({
    url: mod.string(),
    actid: mod.string(),
    anchoruid: mod.string(),
    gameId: mod.union([mod.number(), mod.string()]),
    adrPackageName: mod.string().optional(),
    packageName: mod.string()
});
var startAppScheme = functionScheme.extend({
    packageName: mod.string()
});
var intallApkScheme = functionScheme.extend({
    adrPackageName: mod.string().optional(),
    packageName: mod.string(),
    name: mod.string(),
    gameId: mod.union([mod.number(), mod.string()]),
    joint: mod.union([mod.number(), mod.string()]).optional(),
    url: mod.string(),
    fromId: mod.string().optional(),
    versionCode: mod.number().optional()
});
var cancelDownLoadScheme = functionScheme.extend({
    url: mod.string(),
    gameId: mod.union([mod.number(), mod.string()]),
    adrPackageName: mod.string().optional(),
    packageName: mod.string()
});
var shareAssistFinishScheme = functionScheme.extend({
    shareAssistUrl: mod.string()
});
var getGameResDownloadInfoScheme = mod.object({
    packageName: mod.string(),
    gameId: mod.union([mod.number(), mod.string()]),
    url: mod.string(),
    fileMd5: mod.string(),
    name: mod.string(),
    gameIcon: mod.string(),
    versionCode: mod.union([mod.number(), mod.string()])
});
var gameResStartDownloadScheme = getGameResDownloadInfoScheme.extend({
    type: mod.string()
});
var gameResPauseDownloadScheme = mod.object({
    gameId: mod.union([mod.number(), mod.string()]),
    url: mod.string()
});
var isYybCloudGameScheme = mod.object({
    gameId: mod.number()
});
var launchYybCloudGameScheme = startDownloadScheme.extend({
    reservetype: mod.number().optional(),
    scene: mod.string().optional()
    // lauchcloud: z.number().optional()
});
var reportAppInstallStateScheme = mod.object({
    packageName: mod.string(),
    gameName: mod.string(),
    gameId: mod.string()
});
var getInstalledGameInfoScheme = mod.object({
    gameid: mod.string()
});
var installApkEventChanged = 'INSTALL_APK_EVENT_CHANGED';
var HYDownload = (_a$B = {},
    _a$B[getAppDownloadInfo] = generateCommonAPI(moduleName$B, getAppDownloadInfo, getAppDownloadInfoScheme, { isUseSdk: true }),
    _a$B[startDownload] = generateCommonAPI(moduleName$B, startDownload, startDownloadScheme, {
        isUseSdk: true
    }),
    _a$B[startBatchDownload] = generateCommonAPI(moduleName$B, startBatchDownload, startBatchDownloadScheme),
    _a$B[pauseDownload] = generateCommonAPI(moduleName$B, pauseDownload, pauseDownloadScheme, {
        isUseSdk: true
    }),
    _a$B[pauseAllDownload] = generateCommonAPI(moduleName$B, pauseAllDownload, paramsScheme$q, {
        isUseSdk: true
    }),
    _a$B[startApp] = generateCommonAPI(moduleName$B, startApp, startAppScheme, {
        isUseSdk: true
    }),
    _a$B[cancelDownLoad] = generateCommonAPI(moduleName$B, cancelDownLoad, cancelDownLoadScheme, {
        isUseSdk: true
    }),
    _a$B[cancelAllDownload] = generateCommonAPI(moduleName$B, cancelAllDownload, paramsScheme$q, { isUseSdk: true }),
    _a$B[intallApk] = generateCommonAPI(moduleName$B, intallApk, intallApkScheme, {
        isUseSdk: true
    }),
    _a$B[shareAssistFinish] = generateCommonAPI(moduleName$B, shareAssistFinish, shareAssistFinishScheme, { isUseSdk: true }),
    _a$B[getGameResDownloadInfo] = generateCommonAPI(moduleName$B, getGameResDownloadInfo, getGameResDownloadInfoScheme),
    _a$B[gameResStartDownload] = generateCommonAPI(moduleName$B, gameResStartDownload, gameResStartDownloadScheme),
    _a$B[gameResPauseDownload] = generateCommonAPI(moduleName$B, gameResPauseDownload, gameResPauseDownloadScheme),
    _a$B[isYybCloudGame] = generateCommonAPI(moduleName$B, isYybCloudGame, isYybCloudGameScheme),
    _a$B[launchYybCloudGame] = generateCommonAPI(moduleName$B, launchYybCloudGame, launchYybCloudGameScheme),
    _a$B[getGameMonitorInfo] = generateCommonAPI(moduleName$B, getGameMonitorInfo),
    _a$B[reportAppInstallState] = generateCommonAPI(moduleName$B, reportAppInstallState, reportAppInstallStateScheme),
    _a$B[getInstalledGameInfo] = generateCommonAPI(moduleName$B, getInstalledGameInfo, getInstalledGameInfoScheme),
    _a$B[on$5] = generateCommonEvent(moduleName$B, on$5),
    _a$B[off$5] = generateCommonEvent(moduleName$B, off$5),
    _a$B);

var InfoTypeConst = {
    token: 1,
    config: 2,
    authorInfo: 3
};
// , callback: (resp: any) => void
var HYBase = {
    getInfo: function (type) {
        return new Promise(function (resolve) {
            return apiHuyaSdkHandle('HUYASdk', 'getInfo', {
                type: type,
                complete: resolve
            });
        });
    },
    processUrl: function (url) {
        return apiHuyaSdkHandle('HUYASdk', 'processUrl', {
            url: url
        });
    }
};
var HYLandscapeActivity = {
    appInfo: {
        token: '',
        authorInfo: ''
    },
    ready: function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            var appInfo, resp, authorResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appInfo = this.appInfo;
                        if (!!appInfo.token) return [3 /*break*/, 2];
                        return [4 /*yield*/, HYBase.getInfo(InfoTypeConst.token)];
                    case 1:
                        resp = _a.sent();
                        if (resp.code === 0) {
                            appInfo.token = resp.data;
                            this.appInfo.token = resp.data;
                        }
                        _a.label = 2;
                    case 2:
                        if (!!appInfo.authorInfo) return [3 /*break*/, 4];
                        return [4 /*yield*/, HYBase.getInfo(InfoTypeConst.authorInfo)];
                    case 3:
                        authorResp = _a.sent();
                        if (authorResp.code === 0) {
                            appInfo.authorInfo = authorResp.data;
                            this.appInfo.authorInfo = authorResp.data;
                        }
                        _a.label = 4;
                    case 4:
                        callback && callback(appInfo);
                        return [2 /*return*/];
                }
            });
        });
    },
    showLogin: function () {
        HYLogin.showLogin();
    },
    /**
     * 跳转到webview
     * @memberof LandscapeActivity
     * @param {string} url  - 跳转url
     */
    jumpToWebView: function (url) {
        HYBase.processUrl(url);
    },
    share: function (obj) {
        var shareInfo = {
            title: '',
            url: location.href,
            content: '',
            callbackName: '',
            type: 'sinaweibo'
        };
        Utils.shallowExtend(shareInfo, obj);
        window.location.href = "http://kiwijs.share.huya.com/?shareUrl=" + encodeURIComponent(shareInfo.url) + "&shareTitle=" + shareInfo.title + "&shareContent=" + shareInfo.content + "&shareCallback=" + shareInfo.callbackName + "&shareType=" + shareInfo.type;
    }
};
var LandscapeActivity = function () {
    // const appInfo = {
    //   token: '',
    //   authorInfo: ''
    // }
    // const resp = await HYBase.getInfo(InfoTypeConst.token)
    // if (resp.code === 0) {
    //   appInfo.token = resp.data
    // }
    // const authorResp = await HYBase.getInfo(InfoTypeConst.authorInfo)
    // if (authorResp.code === 0) {
    //   appInfo.authorInfo = authorResp.data
    // }
    // return {
    //   ready: (callback?: (info: any) => void) => {
    //     const timmer = setInterval(function () {
    //       if (appInfo.authorInfo) {
    //         if (typeof callback == 'function') {
    //           callback(appInfo)
    //         }
    //         clearInterval(timmer)
    //       }
    //     }, 50)
    //   },
    //   showLogin: () => {
    //     HYLandscapeActivity.showLogin()
    //   },
    //   /**
    //    * 跳转到webview
    //    * @memberof LandscapeActivity
    //    * @param {string} url  - 跳转url
    //    */
    //   jumpToWebView: (url: string) => {
    //     HYLandscapeActivity.jumpToWebView(url)
    //   },
    //   share: (obj: any) => {
    //     HYLandscapeActivity.share(obj)
    //   }
    // }
    return HYLandscapeActivity;
};

var _a$A;
var moduleName$A = 'HYReport';
var eventReport = 'eventReport';
var statisticReport = 'statisticReport';
var eventReportScheme = functionScheme.extend({
    event: mod.any().optional()
});
var statisticReportScheme = functionScheme.extend({
    event: mod.any().optional(),
    type: mod.string() //按照前端原来的组包格式
});
var HYReport = (_a$A = {},
    _a$A[eventReport] = generateCommonAPI(moduleName$A, eventReport, eventReportScheme, {
        isUseSdk: true
    }),
    _a$A[statisticReport] = generateCommonAPI(moduleName$A, statisticReport, statisticReportScheme, {
        isUseSdk: true
    }),
    _a$A);

var _a$z;
// 只在ios可用
var moduleName$z = 'HYAAID';
var turnoffAAID = 'turnoffAAID';
var queryAAIDStatus = 'queryAAIDStatus';
var paramsScheme$p = functionScheme.optional();
var turnoffScheme = functionScheme
    .extend({
    turnoff: mod.boolean()
})
    .optional();
var HYAAID = (_a$z = {},
    _a$z[turnoffAAID] = generateCommonAPI(moduleName$z, turnoffAAID, turnoffScheme),
    _a$z[queryAAIDStatus] = generateCommonAPI(moduleName$z, queryAAIDStatus, paramsScheme$p),
    _a$z);

var _a$y;
var moduleName$y = 'HYAd';
var getAdDeviceInfo = 'getAdDeviceInfo';
var updateSplashCanShake = 'updateSplashCanShake';
var paramsScheme$o = functionScheme.optional();
var shakeScheme = mod.object({
    canShake: mod.boolean()
});
var HYAd = (_a$y = {},
    _a$y[getAdDeviceInfo] = generateCommonAPI(moduleName$y, getAdDeviceInfo, paramsScheme$o),
    _a$y[updateSplashCanShake] = generateCommonAPI(moduleName$y, updateSplashCanShake, shakeScheme),
    _a$y);

var _a$x;
var moduleName$x = 'HYAdReport';
var landingClick = 'landingClick';
var landingExposure = 'landingExposure';
var taskCenterExposureAd = 'taskCenterExposureAd';
var taskCenterClickAd = 'taskCenterClickAd';
// ieg 相关上报
var ztReportShow = 'ztReportShow';
var ztReportClick = 'ztReportClick';
var ztReportAction = 'ztReportAction';
var ztPresentAppStore = 'ztPresentAppStore';
var ztAfterPage = 'ztAfterPage';
var ztSetIegPageType = 'ztSetIegPageType';
var landingClickScheme = mod.object({
    HYAdWebReportSdkConf: mod.string(),
    HYAdWebReportEnv: mod.any()
});
var landingExposureScheme = mod.object({
    HYAdWebReportSdkConf: mod.string()
});
var taskCenterScheme = mod.object({
    sdkConf: mod.string()
});
var tPageInfoSchema = mod.union([
    mod.object({
        url: mod.string()
    }),
    mod.record(mod.union([mod.string(), mod.number()])).and(mod.object({
        pageName: mod.string(),
        pageType: mod.number()
    }))
]);
var iZTReportInfoSchema = mod.object({
    sceneId: mod.number().optional(),
    scene: mod.number().optional(),
    subScene: mod.number().optional(),
    gameAppid: mod.string().optional(),
    afterPage: mod.string().optional(),
    appStoreLink: mod.string().optional(),
    actionType: mod.number().optional(),
    sceneName: mod.string().optional(),
    subSceneName: mod.string().optional(),
    gameID: mod.number().optional()
});
var pageTypeSchema = mod.object({
    type: mod.number()
});
var HYAdReport = (_a$x = {},
    /**
     * 广告-落地页点击上报
     */
    _a$x[landingClick] = generateCommonAPI(moduleName$x, landingClick, landingClickScheme),
    /**
     * 广告-落地页曝光上报
     */
    _a$x[landingExposure] = generateCommonAPI(moduleName$x, landingExposure, landingExposureScheme),
    /**
     * 任务中心曝光上报
     */
    _a$x[taskCenterExposureAd] = generateCommonAPI(moduleName$x, taskCenterExposureAd, taskCenterScheme),
    /**
     * 任务中心点击上报
     */
    _a$x[taskCenterClickAd] = generateCommonAPI(moduleName$x, taskCenterClickAd, taskCenterScheme),
    /**
     * IEG 曝光上报
     */
    _a$x[ztReportShow] = generateCommonAPI(moduleName$x, ztReportShow, iZTReportInfoSchema),
    /**
     *  IEG 点击并跳转上报
     */
    _a$x[ztReportClick] = generateCommonAPI(moduleName$x, ztReportClick, iZTReportInfoSchema),
    /**
     * IEG 点击不跳转上报
     */
    _a$x[ztReportAction] = generateCommonAPI(moduleName$x, ztReportAction, iZTReportInfoSchema),
    /**
     *IEG 点击打开AppStore上报
     */
    _a$x[ztPresentAppStore] = generateCommonAPI(moduleName$x, ztPresentAppStore, iZTReportInfoSchema),
    /**
     *  IEG 构建pageInfo
     */
    _a$x[ztAfterPage] = generateCommonAPI(moduleName$x, ztAfterPage, tPageInfoSchema),
    /**
     *  IEG 设置页面类型
     */
    _a$x[ztSetIegPageType] = generateCommonAPI(moduleName$x, ztSetIegPageType, pageTypeSchema),
    _a$x);

var _a$w;
var moduleName$w = 'HYAudioRecord';
var startAudioRecord = 'startAudioRecord';
var stopAudioRecord = 'stopAudioRecord';
var cancelAudioRecord = 'cancelAudioRecord';
var on$4 = 'on';
var off$4 = 'off';
var paramsScheme$n = functionScheme.optional();
var audioRecordEnd = 'AUDIO_RECORD_END';
var HYAudioRecord = (_a$w = {},
    /**
     * 开始音频录制
     */
    _a$w[startAudioRecord] = generateCommonAPI(moduleName$w, startAudioRecord, paramsScheme$n, {
        isUseSdk: true
    }),
    /**
     * 停止音频录制
     */
    _a$w[stopAudioRecord] = generateCommonAPI(moduleName$w, stopAudioRecord, paramsScheme$n, {
        isUseSdk: true
    }),
    /**
     * 取消音频录制
     */
    _a$w[cancelAudioRecord] = generateCommonAPI(moduleName$w, cancelAudioRecord, paramsScheme$n, {
        isUseSdk: true
    }),
    _a$w[on$4] = generateCommonEvent(moduleName$w, on$4),
    _a$w[off$4] = generateCommonEvent(moduleName$w, off$4),
    _a$w);

var _a$v;
var moduleName$v = 'HYAuth';
var startWBFaceVerify = 'startWBFaceVerify';
var startWBFaceVerifyV2 = 'startWBFaceVerifyV2';
var startWBFaceVerifyFaceId = 'startWBFaceVerifyFaceId';
var getCommonParam = 'getCommonParam';
var getLoginedToken = 'getLoginedToken';
var hasAliPay = 'hasAliPay';
var startAliPayFaceVerifyFaceId = 'startAliPayFaceVerifyFaceId';
var uploadPic = 'uploadPic';
var jumpPage = 'jumpPage';
var getBindMobileParam = 'getBindMobileParam';
var startWBFaceVerifyScheme = functionScheme.extend({
    sign: mod.string(),
    sSign: mod.string(),
    mode: mod.union([mod.string(), mod.number()]).optional(),
    nonce: mod.string(),
    orderNo: mod.string(),
    version: mod.string(),
    wbAppId: mod.string(),
    name: mod.string(),
    idNum: mod.string()
});
var startWBFaceVerifyV2Scheme = startWBFaceVerifyScheme.extend({
    userId: mod.string()
});
var paramsScheme$m = functionScheme.extend({
    sSign: mod.string(),
    sign: mod.string(),
    faceId: mod.string(),
    nonce: mod.string(),
    mode: mod.union([mod.string(), mod.number()]).optional(),
    orderNo: mod.string(),
    userId: mod.union([mod.string(), mod.number()]).optional(),
    version: mod.string(),
    wbAppId: mod.string()
});
var startAliPayFaceVerifyFaceIdScheme = mod.object({
    certifyUrl: mod.string()
});
var jumpPageScheme = mod.object({
    index: mod.number()
});
var HYAuth = (_a$v = {},
    /**
     * 身份认证 , 仅限登录用户使用
     */
    _a$v[startWBFaceVerify] = generateCommonAPI(moduleName$v, startWBFaceVerify, startWBFaceVerifyScheme, { isUseSdk: true }),
    /**
     * 身份认证 , 登录、非登录用户都可以使用，这个比上面的多了一个参数userId
     */
    _a$v[startWBFaceVerifyV2] = generateCommonAPI(moduleName$v, startWBFaceVerifyV2, startWBFaceVerifyV2Scheme, { isUseSdk: true }),
    _a$v[startWBFaceVerifyFaceId] = generateCommonAPI(moduleName$v, startWBFaceVerifyFaceId, paramsScheme$m, { isUseSdk: true }),
    _a$v[getCommonParam] = generateCommonAPI(moduleName$v, getCommonParam),
    _a$v[getLoginedToken] = generateCommonAPI(moduleName$v, getLoginedToken),
    _a$v[hasAliPay] = generateCommonAPI(moduleName$v, hasAliPay),
    _a$v[uploadPic] = generateCommonAPI(moduleName$v, uploadPic),
    _a$v[getBindMobileParam] = generateCommonAPI(moduleName$v, getBindMobileParam),
    _a$v[jumpPage] = generateCommonAPI(moduleName$v, jumpPage, jumpPageScheme),
    _a$v[startAliPayFaceVerifyFaceId] = generateCommonAPI(moduleName$v, startAliPayFaceVerifyFaceId, startAliPayFaceVerifyFaceIdScheme, { isUseSdk: true }),
    _a$v);

var _a$u;
var moduleName$u = 'HYAuthorization';
var requestAuthorization = 'requestAuthorization';
var isAuthorization = 'isAuthorization';
var authorization = 'authorization';
var requestAuthorizationScheme = mod.object({
    authKey: mod.string() // 权限key
});
var HYAuthorization = (_a$u = {},
    /**
     * 请求APP某个权限
     */
    _a$u[requestAuthorization] = generateCommonAPI(moduleName$u, requestAuthorization, requestAuthorizationScheme),
    /**
     * 是否需要授权
     */
    _a$u[isAuthorization] = generateCommonAPI(moduleName$u, isAuthorization, requestAuthorizationScheme),
    /**
     * 直接设置场景权限打开
     */
    _a$u[authorization] = generateCommonAPI(moduleName$u, authorization, requestAuthorizationScheme),
    _a$u);

var _a$t;
var moduleName$t = 'HYCommodity';
var sendCommodityInfo = 'sendCommodityInfo';
var dismissView = 'dismissView';
var paramsScheme$l = functionScheme.optional();
var sendCommodityInfoScheme = mod.object({
    param: mod
        .array(mod.object({
        spuId: mod.string(),
        imageUrl: mod.string(),
        name: mod.string(),
        platform: mod.string().optional(),
        minPrice: mod.number().optional(),
        maxPrice: mod.number().optional(),
        marketPrice: mod.number().optional()
    }))
        .optional()
});
var HYCommodity = (_a$t = {},
    _a$t[sendCommodityInfo] = generateCommonAPI(moduleName$t, sendCommodityInfo, sendCommodityInfoScheme),
    _a$t[dismissView] = generateCommonAPI(moduleName$t, dismissView, paramsScheme$l),
    _a$t);

var _a$s;
var moduleName$s = 'HYDynamicConfig';
var hasClientConfigForServer = 'hasClientConfigForServer';
var getDynamicConfig = 'getDynamicConfig';
var paramsScheme$k = functionScheme.optional();
var getDynamicConfigScheme = mod.object({
    key: mod.string()
});
var HYDynamicConfig = (_a$s = {},
    _a$s[hasClientConfigForServer] = generateCommonAPI(moduleName$s, hasClientConfigForServer, paramsScheme$k),
    _a$s[getDynamicConfig] = generateCommonAPI(moduleName$s, getDynamicConfig, getDynamicConfigScheme),
    _a$s);

var _a$r;
var moduleName$r = 'HYFreeFlow';
var operationCompleted = 'operationCompleted';
var getImsi = 'getImsi';
var paramsScheme$j = functionScheme
    .extend({
    resp: mod
        .object({
        code: mod.number(),
        product: mod.string(),
        phone: mod.string().optional(),
        ip: mod.string(),
        txwangka: mod.string(),
        albaoka: mod.string()
    })
        .optional()
})
    .optional();
var HYFreeFlow = (_a$r = {},
    _a$r[operationCompleted] = generateCommonAPI(moduleName$r, operationCompleted, paramsScheme$j, {
        isUseSdk: true
    }),
    _a$r[getImsi] = generateCommonAPI(moduleName$r, getImsi),
    _a$r);

var _a$q;
var moduleName$q = 'HYInteraction';
var getInteractiveComData = 'getInteractiveComData';
var currentInteractionInfo = 'currentInteractionInfo';
var on$3 = 'on';
var off$3 = 'off';
var paramsScheme$i = functionScheme.optional();
var HYInteraction = (_a$q = {},
    _a$q[getInteractiveComData] = generateCommonAPI(moduleName$q, getInteractiveComData, paramsScheme$i, { isUseSdk: true }),
    _a$q[currentInteractionInfo] = generateCommonAPI(moduleName$q, currentInteractionInfo, paramsScheme$i),
    _a$q[on$3] = generateCommonEvent(moduleName$q, on$3),
    _a$q[off$3] = generateCommonEvent(moduleName$q, off$3),
    _a$q);

var _a$p;
var moduleName$p = 'HYLiveFilmVip';
var getFilmVipProductList = 'getFilmVipProductList';
var buyFilmVipProduct = 'buyFilmVipProduct';
var paramsScheme$h = functionScheme.optional();
var HYLiveFilmVip = (_a$p = {},
    _a$p[getFilmVipProductList] = generateCommonAPI(moduleName$p, getFilmVipProductList, paramsScheme$h, { isUseSdk: true }),
    _a$p[buyFilmVipProduct] = generateCommonAPI(moduleName$p, buyFilmVipProduct, paramsScheme$h, { isUseSdk: true }),
    _a$p);

var _a$o;
var moduleName$o = 'HYLiveTreasureBox';
var handleAwardBoxPrize = 'handleAwardBoxPrize';
var paramsScheme$g = mod.object({
    taskId: mod.number()
});
var HYLiveTreasureBox = (_a$o = {},
    _a$o[handleAwardBoxPrize] = generateCommonAPI(moduleName$o, handleAwardBoxPrize, paramsScheme$g),
    _a$o);

var _a$n;
var moduleName$n = 'HYNestedScroll';
var updateScrollTop = 'updateScrollTop';
var paramsScheme$f = functionScheme
    .extend({
    url: mod.string(),
    scroll_top: mod.boolean()
})
    .optional();
var HYNestedScroll = (_a$n = {},
    /**
     *
     * @param {string} url 页面链接（编码一下）
     * @param {boolean} scroll_top 是否滑动到顶部
     */
    _a$n[updateScrollTop] = generateCommonAPI(moduleName$n, updateScrollTop, paramsScheme$f),
    _a$n);

var _a$m;
var moduleName$m = 'HYPanel';
var setPopupLayout = 'setPopupLayout';
var dismissPopup = 'dismissPopup';
var setPopupLayoutScheme = functionScheme
    .extend({
    x: mod.number(),
    y: mod.number(),
    width: mod.number(),
    height: mod.number(),
    alpha: mod.number().optional(),
    visible: mod.boolean().optional()
})
    .optional();
var paramsScheme$e = functionScheme.optional();
var HYPanel = (_a$m = {},
    _a$m[setPopupLayout] = generateCommonAPI(moduleName$m, setPopupLayout, setPopupLayoutScheme),
    _a$m[dismissPopup] = generateCommonAPI(moduleName$m, dismissPopup, paramsScheme$e),
    _a$m);

var _a$l;
// 仅支持ios
var moduleName$l = 'HYPay';
var getIAPProductListWithName = 'getIAPProductListWithName';
var buyIAPProductWithParams = 'buyIAPProductWithParams';
var getIAPProductListWithNameScheme = functionScheme.extend({
    productlistname: mod.string()
});
var buyIAPProductWithParamsScheme = functionScheme.extend({
    buyWay: mod.string(),
    appId: mod.string(),
    name: mod.string(),
    price: mod.string(),
    product_id: mod.string(),
    payAddInfo: mod.string().optional()
});
var HYPay = (_a$l = {},
    _a$l[getIAPProductListWithName] = generateCommonAPI(moduleName$l, getIAPProductListWithName, getIAPProductListWithNameScheme, { isUseSdk: true }),
    _a$l[buyIAPProductWithParams] = generateCommonAPI(moduleName$l, buyIAPProductWithParams, buyIAPProductWithParamsScheme, { isUseSdk: true }),
    _a$l);

var _a$k;
var moduleName$k = 'HYPlayer';
var micOpen = 'micOpen';
var micClose = 'micClose';
var paramsScheme$d = functionScheme.optional();
var HYPlayer = (_a$k = {},
    _a$k[micOpen] = generateCommonAPI(moduleName$k, micOpen, paramsScheme$d, { isUseSdk: true }),
    _a$k[micClose] = generateCommonAPI(moduleName$k, micClose, paramsScheme$d, {
        isUseSdk: true
    }),
    _a$k);

var _a$j;
var moduleName$j = 'HYSaveInAlbum';
var saveImageToPhotosAlbum = 'saveImageToPhotosAlbum';
var saveVideoToPhotosAlbum = 'saveVideoToPhotosAlbum';
var saveImageToPhotosAlbumScheme = mod
    .object({
    imgData: mod.string()
})
    .optional();
var paramsScheme$c = mod
    .object({
    url: mod.string()
})
    .optional();
var HYSaveInAlbum = (_a$j = {},
    _a$j[saveImageToPhotosAlbum] = generateCommonAPI(moduleName$j, saveImageToPhotosAlbum, saveImageToPhotosAlbumScheme, { isUseSdk: true }),
    _a$j[saveVideoToPhotosAlbum] = generateCommonAPI(moduleName$j, saveVideoToPhotosAlbum, paramsScheme$c, { isUseSdk: true }),
    _a$j);

var _a$i;
var moduleName$i = 'HYSettingBack';
var setCanBack = 'setCanBack';
var on$2 = 'on';
var off$2 = 'off';
var paramsScheme$b = mod.object({
    flag: mod.boolean()
});
var TAP_BACK = 'TAP_BACK';
var HYSettingBack = (_a$i = {},
    _a$i[setCanBack] = generateCommonAPI(moduleName$i, setCanBack, paramsScheme$b, {
        isUseSdk: true
    }),
    _a$i[on$2] = generateCommonEvent(moduleName$i, on$2),
    _a$i[off$2] = generateCommonEvent(moduleName$i, off$2),
    _a$i);

var _a$h;
var moduleName$h = 'HYSettingsData';
var getStringValueForKey = 'getStringValueForKey';
var setStringValue = 'setStringValue';
var paramsScheme$a = mod.object({
    key: mod.string()
});
var setStringValueScheme = mod.object({
    key: mod.string(),
    value: mod.string()
});
var HYSettingsData = (_a$h = {},
    _a$h[getStringValueForKey] = generateCommonAPI(moduleName$h, getStringValueForKey, paramsScheme$a),
    _a$h[setStringValue] = generateCommonAPI(moduleName$h, setStringValue, setStringValueScheme),
    _a$h);

var _a$g;
var moduleName$g = 'HYStatistic';
var report = 'report';
var setRefInfo = 'setRefInfo';
var paramsScheme$9 = mod.object({
    event: mod.string(),
    prop: mod.any(),
    location: mod.string().optional()
});
var refInfoSchema = mod.object({
    name: mod.string(),
    viewType: mod.union([mod.literal(0), mod.literal(1), mod.literal(2)])
});
var HYStatistic = (_a$g = {},
    _a$g[report] = generateCommonAPI(moduleName$g, report, paramsScheme$9),
    _a$g[setRefInfo] = generateCommonAPI(moduleName$g, setRefInfo, refInfoSchema),
    _a$g);

var _a$f;
var moduleName$f = 'HYSuperFans';
var openSuperFansPage = 'openSuperFansPage';
var hideInteractionPanel = 'hideInteractionPanel';
var paramsScheme$8 = functionScheme.optional();
var HYSuperFans = (_a$f = {},
    _a$f[openSuperFansPage] = generateCommonAPI(moduleName$f, openSuperFansPage, paramsScheme$8),
    _a$f[hideInteractionPanel] = generateCommonAPI(moduleName$f, hideInteractionPanel, paramsScheme$8),
    _a$f);

var _a$e;
var moduleName$e = 'HYTeamMedal';
var notifyUserTeamMedalInfo = 'notifyUserTeamMedalInfo';
var paramsScheme$7 = mod
    .object({
    opt: mod.union([mod.literal(1), mod.literal(2), mod.literal(3)]).optional(),
    object: mod.any()
})
    .optional();
var HYTeamMedal = (_a$e = {},
    _a$e[notifyUserTeamMedalInfo] = generateCommonAPI(moduleName$e, notifyUserTeamMedalInfo, paramsScheme$7),
    _a$e);

var _a$d;
var moduleName$d = 'HYThirdCall';
var joinGangup = 'joinGangup';
var paramsScheme$6 = functionScheme.extend({
    openId: mod.string().optional(),
    token: mod.string().optional(),
    roomId: mod.string().optional(),
    accType: mod.string().optional(),
    platform: mod.string().optional()
});
var joinGangupFunc = generateCommonAPI(moduleName$d, joinGangup, paramsScheme$6);
var HYThirdCall = (_a$d = {},
    // 调起王者荣耀，进入开黑
    _a$d[joinGangup] = function (params) {
        var formatParams = __assign({}, params);
        if (params) {
            // 格式化为字符串
            Object.keys(formatParams).forEach(function (key) {
                if (['openId', 'token', 'roomId', 'accType'].indexOf(key) >= 0 && formatParams[key]) {
                    formatParams[key] = formatParams[key].toString();
                }
            });
            // 虎牙
            formatParams['platform'] = '5';
        }
        return joinGangupFunc(formatParams);
    },
    _a$d);

var _a$c;
var moduleName$c = 'HYUdb';
var HYUDBMSDKQUrlCommon = 'HYUDBMSDKQUrlCommon';
var HYUDBMSDKCallback = 'HYUDBMSDKCallback';
var HYUDBMSDKClose = 'HYUDBMSDKClose';
var HYUDBMSDKCommon = 'HYUDBMSDKCommon';
var HYUDBMSDKVersion = 'HYUDBMSDKVersion';
var paramsScheme$5 = mod.object({}).optional();
var callbackScheme = mod
    .object({
    type: mod.string(),
    data: mod.string()
})
    .optional();
var HYUdb = (_a$c = {},
    _a$c[HYUDBMSDKQUrlCommon] = generateCommonAPI(moduleName$c, HYUDBMSDKQUrlCommon, paramsScheme$5, {
        isUseSdk: true
    }),
    _a$c[HYUDBMSDKCallback] = generateCommonAPI(moduleName$c, HYUDBMSDKCallback, callbackScheme, {
        isUseSdk: true
    }),
    _a$c[HYUDBMSDKClose] = generateCommonAPI(moduleName$c, HYUDBMSDKClose, paramsScheme$5, {
        isUseSdk: true
    }),
    _a$c[HYUDBMSDKCommon] = generateCommonAPI(moduleName$c, HYUDBMSDKCommon, paramsScheme$5, {
        isUseSdk: true
    }),
    _a$c[HYUDBMSDKVersion] = generateCommonAPI(moduleName$c, HYUDBMSDKVersion, paramsScheme$5, {
        isUseSdk: true
    }),
    _a$c);

var _a$b;
var moduleName$b = 'HYUI';
var setSafeAreaColor = 'setSafeAreaColor';
var setWebViewFrame = 'setWebViewFrame';
var setNavigationBarTranslucent = 'setNavigationBarTranslucent';
var setNavConfigs = 'setNavConfigs';
var setSafeAreaColorScheme = functionScheme.extend({
    enabled: mod.boolean(),
    color: mod.string()
});
var setWebViewFrameScheme = functionScheme.extend({
    frame: mod.object({
        x: mod.number(),
        y: mod.number(),
        width: mod.number(),
        height: mod.number()
    })
});
var setNavigationBarTranslucentScheme = mod.object({
    translucent: mod.boolean()
});
var setNavConfigsScheme = mod.object({
    title: mod.string().optional(),
    showNav: mod.boolean().optional(),
    showCloseBtn: mod.boolean().optional(),
    showShareBtn: mod.boolean().optional()
});
var setBackgroundColorScheme = mod.object({
    /** 浅色模式 */
    color: mod.string().optional(),
    /** 深色模式 */
    darkColor: mod.string().optional()
});
var HYUI = (_a$b = {},
    _a$b[setSafeAreaColor] = generateCommonAPI(moduleName$b, setSafeAreaColor, setSafeAreaColorScheme),
    _a$b[setWebViewFrame] = generateCommonAPI(moduleName$b, setWebViewFrame, setWebViewFrameScheme),
    _a$b[setNavigationBarTranslucent] = generateCommonAPI(moduleName$b, setNavigationBarTranslucent, setNavigationBarTranslucentScheme),
    _a$b[setNavConfigs] = generateCommonAPI(moduleName$b, setNavConfigs, setNavConfigsScheme),
    _a$b.setBackgroundColor = generateCommonAPI(moduleName$b, 'setBackgroundColor', setBackgroundColorScheme),
    _a$b);

var _a$a;
var moduleName$a = 'HYWebCalendar';
var insertCalendarNotice = 'insertCalendarNotice';
var removeCalendarNotice = 'removeCalendarNotice';
var queryCalendarNotice = 'queryCalendarNotice';
var needCheckAuthority = 'needCheckAuthority';
var paramsNoticeScheme = functionScheme.extend({
    beginTime: mod.string(),
    title: mod.string(),
    desc: mod.string(),
    duration: mod.string()
});
var paramsScheme$4 = functionScheme.extend({
    title: mod.string()
});
var needCheckAuthorityScheme = mod.object({
    authorityScene: mod.string()
});
var HYWebCalendar = (_a$a = {},
    _a$a[insertCalendarNotice] = generateCommonAPI(moduleName$a, insertCalendarNotice, paramsNoticeScheme, {
        isUseSdk: true
    }),
    _a$a[removeCalendarNotice] = generateCommonAPI(moduleName$a, removeCalendarNotice, paramsScheme$4, {
        isUseSdk: true
    }),
    _a$a[queryCalendarNotice] = generateCommonAPI(moduleName$a, queryCalendarNotice, paramsScheme$4, {
        isUseSdk: true
    }),
    _a$a[needCheckAuthority] = generateCommonAPI(moduleName$a, needCheckAuthority, needCheckAuthorityScheme),
    _a$a);

var _a$9;
var moduleName$9 = 'HYWebGameReserve';
var reserveGame = 'reserveGame';
var cancelReserveGame = 'cancelReserveGame';
var reserveGameScheme = mod.object({
    gameName: mod.string().optional(),
    GameBaseId: mod.string().optional(),
    GameCenterId: mod.string().optional(),
    DownLoadAppId: mod.string(),
    fromId: mod.string(),
    gid: mod.string().optional(),
    ext_fromid: mod.string().optional(),
    cur_fromid: mod.string().optional(),
    anchor_uid: mod.number().optional()
});
var cancelReserveGameScheme = mod.object({
    GameBaseId: mod.string().optional(),
    GameCenterId: mod.string().optional(),
    DownLoadAppId: mod.string()
});
var HYWebGameReserve = (_a$9 = {},
    _a$9[reserveGame] = generateCommonAPI(moduleName$9, reserveGame, reserveGameScheme),
    _a$9[cancelReserveGame] = generateCommonAPI(moduleName$9, cancelReserveGame, cancelReserveGameScheme),
    _a$9);

var _a$8;
var moduleName$8 = 'HYWebPersonal';
var scrollTop = 'scrollTop';
var paramsScheme$3 = mod.object({
    uid: mod.string()
});
var HYWebPersonal = (_a$8 = {},
    _a$8[scrollTop] = generateCommonAPI(moduleName$8, scrollTop, paramsScheme$3),
    _a$8);

var _a$7;
var moduleName$7 = 'HYWebShortcut';
var createShortcut = 'createShortcut';
var goAppDetailSettingsPage = 'goAppDetailSettingsPage';
var isShortCutExist = 'isShortCutExist';
var hasCreateShortcutPermission = 'hasCreateShortcutPermission';
var createShortcutScheme = mod.object({
    key_title: mod.string(),
    key_url: mod.string(),
    key_icon_url: mod.string(),
    key_id: mod.string()
});
var goAppDetailSettingsPageScheme = mod.object({}).optional();
var paramsScheme$2 = mod
    .object({
    key_title: mod.string()
})
    .optional();
var HYWebShortcut = (_a$7 = {},
    _a$7[createShortcut] = generateCommonAPI(moduleName$7, createShortcut, createShortcutScheme),
    _a$7[goAppDetailSettingsPage] = generateCommonAPI(moduleName$7, goAppDetailSettingsPage, goAppDetailSettingsPageScheme),
    _a$7[isShortCutExist] = generateCommonAPI(moduleName$7, isShortCutExist, paramsScheme$2),
    _a$7[hasCreateShortcutPermission] = generateCommonAPI(moduleName$7, hasCreateShortcutPermission),
    _a$7);

var _a$6;
var moduleName$6 = 'HYWebView';
var closeWebView = 'closeWebView';
var getContext = 'getContext';
var setContext = 'setContext';
var paramsScheme$1 = mod.any().optional();
var HYWebView = (_a$6 = {},
    _a$6[closeWebView] = generateCommonAPI(moduleName$6, closeWebView, paramsScheme$1),
    _a$6[getContext] = generateCommonAPI(moduleName$6, getContext, paramsScheme$1),
    _a$6[setContext] = generateCommonAPI(moduleName$6, setContext, paramsScheme$1),
    _a$6);

var _a$5;
var moduleName$5 = 'HYWebViewLifeCycle';
var getAppear = 'getAppear';
var on$1 = 'on';
var off$1 = 'off';
/**
 * WebView出现
 */
var onAppear = 'ON_WEBVIEW_APPEAR';
/**
 * WebView消失
 */
var onDisappear = 'ON_WEBVIEW_DISAPPEAR';
var HYWebViewLifeCycle = (_a$5 = {},
    _a$5[getAppear] = generateCommonAPI(moduleName$5, getAppear),
    _a$5[on$1] = generateCommonEvent(moduleName$5, on$1),
    _a$5[off$1] = generateCommonEvent(moduleName$5, off$1),
    _a$5);

var _a$4;
var moduleName$4 = 'HYWup';
var sendWupRequest = 'sendWupRequest';
var sendRequest = 'sendRequest';
var registerGroup = 'registerGroup';
var unRegisterGroup = 'unRegisterGroup';
var pingsignal = 'pingsignal';
var on = 'on';
var off = 'off';
var wupSuccessCallback = {};
var wupFailureCallback = {};
var count = 0;
var sendRequestScheme = mod.object({
    servant: mod.string(),
    funcname: mod.string(),
    unitPacket: mod.any(),
    strategy: mod.any()
});
var sendWupRequestScheme = mod.object({
    unitPacket: mod.any(),
    channelType: mod.number().optional(),
    userInfo: mod.any().optional()
});
var registerGroupScheme = mod
    .object({
    group: mod.string().optional(),
    groupIds: mod.array(mod.string()).optional(),
    channelType: mod.number().optional()
})
    .optional();
var unRegisterGroupScheme = mod
    .object({
    groupIds: mod.array(mod.string()).optional(),
    channelType: mod.number().optional()
})
    .optional();
var onFun = generateCommonEvent(moduleName$4, on);
var HYWup = (_a$4 = {},
    _a$4[sendRequest] = generateCommonAPI('HYDataCenter', sendRequest, sendRequestScheme, {
        specialHandle: function (params) {
            // 旧版
            var NativeDataCenter = nativeModules === null || nativeModules === void 0 ? void 0 : nativeModules.HYDataCenter;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var _a = (params || {}), stragegy = _a.stragegy, rest = __rest(_a, ["stragegy"]);
            if ((params === null || params === void 0 ? void 0 : params.unitPacket) && (params === null || params === void 0 ? void 0 : params.unitPacket) instanceof ArrayBuffer) {
                rest.unitPacket = Utils.arrayBufferToBase64(params.unitPacket);
            }
            var wupSend = NativeDataCenter.sendWupRequest || NativeDataCenter.sendRequest;
            return wupSend(rest, stragegy)
                .then(function (resp) { return (resp ? Utils.base64ToArrayBuffer(resp) : resp); })
                .catch(function (err) {
                return Promise.reject(__assign(__assign({}, err), { message: err.message ? Utils.base64ToArrayBuffer(err.message) : '' }));
            });
        }
    }),
    _a$4[sendWupRequest] = generateCommonAPI(moduleName$4, sendWupRequest, sendWupRequestScheme, {
        specialHandle: function (params) {
            if ((params === null || params === void 0 ? void 0 : params.unitPacket) && (params === null || params === void 0 ? void 0 : params.unitPacket) instanceof ArrayBuffer) {
                params.unitPacket = Utils.arrayBufferToBase64(params.unitPacket);
            }
            var sentWup = function (success, fail) {
                var id = count++;
                wupSuccessCallback[id] = success;
                wupFailureCallback[id] = fail;
                nativeModules[moduleName$4][sendWupRequest](__assign(__assign({}, params), { userInfo: { __wupBridgeRequestId: id } }));
            };
            // if (params?.success || params?.complete) {
            //   const success = params?.success || params?.complete || () => void
            //   const fail = params?.fail || () => void
            //   sentWup(success, fail)
            // }
            return new Promise(function (resolve, reject) {
                sentWup(resolve, reject);
                // const id = count++
                // wupSuccessCallback[id] = resolve
                // wupFailureCallback[id] = reject
                // NativeModules[moduleName][sendWupRequest]({
                //   ...params,
                //   userInfo: { __wupBridgeRequestId: id }
                // })
            });
        }
    }),
    _a$4[registerGroup] = generateCommonAPI(moduleName$4, registerGroup, registerGroupScheme),
    _a$4[unRegisterGroup] = generateCommonAPI(moduleName$4, unRegisterGroup, unRegisterGroupScheme),
    _a$4[pingsignal] = generateCommonAPI(moduleName$4, pingsignal, mod.any(), {
        specialHandle: function () {
            var biz_js_start = +new Date() * 1000;
            var params = { biz_js_start: "" + biz_js_start };
            return nativeModules[moduleName$4][pingsignal](params)
                .then(function (res) {
                var biz_js_end = +new Date() * 1000;
                res.biz_js_end = biz_js_end;
                return res;
            })
                .catch(function (e) {
                console.log("pingsignal catch error", e);
            });
        }
    }),
    _a$4[on] = function (eventId, callback, params) {
        var isExistWup = nativeModules[moduleName$4] && nativeModules[moduleName$4][on];
        var realCallback = function (res) {
            if (res && res.data) {
                res.data = Utils.base64ToArrayBuffer(res.data);
            }
            callback(res);
        };
        onFun(eventId, isExistWup ? realCallback : callback, params);
    },
    _a$4[off] = generateCommonEvent(moduleName$4, off),
    _a$4);
var transmit = 'transmit';
var transmitWup = 'transmitWup';
var wupReceivedUri = 10000;
var onWupReceivedCallback = function (resp) {
    if (resp && resp.subUri == wupReceivedUri) {
        var userInfo = resp.userInfo;
        var requestId = userInfo.__wupBridgeRequestId;
        if (resp.status === 'ok') {
            var success = wupSuccessCallback[requestId];
            if (success) {
                success(resp);
            }
        }
        else {
            var failure = wupFailureCallback[requestId];
            if (failure) {
                failure(resp);
            }
        }
        wupSuccessCallback[requestId] = null;
        wupFailureCallback[requestId] = null;
    }
};
HYWup.on(transmitWup, onWupReceivedCallback, { subUri: wupReceivedUri });

var _a$3;
var moduleName$3 = 'HYYouth';
var exitYouth = 'exitYouth';
var setYouthPassword = 'setYouthPassword';
var verifyYouthPassword = 'verifyYouthPassword';
var verifyYouthSuccess = 'verifyYouthSuccess';
var paramsScheme = functionScheme.extend({
    password: mod.string().optional()
});
var verifyYouthSuccessScheme = functionScheme.extend({
    type: mod.string().optional()
});
var HYYouth = (_a$3 = {},
    _a$3[exitYouth] = generateCommonAPI(moduleName$3, exitYouth, paramsScheme, {
        isUseSdk: true
    }),
    _a$3[setYouthPassword] = generateCommonAPI(moduleName$3, setYouthPassword, paramsScheme, {
        isUseSdk: true
    }),
    _a$3[verifyYouthPassword] = generateCommonAPI(moduleName$3, verifyYouthPassword, paramsScheme, { isUseSdk: true }),
    _a$3[verifyYouthSuccess] = generateCommonAPI(moduleName$3, verifyYouthSuccess, verifyYouthSuccessScheme, { isUseSdk: true }),
    _a$3);

var _a$2;
var moduleName$2 = 'HYBusinessWidget';
var shouldRefreshWidget = 'shouldRefreshWidget';
var installWidget = 'installWidget';
var shouldRefreshWidgetScheme = mod.object({
    kind: mod.string().optional(),
    reason: mod.string().optional() //刷新理由
});
var installWidgetScheme = mod.object({
    kind: mod.string().optional() // 小组件类型, 福利助手小组件传： HYWWelfareWidget
});
var HYBusinessWidget = (_a$2 = {},
    /**
     * 是否刷新小组件 (双端支持，版本：12.4.0 以上)
     */
    _a$2[shouldRefreshWidget] = generateCommonAPI(moduleName$2, shouldRefreshWidget, shouldRefreshWidgetScheme),
    /**
     * 安装小组件 (仅安卓支持)
     */
    _a$2[installWidget] = generateCommonAPI(moduleName$2, installWidget, installWidgetScheme),
    _a$2);

var _a$1;
var moduleName$1 = 'HYWebAccompanyMsgFloatBall';
var enhanceApiTypes$1 = enhanceApiTypesWithModule(moduleName$1);
/** 调用悬浮球开关 */
var changeMsgFloatBallStatus = {
    name: 'changeMsgFloatBallStatus',
    input: mod.object({
        /** 1-开启, 0-关闭 */
        isOpen: mod.union([mod.literal('1'), mod.literal('0')]).optional()
    }),
    /** true-设置成功，false-设置失败 */
    output: Promise.resolve(true)
};
/** 查询用户悬浮球开关状态 */
var checkMsgFloatBallStatus = {
    name: 'checkMsgFloatBallStatus',
    input: functionScheme.optional(),
    output: undefined
};
/**
 * 查询用户悬浮球权限-仅 adr 支持
 */
var hasMsgFloatBallPermission = {
    name: 'hasMsgFloatBallPermission',
    input: functionScheme.optional(),
    output: undefined
};
/**
 * 跳转系统设置开启悬浮球权限-仅 adr 支持
 */
var openMsgFloatBallPermission = {
    name: 'openMsgFloatBallPermission',
    input: functionScheme.optional(),
    output: Promise.resolve(undefined)
};
var HYWebAccompanyMsgFloatBall = (_a$1 = {},
    _a$1[changeMsgFloatBallStatus.name] = enhanceApiTypes$1(changeMsgFloatBallStatus),
    _a$1[checkMsgFloatBallStatus.name] = enhanceApiTypes$1(checkMsgFloatBallStatus),
    _a$1[hasMsgFloatBallPermission.name] = enhanceApiTypes$1(hasMsgFloatBallPermission),
    _a$1[openMsgFloatBallPermission.name] = enhanceApiTypes$1(openMsgFloatBallPermission),
    _a$1);

var _a;
var moduleName = 'HYPCAnchor';
var enhanceApiTypes = enhanceApiTypesWithModule(moduleName);
/**
 * 获取主播当前是否有使用摄像头的接口
 */
var checkAnchorUsingCamera = {
    name: 'checkAnchorUsingCamera',
    input: functionScheme.optional(),
    output: undefined
};
var HYPCAnchor = (_a = {},
    _a[checkAnchorUsingCamera.name] = enhanceApiTypes(checkAnchorUsingCamera, {
        isUseSdk: true
    }),
    _a);

HYDevice.on; HYDevice.off; var HYDeviceRest = __rest(HYDevice, ["on", "off"]);
HYLivingRoomActivity.on; HYLivingRoomActivity.off; var HYLivingRoomActivityRest = __rest(HYLivingRoomActivity
// 需要注入到HUYASdk兼容旧版
, ["on", "off"]);
var HUYASdk = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, HUYASdk$1), HYGift), HYLive), HYLivingRoomActivityRest), HYRouter), HYUserInfo), HYLogin), HYDeviceRest), HYRouter), HYToast), HYCache), HYDiskConfig), HYTipOff), HYSubscribe), HYFeedBack), HYDownload), HYShare), OldEventCenter), HYReport), { kiwiVersion: "1.10.11", HUYAConfig: HUYAConfig, PortraitActivity: HYPortraitActivity, LandscapeActivity: LandscapeActivity, PlatformCompat: PlatformCompat });

// import { onMessageForCrossDomain } from './commons/crossDomain'
useSentry();
initPlatformCheck();

exports.Browser = Browser;
exports.CrossDomain = index;
exports.HUYASdk = HUYASdk;
exports.HYAAID = HYAAID;
exports.HYAd = HYAd;
exports.HYAdReport = HYAdReport;
exports.HYAudioRecord = HYAudioRecord;
exports.HYAuth = HYAuth;
exports.HYAuthorization = HYAuthorization;
exports.HYBusinessWidget = HYBusinessWidget;
exports.HYCache = HYCache;
exports.HYCommodity = HYCommodity;
exports.HYDataCenter = hyDataCenter;
exports.HYDevice = HYDevice;
exports.HYDiskConfig = HYDiskConfig;
exports.HYDownload = HYDownload;
exports.HYDynamicConfig = HYDynamicConfig;
exports.HYEventCenter = OldEventCenter;
exports.HYFeedBack = HYFeedBack;
exports.HYFreeFlow = HYFreeFlow;
exports.HYGift = HYGift;
exports.HYInteraction = HYInteraction;
exports.HYLandscapeActivity = HYLandscapeActivity;
exports.HYLive = HYLive;
exports.HYLiveFilmVip = HYLiveFilmVip;
exports.HYLiveTreasureBox = HYLiveTreasureBox;
exports.HYLivingRoomActivity = HYLivingRoomActivity;
exports.HYLog = HYLog;
exports.HYLogin = HYLogin;
exports.HYNativeEventCenter = HYNativeEventCenter;
exports.HYNestedScroll = HYNestedScroll;
exports.HYPCAnchor = HYPCAnchor;
exports.HYPCLive = HYPCLive;
exports.HYPanel = HYPanel;
exports.HYPay = HYPay;
exports.HYPlayer = HYPlayer;
exports.HYPortraitActivity = HYPortraitActivity;
exports.HYReport = HYReport;
exports.HYRouter = HYRouter;
exports.HYSaveInAlbum = HYSaveInAlbum;
exports.HYSettingBack = HYSettingBack;
exports.HYSettingsData = HYSettingsData;
exports.HYShare = HYShare;
exports.HYStatistic = HYStatistic;
exports.HYSubscribe = HYSubscribe;
exports.HYSuperFans = HYSuperFans;
exports.HYTeamMedal = HYTeamMedal;
exports.HYThirdCall = HYThirdCall;
exports.HYTipOff = HYTipOff;
exports.HYToast = HYToast;
exports.HYUI = HYUI;
exports.HYUdb = HYUdb;
exports.HYUserInfo = HYUserInfo;
exports.HYWebAccompanyMsgFloatBall = HYWebAccompanyMsgFloatBall;
exports.HYWebCalendar = HYWebCalendar;
exports.HYWebGameReserve = HYWebGameReserve;
exports.HYWebPersonal = HYWebPersonal;
exports.HYWebShortcut = HYWebShortcut;
exports.HYWebView = HYWebView;
exports.HYWebViewLifeCycle = HYWebViewLifeCycle;
exports.HYWup = HYWup;
exports.HYYouth = HYYouth;
exports.NativeModules = nativeModules;
exports.PlatformCompat = PlatformCompat;
exports.TAP_BACK = TAP_BACK;
exports.Utils = Utils;
exports.activityWindowSizeChanged = activityWindowSizeChanged;
exports.audioRecordEnd = audioRecordEnd;
exports.didBecomeActive = didBecomeActive;
exports.generateCommonAPI = generateCommonAPI;
exports.installApkEventChanged = installApkEventChanged;
exports.kKWJSSdkEventIdApp = kKWJSSdkEventIdApp;
exports.kickOff = kickOff;
exports.loginFailed = loginFailed;
exports.loginSuccess = loginSuccess;
exports.networkChanged = networkChanged;
exports.onAppear = onAppear;
exports.onDisappear = onDisappear;
exports.screenRecordChanged = screenRecordChanged;
exports.transmit = transmit;
exports.transmitWup = transmitWup;
exports.willResignActive = willResignActive;
